/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var xcommon_common_pb = require('../xcommon/common_pb.js');
goog.object.extend(proto, xcommon_common_pb);
var xcommon_enum_pb = require('../xcommon/enum_pb.js');
goog.object.extend(proto, xcommon_enum_pb);
goog.exportSymbol('proto.xcommon.AccountAlternativeContactInfo', null, global);
goog.exportSymbol('proto.xcommon.AccountBaseInfo', null, global);
goog.exportSymbol('proto.xcommon.AccountBillHistory', null, global);
goog.exportSymbol('proto.xcommon.AccountChangeLog', null, global);
goog.exportSymbol('proto.xcommon.AccountLoanHistory', null, global);
goog.exportSymbol('proto.xcommon.AccountLoanHistoryBackend', null, global);
goog.exportSymbol('proto.xcommon.AccountProfileInfo', null, global);
goog.exportSymbol('proto.xcommon.AccountSocialInfo', null, global);
goog.exportSymbol('proto.xcommon.AccountWalletInfo', null, global);
goog.exportSymbol('proto.xcommon.ApplyReducePenaltyFieldDetail', null, global);
goog.exportSymbol('proto.xcommon.AutoCallCoreParams', null, global);
goog.exportSymbol('proto.xcommon.AutoCallCoreResult', null, global);
goog.exportSymbol('proto.xcommon.AutoCallResultInfo', null, global);
goog.exportSymbol('proto.xcommon.AutoCallSupplier', null, global);
goog.exportSymbol('proto.xcommon.BusinessTypeEnum', null, global);
goog.exportSymbol('proto.xcommon.ButtonShow', null, global);
goog.exportSymbol('proto.xcommon.CalcMarketPaymentFeeParam', null, global);
goog.exportSymbol('proto.xcommon.CalcMarketPaymentFeeResult', null, global);
goog.exportSymbol('proto.xcommon.CalcMarketPaymentFeeVersion', null, global);
goog.exportSymbol('proto.xcommon.CallLog', null, global);
goog.exportSymbol('proto.xcommon.ContactStatusEnum', null, global);
goog.exportSymbol('proto.xcommon.CorporateCustomer', null, global);
goog.exportSymbol('proto.xcommon.CouponInfo', null, global);
goog.exportSymbol('proto.xcommon.CreditCardFeeReduceFlag', null, global);
goog.exportSymbol('proto.xcommon.CreditEnhanceInfo', null, global);
goog.exportSymbol('proto.xcommon.CustomerDetailItem', null, global);
goog.exportSymbol('proto.xcommon.CustomerDetailSection', null, global);
goog.exportSymbol('proto.xcommon.CustomerDetailTab', null, global);
goog.exportSymbol('proto.xcommon.CustomerInfo', null, global);
goog.exportSymbol('proto.xcommon.CustomerInfoResourceIDs', null, global);
goog.exportSymbol('proto.xcommon.EAccountNumberInfo', null, global);
goog.exportSymbol('proto.xcommon.File', null, global);
goog.exportSymbol('proto.xcommon.LoadAmount', null, global);
goog.exportSymbol('proto.xcommon.MPSystemType', null, global);
goog.exportSymbol('proto.xcommon.MarketPaymentChannel', null, global);
goog.exportSymbol('proto.xcommon.MarketPaymentItem', null, global);
goog.exportSymbol('proto.xcommon.MarketPaymentItemList', null, global);
goog.exportSymbol('proto.xcommon.MarketPaymentStatus', null, global);
goog.exportSymbol('proto.xcommon.MarketPaymentType', null, global);
goog.exportSymbol('proto.xcommon.OpenPayHandingFeeMethod', null, global);
goog.exportSymbol('proto.xcommon.OrderCustomization', null, global);
goog.exportSymbol('proto.xcommon.OrderFromPlatform', null, global);
goog.exportSymbol('proto.xcommon.OrderInfo', null, global);
goog.exportSymbol('proto.xcommon.OrderInspectReasonItem', null, global);
goog.exportSymbol('proto.xcommon.OrderRepayDetail', null, global);
goog.exportSymbol('proto.xcommon.OrderRepaymentDetail', null, global);
goog.exportSymbol('proto.xcommon.OrderRiskInfo', null, global);
goog.exportSymbol('proto.xcommon.OrderTagExtInfo', null, global);
goog.exportSymbol('proto.xcommon.OrderTagInfo', null, global);
goog.exportSymbol('proto.xcommon.OrderUrgeInfoDetail', null, global);
goog.exportSymbol('proto.xcommon.ReducePenaltyBillDetail', null, global);
goog.exportSymbol('proto.xcommon.ReducePenaltyFieldDetail', null, global);
goog.exportSymbol('proto.xcommon.ReduceRecordListItem', null, global);
goog.exportSymbol('proto.xcommon.ReduceRecordNew', null, global);
goog.exportSymbol('proto.xcommon.ReductionListParam', null, global);
goog.exportSymbol('proto.xcommon.RepayPlanInfo', null, global);
goog.exportSymbol('proto.xcommon.RepayPlanStageInfo', null, global);
goog.exportSymbol('proto.xcommon.RepayTypeEnum', null, global);
goog.exportSymbol('proto.xcommon.RepaymentDetail', null, global);
goog.exportSymbol('proto.xcommon.RollStatus', null, global);
goog.exportSymbol('proto.xcommon.RollTCDetail', null, global);
goog.exportSymbol('proto.xcommon.RollTCOption', null, global);
goog.exportSymbol('proto.xcommon.RollTCRepayCode', null, global);
goog.exportSymbol('proto.xcommon.SmsLog', null, global);
goog.exportSymbol('proto.xcommon.SmsLogData', null, global);
goog.exportSymbol('proto.xcommon.SmsTaskParam', null, global);
goog.exportSymbol('proto.xcommon.SmsTaskParamList', null, global);
goog.exportSymbol('proto.xcommon.SmsTaskParamOption', null, global);
goog.exportSymbol('proto.xcommon.SmsTaskParamValue', null, global);
goog.exportSymbol('proto.xcommon.SuggestInfo', null, global);
goog.exportSymbol('proto.xcommon.URLLinkShowType', null, global);
goog.exportSymbol('proto.xcommon.UrgeLoanInfo', null, global);
goog.exportSymbol('proto.xcommon.UrgeLoanStageInfo', null, global);
goog.exportSymbol('proto.xcommon.UrgeRepayInfo', null, global);
goog.exportSymbol('proto.xcommon.UrgeRollInfo', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.OrderCustomization = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.OrderCustomization, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.OrderCustomization.displayName = 'proto.xcommon.OrderCustomization';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.OrderInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.OrderInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.OrderInfo.displayName = 'proto.xcommon.OrderInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.OrderRiskInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.OrderRiskInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.OrderRiskInfo.displayName = 'proto.xcommon.OrderRiskInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.OrderTagInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.OrderTagInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.OrderTagInfo.displayName = 'proto.xcommon.OrderTagInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.OrderTagExtInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.OrderTagExtInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.OrderTagExtInfo.displayName = 'proto.xcommon.OrderTagExtInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.AccountProfileInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.AccountProfileInfo.repeatedFields_, null);
};
goog.inherits(proto.xcommon.AccountProfileInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.AccountProfileInfo.displayName = 'proto.xcommon.AccountProfileInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.AccountWalletInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.AccountWalletInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.AccountWalletInfo.displayName = 'proto.xcommon.AccountWalletInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.AccountSocialInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.AccountSocialInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.AccountSocialInfo.displayName = 'proto.xcommon.AccountSocialInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.RepayPlanInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.RepayPlanInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.RepayPlanInfo.displayName = 'proto.xcommon.RepayPlanInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.AccountBaseInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.AccountBaseInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.AccountBaseInfo.displayName = 'proto.xcommon.AccountBaseInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.EAccountNumberInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.EAccountNumberInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.EAccountNumberInfo.displayName = 'proto.xcommon.EAccountNumberInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.CouponInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.CouponInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.CouponInfo.displayName = 'proto.xcommon.CouponInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.RepayPlanStageInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.RepayPlanStageInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.RepayPlanStageInfo.displayName = 'proto.xcommon.RepayPlanStageInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.AccountAlternativeContactInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.AccountAlternativeContactInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.AccountAlternativeContactInfo.displayName = 'proto.xcommon.AccountAlternativeContactInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.AutoCallResultInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.AutoCallResultInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.AutoCallResultInfo.displayName = 'proto.xcommon.AutoCallResultInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ReductionListParam = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ReductionListParam, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ReductionListParam.displayName = 'proto.xcommon.ReductionListParam';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ReduceRecordNew = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ReduceRecordNew, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ReduceRecordNew.displayName = 'proto.xcommon.ReduceRecordNew';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ReduceRecordListItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ReduceRecordListItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ReduceRecordListItem.displayName = 'proto.xcommon.ReduceRecordListItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.CustomerDetailItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.CustomerDetailItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.CustomerDetailItem.displayName = 'proto.xcommon.CustomerDetailItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.CustomerDetailSection = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.CustomerDetailSection.repeatedFields_, null);
};
goog.inherits(proto.xcommon.CustomerDetailSection, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.CustomerDetailSection.displayName = 'proto.xcommon.CustomerDetailSection';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.CustomerDetailTab = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.CustomerDetailTab.repeatedFields_, null);
};
goog.inherits(proto.xcommon.CustomerDetailTab, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.CustomerDetailTab.displayName = 'proto.xcommon.CustomerDetailTab';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.AccountLoanHistory = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.AccountLoanHistory, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.AccountLoanHistory.displayName = 'proto.xcommon.AccountLoanHistory';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.AccountLoanHistoryBackend = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.AccountLoanHistoryBackend, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.AccountLoanHistoryBackend.displayName = 'proto.xcommon.AccountLoanHistoryBackend';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.AccountBillHistory = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.AccountBillHistory, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.AccountBillHistory.displayName = 'proto.xcommon.AccountBillHistory';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.AccountChangeLog = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.AccountChangeLog, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.AccountChangeLog.displayName = 'proto.xcommon.AccountChangeLog';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.CalcMarketPaymentFeeParam = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.CalcMarketPaymentFeeParam, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.CalcMarketPaymentFeeParam.displayName = 'proto.xcommon.CalcMarketPaymentFeeParam';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.CalcMarketPaymentFeeResult = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.CalcMarketPaymentFeeResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.CalcMarketPaymentFeeResult.displayName = 'proto.xcommon.CalcMarketPaymentFeeResult';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.MarketPaymentItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.MarketPaymentItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.MarketPaymentItem.displayName = 'proto.xcommon.MarketPaymentItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.MarketPaymentItemList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.MarketPaymentItemList.repeatedFields_, null);
};
goog.inherits(proto.xcommon.MarketPaymentItemList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.MarketPaymentItemList.displayName = 'proto.xcommon.MarketPaymentItemList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.UrgeRepayInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.UrgeRepayInfo.repeatedFields_, null);
};
goog.inherits(proto.xcommon.UrgeRepayInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.UrgeRepayInfo.displayName = 'proto.xcommon.UrgeRepayInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.CreditEnhanceInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.CreditEnhanceInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.CreditEnhanceInfo.displayName = 'proto.xcommon.CreditEnhanceInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.RollTCRepayCode = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.RollTCRepayCode, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.RollTCRepayCode.displayName = 'proto.xcommon.RollTCRepayCode';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.RollTCDetail = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.RollTCDetail.repeatedFields_, null);
};
goog.inherits(proto.xcommon.RollTCDetail, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.RollTCDetail.displayName = 'proto.xcommon.RollTCDetail';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.RollTCOption = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.RollTCOption, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.RollTCOption.displayName = 'proto.xcommon.RollTCOption';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.UrgeRollInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.UrgeRollInfo.repeatedFields_, null);
};
goog.inherits(proto.xcommon.UrgeRollInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.UrgeRollInfo.displayName = 'proto.xcommon.UrgeRollInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.UrgeLoanStageInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.UrgeLoanStageInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.UrgeLoanStageInfo.displayName = 'proto.xcommon.UrgeLoanStageInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.UrgeLoanInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.UrgeLoanInfo.repeatedFields_, null);
};
goog.inherits(proto.xcommon.UrgeLoanInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.UrgeLoanInfo.displayName = 'proto.xcommon.UrgeLoanInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ReducePenaltyBillDetail = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ReducePenaltyBillDetail, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ReducePenaltyBillDetail.displayName = 'proto.xcommon.ReducePenaltyBillDetail';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ReducePenaltyFieldDetail = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ReducePenaltyFieldDetail, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ReducePenaltyFieldDetail.displayName = 'proto.xcommon.ReducePenaltyFieldDetail';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.ApplyReducePenaltyFieldDetail = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.ApplyReducePenaltyFieldDetail, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.ApplyReducePenaltyFieldDetail.displayName = 'proto.xcommon.ApplyReducePenaltyFieldDetail';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.OrderRepaymentDetail = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.OrderRepaymentDetail.repeatedFields_, null);
};
goog.inherits(proto.xcommon.OrderRepaymentDetail, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.OrderRepaymentDetail.displayName = 'proto.xcommon.OrderRepaymentDetail';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.LoadAmount = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.LoadAmount, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.LoadAmount.displayName = 'proto.xcommon.LoadAmount';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.RepaymentDetail = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.RepaymentDetail, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.RepaymentDetail.displayName = 'proto.xcommon.RepaymentDetail';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.AutoCallCoreParams = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.AutoCallCoreParams, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.AutoCallCoreParams.displayName = 'proto.xcommon.AutoCallCoreParams';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.AutoCallCoreResult = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.AutoCallCoreResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.AutoCallCoreResult.displayName = 'proto.xcommon.AutoCallCoreResult';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.OrderUrgeInfoDetail = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.OrderUrgeInfoDetail, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.OrderUrgeInfoDetail.displayName = 'proto.xcommon.OrderUrgeInfoDetail';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SmsTaskParamList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.SmsTaskParamList.repeatedFields_, null);
};
goog.inherits(proto.xcommon.SmsTaskParamList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SmsTaskParamList.displayName = 'proto.xcommon.SmsTaskParamList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SmsTaskParam = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.SmsTaskParam.repeatedFields_, null);
};
goog.inherits(proto.xcommon.SmsTaskParam, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SmsTaskParam.displayName = 'proto.xcommon.SmsTaskParam';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SmsTaskParamOption = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SmsTaskParamOption, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SmsTaskParamOption.displayName = 'proto.xcommon.SmsTaskParamOption';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SmsTaskParamValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SmsTaskParamValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SmsTaskParamValue.displayName = 'proto.xcommon.SmsTaskParamValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.CustomerInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.CustomerInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.CustomerInfo.displayName = 'proto.xcommon.CustomerInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.CustomerInfoResourceIDs = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.CustomerInfoResourceIDs, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.CustomerInfoResourceIDs.displayName = 'proto.xcommon.CustomerInfoResourceIDs';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.OrderInspectReasonItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.OrderInspectReasonItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.OrderInspectReasonItem.displayName = 'proto.xcommon.OrderInspectReasonItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.CorporateCustomer = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.CorporateCustomer, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.CorporateCustomer.displayName = 'proto.xcommon.CorporateCustomer';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.File = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.File, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.File.displayName = 'proto.xcommon.File';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.OrderRepayDetail = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.OrderRepayDetail, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.OrderRepayDetail.displayName = 'proto.xcommon.OrderRepayDetail';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SuggestInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.SuggestInfo.repeatedFields_, null);
};
goog.inherits(proto.xcommon.SuggestInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SuggestInfo.displayName = 'proto.xcommon.SuggestInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.CallLog = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.CallLog, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.CallLog.displayName = 'proto.xcommon.CallLog';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SmsLog = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.xcommon.SmsLog.repeatedFields_, null);
};
goog.inherits(proto.xcommon.SmsLog, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SmsLog.displayName = 'proto.xcommon.SmsLog';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.xcommon.SmsLogData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.xcommon.SmsLogData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.xcommon.SmsLogData.displayName = 'proto.xcommon.SmsLogData';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.OrderCustomization.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.OrderCustomization.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.OrderCustomization} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.OrderCustomization.toObject = function(includeInstance, msg) {
  var f, obj = {
    reduceamountbutton: jspb.Message.getFieldWithDefault(msg, 1, 0),
    reduceinterestbutton: jspb.Message.getFieldWithDefault(msg, 2, 0),
    appname: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.OrderCustomization}
 */
proto.xcommon.OrderCustomization.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.OrderCustomization;
  return proto.xcommon.OrderCustomization.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.OrderCustomization} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.OrderCustomization}
 */
proto.xcommon.OrderCustomization.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.xcommon.ButtonShow} */ (reader.readEnum());
      msg.setReduceamountbutton(value);
      break;
    case 2:
      var value = /** @type {!proto.xcommon.ButtonShow} */ (reader.readEnum());
      msg.setReduceinterestbutton(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.OrderCustomization.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.OrderCustomization.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.OrderCustomization} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.OrderCustomization.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReduceamountbutton();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getReduceinterestbutton();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional ButtonShow ReduceAmountButton = 1;
 * @return {!proto.xcommon.ButtonShow}
 */
proto.xcommon.OrderCustomization.prototype.getReduceamountbutton = function() {
  return /** @type {!proto.xcommon.ButtonShow} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {!proto.xcommon.ButtonShow} value */
proto.xcommon.OrderCustomization.prototype.setReduceamountbutton = function(value) {
  jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional ButtonShow ReduceInterestButton = 2;
 * @return {!proto.xcommon.ButtonShow}
 */
proto.xcommon.OrderCustomization.prototype.getReduceinterestbutton = function() {
  return /** @type {!proto.xcommon.ButtonShow} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {!proto.xcommon.ButtonShow} value */
proto.xcommon.OrderCustomization.prototype.setReduceinterestbutton = function(value) {
  jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string AppName = 3;
 * @return {string}
 */
proto.xcommon.OrderCustomization.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.OrderCustomization.prototype.setAppname = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.OrderInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.OrderInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.OrderInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.OrderInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    useraccountid: jspb.Message.getFieldWithDefault(msg, 2, "0"),
    amount: jspb.Message.getFieldWithDefault(msg, 6, 0),
    loan: jspb.Message.getFieldWithDefault(msg, 9, 0),
    checkstatus: jspb.Message.getFieldWithDefault(msg, 13, 0),
    istemporary: jspb.Message.getFieldWithDefault(msg, 14, 0),
    isoverdue: jspb.Message.getFieldWithDefault(msg, 15, 0),
    isdeaddebt: jspb.Message.getFieldWithDefault(msg, 16, 0),
    isreloan: jspb.Message.getFieldWithDefault(msg, 17, 0),
    finishtime: jspb.Message.getFieldWithDefault(msg, 23, 0),
    rolltimes: jspb.Message.getFieldWithDefault(msg, 35, 0),
    preorder: jspb.Message.getFieldWithDefault(msg, 36, "0"),
    stagenum: jspb.Message.getFieldWithDefault(msg, 46, 0),
    stageindex: jspb.Message.getFieldWithDefault(msg, 49, 0),
    checkstatusshow: jspb.Message.getFieldWithDefault(msg, 50, ""),
    businesstype: jspb.Message.getFieldWithDefault(msg, 51, 0),
    invalidtime: jspb.Message.getFieldWithDefault(msg, 52, 0),
    ccfreduceflag: jspb.Message.getFieldWithDefault(msg, 53, 0),
    fromplatform: jspb.Message.getFieldWithDefault(msg, 54, 0),
    customization: (f = msg.getCustomization()) && proto.xcommon.OrderCustomization.toObject(includeInstance, f),
    appname: jspb.Message.getFieldWithDefault(msg, 56, ""),
    ordertagsMap: (f = msg.getOrdertagsMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.OrderInfo}
 */
proto.xcommon.OrderInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.OrderInfo;
  return proto.xcommon.OrderInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.OrderInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.OrderInfo}
 */
proto.xcommon.OrderInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setUseraccountid(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmount(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLoan(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCheckstatus(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIstemporary(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIsoverdue(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIsdeaddebt(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIsreloan(value);
      break;
    case 23:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setFinishtime(value);
      break;
    case 35:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRolltimes(value);
      break;
    case 36:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setPreorder(value);
      break;
    case 46:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStagenum(value);
      break;
    case 49:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStageindex(value);
      break;
    case 50:
      var value = /** @type {string} */ (reader.readString());
      msg.setCheckstatusshow(value);
      break;
    case 51:
      var value = /** @type {!proto.xcommon.BusinessTypeEnum} */ (reader.readEnum());
      msg.setBusinesstype(value);
      break;
    case 52:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setInvalidtime(value);
      break;
    case 53:
      var value = /** @type {!proto.xcommon.CreditCardFeeReduceFlag} */ (reader.readEnum());
      msg.setCcfreduceflag(value);
      break;
    case 54:
      var value = /** @type {!proto.xcommon.OrderFromPlatform} */ (reader.readEnum());
      msg.setFromplatform(value);
      break;
    case 55:
      var value = new proto.xcommon.OrderCustomization;
      reader.readMessage(value,proto.xcommon.OrderCustomization.deserializeBinaryFromReader);
      msg.setCustomization(value);
      break;
    case 56:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    case 57:
      var value = msg.getOrdertagsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt32, jspb.BinaryReader.prototype.readString, null, 0);
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.OrderInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.OrderInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.OrderInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.OrderInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      1,
      f
    );
  }
  f = message.getUseraccountid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      2,
      f
    );
  }
  f = message.getAmount();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getLoan();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getCheckstatus();
  if (f !== 0) {
    writer.writeInt32(
      13,
      f
    );
  }
  f = message.getIstemporary();
  if (f !== 0) {
    writer.writeInt32(
      14,
      f
    );
  }
  f = message.getIsoverdue();
  if (f !== 0) {
    writer.writeInt32(
      15,
      f
    );
  }
  f = message.getIsdeaddebt();
  if (f !== 0) {
    writer.writeInt32(
      16,
      f
    );
  }
  f = message.getIsreloan();
  if (f !== 0) {
    writer.writeInt32(
      17,
      f
    );
  }
  f = message.getFinishtime();
  if (f !== 0) {
    writer.writeInt64(
      23,
      f
    );
  }
  f = message.getRolltimes();
  if (f !== 0) {
    writer.writeInt32(
      35,
      f
    );
  }
  f = message.getPreorder();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      36,
      f
    );
  }
  f = message.getStagenum();
  if (f !== 0) {
    writer.writeInt32(
      46,
      f
    );
  }
  f = message.getStageindex();
  if (f !== 0) {
    writer.writeInt32(
      49,
      f
    );
  }
  f = message.getCheckstatusshow();
  if (f.length > 0) {
    writer.writeString(
      50,
      f
    );
  }
  f = message.getBusinesstype();
  if (f !== 0.0) {
    writer.writeEnum(
      51,
      f
    );
  }
  f = message.getInvalidtime();
  if (f !== 0) {
    writer.writeInt64(
      52,
      f
    );
  }
  f = message.getCcfreduceflag();
  if (f !== 0.0) {
    writer.writeEnum(
      53,
      f
    );
  }
  f = message.getFromplatform();
  if (f !== 0.0) {
    writer.writeEnum(
      54,
      f
    );
  }
  f = message.getCustomization();
  if (f != null) {
    writer.writeMessage(
      55,
      f,
      proto.xcommon.OrderCustomization.serializeBinaryToWriter
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      56,
      f
    );
  }
  f = message.getOrdertagsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(57, writer, jspb.BinaryWriter.prototype.writeInt32, jspb.BinaryWriter.prototype.writeString);
  }
};


/**
 * optional int64 Id = 1;
 * @return {string}
 */
proto.xcommon.OrderInfo.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/** @param {string} value */
proto.xcommon.OrderInfo.prototype.setId = function(value) {
  jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional int64 UserAccountId = 2;
 * @return {string}
 */
proto.xcommon.OrderInfo.prototype.getUseraccountid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/** @param {string} value */
proto.xcommon.OrderInfo.prototype.setUseraccountid = function(value) {
  jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * optional int64 Amount = 6;
 * @return {number}
 */
proto.xcommon.OrderInfo.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.xcommon.OrderInfo.prototype.setAmount = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 Loan = 9;
 * @return {number}
 */
proto.xcommon.OrderInfo.prototype.getLoan = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/** @param {number} value */
proto.xcommon.OrderInfo.prototype.setLoan = function(value) {
  jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int32 CheckStatus = 13;
 * @return {number}
 */
proto.xcommon.OrderInfo.prototype.getCheckstatus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/** @param {number} value */
proto.xcommon.OrderInfo.prototype.setCheckstatus = function(value) {
  jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional int32 IsTemporary = 14;
 * @return {number}
 */
proto.xcommon.OrderInfo.prototype.getIstemporary = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/** @param {number} value */
proto.xcommon.OrderInfo.prototype.setIstemporary = function(value) {
  jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional int32 IsOverdue = 15;
 * @return {number}
 */
proto.xcommon.OrderInfo.prototype.getIsoverdue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/** @param {number} value */
proto.xcommon.OrderInfo.prototype.setIsoverdue = function(value) {
  jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional int32 IsDeadDebt = 16;
 * @return {number}
 */
proto.xcommon.OrderInfo.prototype.getIsdeaddebt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/** @param {number} value */
proto.xcommon.OrderInfo.prototype.setIsdeaddebt = function(value) {
  jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional int32 IsReloan = 17;
 * @return {number}
 */
proto.xcommon.OrderInfo.prototype.getIsreloan = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/** @param {number} value */
proto.xcommon.OrderInfo.prototype.setIsreloan = function(value) {
  jspb.Message.setProto3IntField(this, 17, value);
};


/**
 * optional int64 FinishTime = 23;
 * @return {number}
 */
proto.xcommon.OrderInfo.prototype.getFinishtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 23, 0));
};


/** @param {number} value */
proto.xcommon.OrderInfo.prototype.setFinishtime = function(value) {
  jspb.Message.setProto3IntField(this, 23, value);
};


/**
 * optional int32 RollTimes = 35;
 * @return {number}
 */
proto.xcommon.OrderInfo.prototype.getRolltimes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 35, 0));
};


/** @param {number} value */
proto.xcommon.OrderInfo.prototype.setRolltimes = function(value) {
  jspb.Message.setProto3IntField(this, 35, value);
};


/**
 * optional int64 PreOrder = 36;
 * @return {string}
 */
proto.xcommon.OrderInfo.prototype.getPreorder = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 36, "0"));
};


/** @param {string} value */
proto.xcommon.OrderInfo.prototype.setPreorder = function(value) {
  jspb.Message.setProto3StringIntField(this, 36, value);
};


/**
 * optional int32 StageNum = 46;
 * @return {number}
 */
proto.xcommon.OrderInfo.prototype.getStagenum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 46, 0));
};


/** @param {number} value */
proto.xcommon.OrderInfo.prototype.setStagenum = function(value) {
  jspb.Message.setProto3IntField(this, 46, value);
};


/**
 * optional int32 StageIndex = 49;
 * @return {number}
 */
proto.xcommon.OrderInfo.prototype.getStageindex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 49, 0));
};


/** @param {number} value */
proto.xcommon.OrderInfo.prototype.setStageindex = function(value) {
  jspb.Message.setProto3IntField(this, 49, value);
};


/**
 * optional string CheckStatusShow = 50;
 * @return {string}
 */
proto.xcommon.OrderInfo.prototype.getCheckstatusshow = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 50, ""));
};


/** @param {string} value */
proto.xcommon.OrderInfo.prototype.setCheckstatusshow = function(value) {
  jspb.Message.setProto3StringField(this, 50, value);
};


/**
 * optional BusinessTypeEnum BusinessType = 51;
 * @return {!proto.xcommon.BusinessTypeEnum}
 */
proto.xcommon.OrderInfo.prototype.getBusinesstype = function() {
  return /** @type {!proto.xcommon.BusinessTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 51, 0));
};


/** @param {!proto.xcommon.BusinessTypeEnum} value */
proto.xcommon.OrderInfo.prototype.setBusinesstype = function(value) {
  jspb.Message.setProto3EnumField(this, 51, value);
};


/**
 * optional int64 InvalidTime = 52;
 * @return {number}
 */
proto.xcommon.OrderInfo.prototype.getInvalidtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 52, 0));
};


/** @param {number} value */
proto.xcommon.OrderInfo.prototype.setInvalidtime = function(value) {
  jspb.Message.setProto3IntField(this, 52, value);
};


/**
 * optional CreditCardFeeReduceFlag CCFReduceFlag = 53;
 * @return {!proto.xcommon.CreditCardFeeReduceFlag}
 */
proto.xcommon.OrderInfo.prototype.getCcfreduceflag = function() {
  return /** @type {!proto.xcommon.CreditCardFeeReduceFlag} */ (jspb.Message.getFieldWithDefault(this, 53, 0));
};


/** @param {!proto.xcommon.CreditCardFeeReduceFlag} value */
proto.xcommon.OrderInfo.prototype.setCcfreduceflag = function(value) {
  jspb.Message.setProto3EnumField(this, 53, value);
};


/**
 * optional OrderFromPlatform FromPlatform = 54;
 * @return {!proto.xcommon.OrderFromPlatform}
 */
proto.xcommon.OrderInfo.prototype.getFromplatform = function() {
  return /** @type {!proto.xcommon.OrderFromPlatform} */ (jspb.Message.getFieldWithDefault(this, 54, 0));
};


/** @param {!proto.xcommon.OrderFromPlatform} value */
proto.xcommon.OrderInfo.prototype.setFromplatform = function(value) {
  jspb.Message.setProto3EnumField(this, 54, value);
};


/**
 * optional OrderCustomization Customization = 55;
 * @return {?proto.xcommon.OrderCustomization}
 */
proto.xcommon.OrderInfo.prototype.getCustomization = function() {
  return /** @type{?proto.xcommon.OrderCustomization} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.OrderCustomization, 55));
};


/** @param {?proto.xcommon.OrderCustomization|undefined} value */
proto.xcommon.OrderInfo.prototype.setCustomization = function(value) {
  jspb.Message.setWrapperField(this, 55, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.OrderInfo.prototype.clearCustomization = function() {
  this.setCustomization(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.OrderInfo.prototype.hasCustomization = function() {
  return jspb.Message.getField(this, 55) != null;
};


/**
 * optional string AppName = 56;
 * @return {string}
 */
proto.xcommon.OrderInfo.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 56, ""));
};


/** @param {string} value */
proto.xcommon.OrderInfo.prototype.setAppname = function(value) {
  jspb.Message.setProto3StringField(this, 56, value);
};


/**
 * map<int32, string> OrderTags = 57;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,string>}
 */
proto.xcommon.OrderInfo.prototype.getOrdertagsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,string>} */ (
      jspb.Message.getMapField(this, 57, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 */
proto.xcommon.OrderInfo.prototype.clearOrdertagsMap = function() {
  this.getOrdertagsMap().clear();
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.OrderRiskInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.OrderRiskInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.OrderRiskInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.OrderRiskInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    riskscore: jspb.Message.getFieldWithDefault(msg, 1, 0),
    risklevel: jspb.Message.getFieldWithDefault(msg, 2, ""),
    reject: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    appname: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.OrderRiskInfo}
 */
proto.xcommon.OrderRiskInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.OrderRiskInfo;
  return proto.xcommon.OrderRiskInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.OrderRiskInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.OrderRiskInfo}
 */
proto.xcommon.OrderRiskInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRiskscore(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRisklevel(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setReject(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.OrderRiskInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.OrderRiskInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.OrderRiskInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.OrderRiskInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRiskscore();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getRisklevel();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getReject();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional int64 RiskScore = 1;
 * @return {number}
 */
proto.xcommon.OrderRiskInfo.prototype.getRiskscore = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.OrderRiskInfo.prototype.setRiskscore = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string RiskLevel = 2;
 * @return {string}
 */
proto.xcommon.OrderRiskInfo.prototype.getRisklevel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.OrderRiskInfo.prototype.setRisklevel = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool Reject = 3;
 * @return {boolean}
 */
proto.xcommon.OrderRiskInfo.prototype.getReject = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/** @param {boolean} value */
proto.xcommon.OrderRiskInfo.prototype.setReject = function(value) {
  jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional string AppName = 4;
 * @return {string}
 */
proto.xcommon.OrderRiskInfo.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.OrderRiskInfo.prototype.setAppname = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.OrderTagInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.OrderTagInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.OrderTagInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.OrderTagInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    autocalltag: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    producttag: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    statustag: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    customertag: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    platformtag: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    appname: jspb.Message.getFieldWithDefault(msg, 6, ""),
    risktag: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
    repayintenttag: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
    abnormalcontact: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
    disastertag: jspb.Message.getBooleanFieldWithDefault(msg, 10, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.OrderTagInfo}
 */
proto.xcommon.OrderTagInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.OrderTagInfo;
  return proto.xcommon.OrderTagInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.OrderTagInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.OrderTagInfo}
 */
proto.xcommon.OrderTagInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAutocalltag(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setProducttag(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setStatustag(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCustomertag(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPlatformtag(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRisktag(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRepayintenttag(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAbnormalcontact(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDisastertag(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.OrderTagInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.OrderTagInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.OrderTagInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.OrderTagInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAutocalltag();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getProducttag();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getStatustag();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getCustomertag();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getPlatformtag();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getRisktag();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getRepayintenttag();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getAbnormalcontact();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getDisastertag();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
};


/**
 * optional bool AutoCallTag = 1;
 * @return {boolean}
 */
proto.xcommon.OrderTagInfo.prototype.getAutocalltag = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/** @param {boolean} value */
proto.xcommon.OrderTagInfo.prototype.setAutocalltag = function(value) {
  jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional bool ProductTag = 2;
 * @return {boolean}
 */
proto.xcommon.OrderTagInfo.prototype.getProducttag = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/** @param {boolean} value */
proto.xcommon.OrderTagInfo.prototype.setProducttag = function(value) {
  jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional bool StatusTag = 3;
 * @return {boolean}
 */
proto.xcommon.OrderTagInfo.prototype.getStatustag = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/** @param {boolean} value */
proto.xcommon.OrderTagInfo.prototype.setStatustag = function(value) {
  jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional bool CustomerTag = 4;
 * @return {boolean}
 */
proto.xcommon.OrderTagInfo.prototype.getCustomertag = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/** @param {boolean} value */
proto.xcommon.OrderTagInfo.prototype.setCustomertag = function(value) {
  jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional bool PlatformTag = 5;
 * @return {boolean}
 */
proto.xcommon.OrderTagInfo.prototype.getPlatformtag = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/** @param {boolean} value */
proto.xcommon.OrderTagInfo.prototype.setPlatformtag = function(value) {
  jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional string AppName = 6;
 * @return {string}
 */
proto.xcommon.OrderTagInfo.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.xcommon.OrderTagInfo.prototype.setAppname = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional bool RiskTag = 7;
 * @return {boolean}
 */
proto.xcommon.OrderTagInfo.prototype.getRisktag = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/** @param {boolean} value */
proto.xcommon.OrderTagInfo.prototype.setRisktag = function(value) {
  jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional bool RepayIntentTag = 8;
 * @return {boolean}
 */
proto.xcommon.OrderTagInfo.prototype.getRepayintenttag = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/** @param {boolean} value */
proto.xcommon.OrderTagInfo.prototype.setRepayintenttag = function(value) {
  jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional bool AbnormalContact = 9;
 * @return {boolean}
 */
proto.xcommon.OrderTagInfo.prototype.getAbnormalcontact = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/** @param {boolean} value */
proto.xcommon.OrderTagInfo.prototype.setAbnormalcontact = function(value) {
  jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * optional bool DisasterTag = 10;
 * @return {boolean}
 */
proto.xcommon.OrderTagInfo.prototype.getDisastertag = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/** @param {boolean} value */
proto.xcommon.OrderTagInfo.prototype.setDisastertag = function(value) {
  jspb.Message.setProto3BooleanField(this, 10, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.OrderTagExtInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.OrderTagExtInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.OrderTagExtInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.OrderTagExtInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    autocalltag: jspb.Message.getFieldWithDefault(msg, 1, ""),
    producttag: jspb.Message.getFieldWithDefault(msg, 2, ""),
    statustag: jspb.Message.getFieldWithDefault(msg, 3, ""),
    customertag: jspb.Message.getFieldWithDefault(msg, 4, ""),
    platformtag: jspb.Message.getFieldWithDefault(msg, 5, ""),
    appname: jspb.Message.getFieldWithDefault(msg, 6, ""),
    risktag: jspb.Message.getFieldWithDefault(msg, 7, ""),
    repayintenttag: jspb.Message.getFieldWithDefault(msg, 8, ""),
    abnormalcontact: jspb.Message.getFieldWithDefault(msg, 9, ""),
    disastertag: jspb.Message.getFieldWithDefault(msg, 10, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.OrderTagExtInfo}
 */
proto.xcommon.OrderTagExtInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.OrderTagExtInfo;
  return proto.xcommon.OrderTagExtInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.OrderTagExtInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.OrderTagExtInfo}
 */
proto.xcommon.OrderTagExtInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAutocalltag(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setProducttag(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatustag(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomertag(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlatformtag(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setRisktag(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setRepayintenttag(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setAbnormalcontact(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisastertag(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.OrderTagExtInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.OrderTagExtInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.OrderTagExtInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.OrderTagExtInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAutocalltag();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getProducttag();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getStatustag();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCustomertag();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPlatformtag();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getRisktag();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getRepayintenttag();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getAbnormalcontact();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getDisastertag();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
};


/**
 * optional string AutoCallTag = 1;
 * @return {string}
 */
proto.xcommon.OrderTagExtInfo.prototype.getAutocalltag = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.xcommon.OrderTagExtInfo.prototype.setAutocalltag = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string ProductTag = 2;
 * @return {string}
 */
proto.xcommon.OrderTagExtInfo.prototype.getProducttag = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.OrderTagExtInfo.prototype.setProducttag = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string StatusTag = 3;
 * @return {string}
 */
proto.xcommon.OrderTagExtInfo.prototype.getStatustag = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.OrderTagExtInfo.prototype.setStatustag = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string CustomerTag = 4;
 * @return {string}
 */
proto.xcommon.OrderTagExtInfo.prototype.getCustomertag = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.OrderTagExtInfo.prototype.setCustomertag = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string PlatformTag = 5;
 * @return {string}
 */
proto.xcommon.OrderTagExtInfo.prototype.getPlatformtag = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.xcommon.OrderTagExtInfo.prototype.setPlatformtag = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string AppName = 6;
 * @return {string}
 */
proto.xcommon.OrderTagExtInfo.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.xcommon.OrderTagExtInfo.prototype.setAppname = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string RiskTag = 7;
 * @return {string}
 */
proto.xcommon.OrderTagExtInfo.prototype.getRisktag = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.xcommon.OrderTagExtInfo.prototype.setRisktag = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string RepayIntentTag = 8;
 * @return {string}
 */
proto.xcommon.OrderTagExtInfo.prototype.getRepayintenttag = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/** @param {string} value */
proto.xcommon.OrderTagExtInfo.prototype.setRepayintenttag = function(value) {
  jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string AbnormalContact = 9;
 * @return {string}
 */
proto.xcommon.OrderTagExtInfo.prototype.getAbnormalcontact = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/** @param {string} value */
proto.xcommon.OrderTagExtInfo.prototype.setAbnormalcontact = function(value) {
  jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string DisasterTag = 10;
 * @return {string}
 */
proto.xcommon.OrderTagExtInfo.prototype.getDisastertag = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/** @param {string} value */
proto.xcommon.OrderTagExtInfo.prototype.setDisastertag = function(value) {
  jspb.Message.setProto3StringField(this, 10, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.AccountProfileInfo.repeatedFields_ = [60,61];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.AccountProfileInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.AccountProfileInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.AccountProfileInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.AccountProfileInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    accountid: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    idphoto: jspb.Message.getFieldWithDefault(msg, 2, 0),
    handheldidphoto: jspb.Message.getFieldWithDefault(msg, 3, 0),
    selfieuploadtime: jspb.Message.getFieldWithDefault(msg, 4, 0),
    jobtype: jspb.Message.getFieldWithDefault(msg, 5, 0),
    monthlyincome: jspb.Message.getFieldWithDefault(msg, 6, 0),
    familymonthlyincome: jspb.Message.getFieldWithDefault(msg, 7, 0),
    companyname: jspb.Message.getFieldWithDefault(msg, 8, ""),
    companycity: jspb.Message.getFieldWithDefault(msg, 9, ""),
    companyaddress: jspb.Message.getFieldWithDefault(msg, 10, ""),
    companypincode: jspb.Message.getFieldWithDefault(msg, 11, ""),
    currentpincode: jspb.Message.getFieldWithDefault(msg, 12, ""),
    serviceyears: jspb.Message.getFieldWithDefault(msg, 13, 0),
    contact1: jspb.Message.getFieldWithDefault(msg, 14, ""),
    contact1name: jspb.Message.getFieldWithDefault(msg, 15, ""),
    relationship1: jspb.Message.getFieldWithDefault(msg, 16, 0),
    contact2: jspb.Message.getFieldWithDefault(msg, 17, ""),
    contact2name: jspb.Message.getFieldWithDefault(msg, 18, ""),
    relationship2: jspb.Message.getFieldWithDefault(msg, 19, 0),
    education: jspb.Message.getFieldWithDefault(msg, 20, 0),
    maritalstatus: jspb.Message.getFieldWithDefault(msg, 21, 0),
    childrennumber: jspb.Message.getFieldWithDefault(msg, 22, 0),
    residentcity: jspb.Message.getFieldWithDefault(msg, 23, ""),
    residentstate: jspb.Message.getFieldWithDefault(msg, 24, ""),
    residentaddress: jspb.Message.getFieldWithDefault(msg, 25, ""),
    pincode: jspb.Message.getFieldWithDefault(msg, 26, ""),
    systemlanguage: jspb.Message.getFieldWithDefault(msg, 27, ""),
    language: jspb.Message.getFieldWithDefault(msg, 28, ""),
    applanguage: jspb.Message.getFieldWithDefault(msg, 29, ""),
    bankname: jspb.Message.getFieldWithDefault(msg, 30, ""),
    bankno: jspb.Message.getFieldWithDefault(msg, 31, ""),
    repaybankcode: jspb.Message.getFieldWithDefault(msg, 32, ""),
    idphotoquality: jspb.Message.getFieldWithDefault(msg, 33, ""),
    idphotoqualitythreshold: jspb.Message.getFieldWithDefault(msg, 34, ""),
    handphotoquality: jspb.Message.getFieldWithDefault(msg, 35, ""),
    handphotoqualitythreshold: jspb.Message.getFieldWithDefault(msg, 36, ""),
    facecomparison: jspb.Message.getFieldWithDefault(msg, 37, ""),
    facecomparisonihid: jspb.Message.getFieldWithDefault(msg, 38, ""),
    idholdingphotocheck: jspb.Message.getFieldWithDefault(msg, 39, ""),
    bankverification: jspb.Message.getFieldWithDefault(msg, 40, 0),
    companytelephone: jspb.Message.getFieldWithDefault(msg, 41, ""),
    salaryday: jspb.Message.getFieldWithDefault(msg, 42, ""),
    ctime: jspb.Message.getFieldWithDefault(msg, 43, 0),
    utime: jspb.Message.getFieldWithDefault(msg, 44, 0),
    dateofbirth: jspb.Message.getFieldWithDefault(msg, 45, 0),
    ifsccode: jspb.Message.getFieldWithDefault(msg, 46, ""),
    photoaadhaarfront: jspb.Message.getFieldWithDefault(msg, 47, 0),
    photoaadhaarback: jspb.Message.getFieldWithDefault(msg, 48, 0),
    addressphototype: jspb.Message.getFieldWithDefault(msg, 49, 0),
    addressphotouploadtime: jspb.Message.getFieldWithDefault(msg, 50, 0),
    familyphone: jspb.Message.getFieldWithDefault(msg, 51, ""),
    salarytype: jspb.Message.getFieldWithDefault(msg, 52, 0),
    contact3: jspb.Message.getFieldWithDefault(msg, 53, ""),
    contact3name: jspb.Message.getFieldWithDefault(msg, 54, ""),
    relationship3: jspb.Message.getFieldWithDefault(msg, 55, 0),
    sparemobile: jspb.Message.getFieldWithDefault(msg, 56, ""),
    concatMap: (f = msg.getConcatMap()) ? f.toObject(includeInstance, undefined) : [],
    appname: jspb.Message.getFieldWithDefault(msg, 58, ""),
    calllogMap: (f = msg.getCalllogMap()) ? f.toObject(includeInstance, undefined) : [],
    calllogsList: jspb.Message.toObjectList(msg.getCalllogsList(),
    proto.xcommon.CallLog.toObject, includeInstance),
    smslogList: jspb.Message.toObjectList(msg.getSmslogList(),
    proto.xcommon.SmsLog.toObject, includeInstance),
    contact4: jspb.Message.getFieldWithDefault(msg, 62, ""),
    contact4name: jspb.Message.getFieldWithDefault(msg, 63, ""),
    relationship4: jspb.Message.getFieldWithDefault(msg, 64, 0),
    currentwallet: (f = msg.getCurrentwallet()) && proto.xcommon.AccountWalletInfo.toObject(includeInstance, f),
    historywallets: jspb.Message.getFieldWithDefault(msg, 66, ""),
    applogo: jspb.Message.getFieldWithDefault(msg, 67, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.AccountProfileInfo}
 */
proto.xcommon.AccountProfileInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.AccountProfileInfo;
  return proto.xcommon.AccountProfileInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.AccountProfileInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.AccountProfileInfo}
 */
proto.xcommon.AccountProfileInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setAccountid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setIdphoto(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setHandheldidphoto(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSelfieuploadtime(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setJobtype(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMonthlyincome(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFamilymonthlyincome(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompanyname(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompanycity(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompanyaddress(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompanypincode(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrentpincode(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setServiceyears(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setContact1(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setContact1name(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRelationship1(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setContact2(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setContact2name(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRelationship2(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setEducation(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMaritalstatus(value);
      break;
    case 22:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setChildrennumber(value);
      break;
    case 23:
      var value = /** @type {string} */ (reader.readString());
      msg.setResidentcity(value);
      break;
    case 24:
      var value = /** @type {string} */ (reader.readString());
      msg.setResidentstate(value);
      break;
    case 25:
      var value = /** @type {string} */ (reader.readString());
      msg.setResidentaddress(value);
      break;
    case 26:
      var value = /** @type {string} */ (reader.readString());
      msg.setPincode(value);
      break;
    case 27:
      var value = /** @type {string} */ (reader.readString());
      msg.setSystemlanguage(value);
      break;
    case 28:
      var value = /** @type {string} */ (reader.readString());
      msg.setLanguage(value);
      break;
    case 29:
      var value = /** @type {string} */ (reader.readString());
      msg.setApplanguage(value);
      break;
    case 30:
      var value = /** @type {string} */ (reader.readString());
      msg.setBankname(value);
      break;
    case 31:
      var value = /** @type {string} */ (reader.readString());
      msg.setBankno(value);
      break;
    case 32:
      var value = /** @type {string} */ (reader.readString());
      msg.setRepaybankcode(value);
      break;
    case 33:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdphotoquality(value);
      break;
    case 34:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdphotoqualitythreshold(value);
      break;
    case 35:
      var value = /** @type {string} */ (reader.readString());
      msg.setHandphotoquality(value);
      break;
    case 36:
      var value = /** @type {string} */ (reader.readString());
      msg.setHandphotoqualitythreshold(value);
      break;
    case 37:
      var value = /** @type {string} */ (reader.readString());
      msg.setFacecomparison(value);
      break;
    case 38:
      var value = /** @type {string} */ (reader.readString());
      msg.setFacecomparisonihid(value);
      break;
    case 39:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdholdingphotocheck(value);
      break;
    case 40:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBankverification(value);
      break;
    case 41:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompanytelephone(value);
      break;
    case 42:
      var value = /** @type {string} */ (reader.readString());
      msg.setSalaryday(value);
      break;
    case 43:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCtime(value);
      break;
    case 44:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUtime(value);
      break;
    case 45:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDateofbirth(value);
      break;
    case 46:
      var value = /** @type {string} */ (reader.readString());
      msg.setIfsccode(value);
      break;
    case 47:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPhotoaadhaarfront(value);
      break;
    case 48:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPhotoaadhaarback(value);
      break;
    case 49:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAddressphototype(value);
      break;
    case 50:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAddressphotouploadtime(value);
      break;
    case 51:
      var value = /** @type {string} */ (reader.readString());
      msg.setFamilyphone(value);
      break;
    case 52:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSalarytype(value);
      break;
    case 53:
      var value = /** @type {string} */ (reader.readString());
      msg.setContact3(value);
      break;
    case 54:
      var value = /** @type {string} */ (reader.readString());
      msg.setContact3name(value);
      break;
    case 55:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRelationship3(value);
      break;
    case 56:
      var value = /** @type {string} */ (reader.readString());
      msg.setSparemobile(value);
      break;
    case 57:
      var value = msg.getConcatMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "");
         });
      break;
    case 58:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    case 59:
      var value = msg.getCalllogMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "");
         });
      break;
    case 60:
      var value = new proto.xcommon.CallLog;
      reader.readMessage(value,proto.xcommon.CallLog.deserializeBinaryFromReader);
      msg.addCalllogs(value);
      break;
    case 61:
      var value = new proto.xcommon.SmsLog;
      reader.readMessage(value,proto.xcommon.SmsLog.deserializeBinaryFromReader);
      msg.addSmslog(value);
      break;
    case 62:
      var value = /** @type {string} */ (reader.readString());
      msg.setContact4(value);
      break;
    case 63:
      var value = /** @type {string} */ (reader.readString());
      msg.setContact4name(value);
      break;
    case 64:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRelationship4(value);
      break;
    case 65:
      var value = new proto.xcommon.AccountWalletInfo;
      reader.readMessage(value,proto.xcommon.AccountWalletInfo.deserializeBinaryFromReader);
      msg.setCurrentwallet(value);
      break;
    case 66:
      var value = /** @type {string} */ (reader.readString());
      msg.setHistorywallets(value);
      break;
    case 67:
      var value = /** @type {string} */ (reader.readString());
      msg.setApplogo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.AccountProfileInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.AccountProfileInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.AccountProfileInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.AccountProfileInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      1,
      f
    );
  }
  f = message.getIdphoto();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getHandheldidphoto();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getSelfieuploadtime();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getJobtype();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getMonthlyincome();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getFamilymonthlyincome();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getCompanyname();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getCompanycity();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getCompanyaddress();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getCompanypincode();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getCurrentpincode();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getServiceyears();
  if (f !== 0) {
    writer.writeInt32(
      13,
      f
    );
  }
  f = message.getContact1();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getContact1name();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getRelationship1();
  if (f !== 0) {
    writer.writeInt32(
      16,
      f
    );
  }
  f = message.getContact2();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getContact2name();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getRelationship2();
  if (f !== 0) {
    writer.writeInt32(
      19,
      f
    );
  }
  f = message.getEducation();
  if (f !== 0) {
    writer.writeInt32(
      20,
      f
    );
  }
  f = message.getMaritalstatus();
  if (f !== 0) {
    writer.writeInt32(
      21,
      f
    );
  }
  f = message.getChildrennumber();
  if (f !== 0) {
    writer.writeInt32(
      22,
      f
    );
  }
  f = message.getResidentcity();
  if (f.length > 0) {
    writer.writeString(
      23,
      f
    );
  }
  f = message.getResidentstate();
  if (f.length > 0) {
    writer.writeString(
      24,
      f
    );
  }
  f = message.getResidentaddress();
  if (f.length > 0) {
    writer.writeString(
      25,
      f
    );
  }
  f = message.getPincode();
  if (f.length > 0) {
    writer.writeString(
      26,
      f
    );
  }
  f = message.getSystemlanguage();
  if (f.length > 0) {
    writer.writeString(
      27,
      f
    );
  }
  f = message.getLanguage();
  if (f.length > 0) {
    writer.writeString(
      28,
      f
    );
  }
  f = message.getApplanguage();
  if (f.length > 0) {
    writer.writeString(
      29,
      f
    );
  }
  f = message.getBankname();
  if (f.length > 0) {
    writer.writeString(
      30,
      f
    );
  }
  f = message.getBankno();
  if (f.length > 0) {
    writer.writeString(
      31,
      f
    );
  }
  f = message.getRepaybankcode();
  if (f.length > 0) {
    writer.writeString(
      32,
      f
    );
  }
  f = message.getIdphotoquality();
  if (f.length > 0) {
    writer.writeString(
      33,
      f
    );
  }
  f = message.getIdphotoqualitythreshold();
  if (f.length > 0) {
    writer.writeString(
      34,
      f
    );
  }
  f = message.getHandphotoquality();
  if (f.length > 0) {
    writer.writeString(
      35,
      f
    );
  }
  f = message.getHandphotoqualitythreshold();
  if (f.length > 0) {
    writer.writeString(
      36,
      f
    );
  }
  f = message.getFacecomparison();
  if (f.length > 0) {
    writer.writeString(
      37,
      f
    );
  }
  f = message.getFacecomparisonihid();
  if (f.length > 0) {
    writer.writeString(
      38,
      f
    );
  }
  f = message.getIdholdingphotocheck();
  if (f.length > 0) {
    writer.writeString(
      39,
      f
    );
  }
  f = message.getBankverification();
  if (f !== 0) {
    writer.writeInt32(
      40,
      f
    );
  }
  f = message.getCompanytelephone();
  if (f.length > 0) {
    writer.writeString(
      41,
      f
    );
  }
  f = message.getSalaryday();
  if (f.length > 0) {
    writer.writeString(
      42,
      f
    );
  }
  f = message.getCtime();
  if (f !== 0) {
    writer.writeInt64(
      43,
      f
    );
  }
  f = message.getUtime();
  if (f !== 0) {
    writer.writeInt64(
      44,
      f
    );
  }
  f = message.getDateofbirth();
  if (f !== 0) {
    writer.writeInt64(
      45,
      f
    );
  }
  f = message.getIfsccode();
  if (f.length > 0) {
    writer.writeString(
      46,
      f
    );
  }
  f = message.getPhotoaadhaarfront();
  if (f !== 0) {
    writer.writeInt64(
      47,
      f
    );
  }
  f = message.getPhotoaadhaarback();
  if (f !== 0) {
    writer.writeInt64(
      48,
      f
    );
  }
  f = message.getAddressphototype();
  if (f !== 0) {
    writer.writeInt32(
      49,
      f
    );
  }
  f = message.getAddressphotouploadtime();
  if (f !== 0) {
    writer.writeInt64(
      50,
      f
    );
  }
  f = message.getFamilyphone();
  if (f.length > 0) {
    writer.writeString(
      51,
      f
    );
  }
  f = message.getSalarytype();
  if (f !== 0) {
    writer.writeInt32(
      52,
      f
    );
  }
  f = message.getContact3();
  if (f.length > 0) {
    writer.writeString(
      53,
      f
    );
  }
  f = message.getContact3name();
  if (f.length > 0) {
    writer.writeString(
      54,
      f
    );
  }
  f = message.getRelationship3();
  if (f !== 0) {
    writer.writeInt32(
      55,
      f
    );
  }
  f = message.getSparemobile();
  if (f.length > 0) {
    writer.writeString(
      56,
      f
    );
  }
  f = message.getConcatMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(57, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      58,
      f
    );
  }
  f = message.getCalllogMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(59, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getCalllogsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      60,
      f,
      proto.xcommon.CallLog.serializeBinaryToWriter
    );
  }
  f = message.getSmslogList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      61,
      f,
      proto.xcommon.SmsLog.serializeBinaryToWriter
    );
  }
  f = message.getContact4();
  if (f.length > 0) {
    writer.writeString(
      62,
      f
    );
  }
  f = message.getContact4name();
  if (f.length > 0) {
    writer.writeString(
      63,
      f
    );
  }
  f = message.getRelationship4();
  if (f !== 0) {
    writer.writeInt32(
      64,
      f
    );
  }
  f = message.getCurrentwallet();
  if (f != null) {
    writer.writeMessage(
      65,
      f,
      proto.xcommon.AccountWalletInfo.serializeBinaryToWriter
    );
  }
  f = message.getHistorywallets();
  if (f.length > 0) {
    writer.writeString(
      66,
      f
    );
  }
  f = message.getApplogo();
  if (f.length > 0) {
    writer.writeString(
      67,
      f
    );
  }
};


/**
 * optional int64 AccountId = 1;
 * @return {string}
 */
proto.xcommon.AccountProfileInfo.prototype.getAccountid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/** @param {string} value */
proto.xcommon.AccountProfileInfo.prototype.setAccountid = function(value) {
  jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional int64 IdPhoto = 2;
 * @return {number}
 */
proto.xcommon.AccountProfileInfo.prototype.getIdphoto = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.AccountProfileInfo.prototype.setIdphoto = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 HandHeldIdPhoto = 3;
 * @return {number}
 */
proto.xcommon.AccountProfileInfo.prototype.getHandheldidphoto = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.AccountProfileInfo.prototype.setHandheldidphoto = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 SelfieUploadTime = 4;
 * @return {number}
 */
proto.xcommon.AccountProfileInfo.prototype.getSelfieuploadtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.AccountProfileInfo.prototype.setSelfieuploadtime = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 JobType = 5;
 * @return {number}
 */
proto.xcommon.AccountProfileInfo.prototype.getJobtype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.AccountProfileInfo.prototype.setJobtype = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 MonthlyIncome = 6;
 * @return {number}
 */
proto.xcommon.AccountProfileInfo.prototype.getMonthlyincome = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.xcommon.AccountProfileInfo.prototype.setMonthlyincome = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 FamilyMonthlyIncome = 7;
 * @return {number}
 */
proto.xcommon.AccountProfileInfo.prototype.getFamilymonthlyincome = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.xcommon.AccountProfileInfo.prototype.setFamilymonthlyincome = function(value) {
  jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string CompanyName = 8;
 * @return {string}
 */
proto.xcommon.AccountProfileInfo.prototype.getCompanyname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/** @param {string} value */
proto.xcommon.AccountProfileInfo.prototype.setCompanyname = function(value) {
  jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string CompanyCity = 9;
 * @return {string}
 */
proto.xcommon.AccountProfileInfo.prototype.getCompanycity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/** @param {string} value */
proto.xcommon.AccountProfileInfo.prototype.setCompanycity = function(value) {
  jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string CompanyAddress = 10;
 * @return {string}
 */
proto.xcommon.AccountProfileInfo.prototype.getCompanyaddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/** @param {string} value */
proto.xcommon.AccountProfileInfo.prototype.setCompanyaddress = function(value) {
  jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string CompanyPincode = 11;
 * @return {string}
 */
proto.xcommon.AccountProfileInfo.prototype.getCompanypincode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/** @param {string} value */
proto.xcommon.AccountProfileInfo.prototype.setCompanypincode = function(value) {
  jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string CurrentPincode = 12;
 * @return {string}
 */
proto.xcommon.AccountProfileInfo.prototype.getCurrentpincode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/** @param {string} value */
proto.xcommon.AccountProfileInfo.prototype.setCurrentpincode = function(value) {
  jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional int32 ServiceYears = 13;
 * @return {number}
 */
proto.xcommon.AccountProfileInfo.prototype.getServiceyears = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/** @param {number} value */
proto.xcommon.AccountProfileInfo.prototype.setServiceyears = function(value) {
  jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional string Contact1 = 14;
 * @return {string}
 */
proto.xcommon.AccountProfileInfo.prototype.getContact1 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/** @param {string} value */
proto.xcommon.AccountProfileInfo.prototype.setContact1 = function(value) {
  jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string Contact1Name = 15;
 * @return {string}
 */
proto.xcommon.AccountProfileInfo.prototype.getContact1name = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/** @param {string} value */
proto.xcommon.AccountProfileInfo.prototype.setContact1name = function(value) {
  jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional int32 Relationship1 = 16;
 * @return {number}
 */
proto.xcommon.AccountProfileInfo.prototype.getRelationship1 = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/** @param {number} value */
proto.xcommon.AccountProfileInfo.prototype.setRelationship1 = function(value) {
  jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional string Contact2 = 17;
 * @return {string}
 */
proto.xcommon.AccountProfileInfo.prototype.getContact2 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/** @param {string} value */
proto.xcommon.AccountProfileInfo.prototype.setContact2 = function(value) {
  jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string Contact2Name = 18;
 * @return {string}
 */
proto.xcommon.AccountProfileInfo.prototype.getContact2name = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/** @param {string} value */
proto.xcommon.AccountProfileInfo.prototype.setContact2name = function(value) {
  jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional int32 Relationship2 = 19;
 * @return {number}
 */
proto.xcommon.AccountProfileInfo.prototype.getRelationship2 = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/** @param {number} value */
proto.xcommon.AccountProfileInfo.prototype.setRelationship2 = function(value) {
  jspb.Message.setProto3IntField(this, 19, value);
};


/**
 * optional int32 Education = 20;
 * @return {number}
 */
proto.xcommon.AccountProfileInfo.prototype.getEducation = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/** @param {number} value */
proto.xcommon.AccountProfileInfo.prototype.setEducation = function(value) {
  jspb.Message.setProto3IntField(this, 20, value);
};


/**
 * optional int32 MaritalStatus = 21;
 * @return {number}
 */
proto.xcommon.AccountProfileInfo.prototype.getMaritalstatus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};


/** @param {number} value */
proto.xcommon.AccountProfileInfo.prototype.setMaritalstatus = function(value) {
  jspb.Message.setProto3IntField(this, 21, value);
};


/**
 * optional int32 ChildrenNumber = 22;
 * @return {number}
 */
proto.xcommon.AccountProfileInfo.prototype.getChildrennumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 22, 0));
};


/** @param {number} value */
proto.xcommon.AccountProfileInfo.prototype.setChildrennumber = function(value) {
  jspb.Message.setProto3IntField(this, 22, value);
};


/**
 * optional string ResidentCity = 23;
 * @return {string}
 */
proto.xcommon.AccountProfileInfo.prototype.getResidentcity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 23, ""));
};


/** @param {string} value */
proto.xcommon.AccountProfileInfo.prototype.setResidentcity = function(value) {
  jspb.Message.setProto3StringField(this, 23, value);
};


/**
 * optional string ResidentState = 24;
 * @return {string}
 */
proto.xcommon.AccountProfileInfo.prototype.getResidentstate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 24, ""));
};


/** @param {string} value */
proto.xcommon.AccountProfileInfo.prototype.setResidentstate = function(value) {
  jspb.Message.setProto3StringField(this, 24, value);
};


/**
 * optional string ResidentAddress = 25;
 * @return {string}
 */
proto.xcommon.AccountProfileInfo.prototype.getResidentaddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 25, ""));
};


/** @param {string} value */
proto.xcommon.AccountProfileInfo.prototype.setResidentaddress = function(value) {
  jspb.Message.setProto3StringField(this, 25, value);
};


/**
 * optional string Pincode = 26;
 * @return {string}
 */
proto.xcommon.AccountProfileInfo.prototype.getPincode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 26, ""));
};


/** @param {string} value */
proto.xcommon.AccountProfileInfo.prototype.setPincode = function(value) {
  jspb.Message.setProto3StringField(this, 26, value);
};


/**
 * optional string SystemLanguage = 27;
 * @return {string}
 */
proto.xcommon.AccountProfileInfo.prototype.getSystemlanguage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 27, ""));
};


/** @param {string} value */
proto.xcommon.AccountProfileInfo.prototype.setSystemlanguage = function(value) {
  jspb.Message.setProto3StringField(this, 27, value);
};


/**
 * optional string Language = 28;
 * @return {string}
 */
proto.xcommon.AccountProfileInfo.prototype.getLanguage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 28, ""));
};


/** @param {string} value */
proto.xcommon.AccountProfileInfo.prototype.setLanguage = function(value) {
  jspb.Message.setProto3StringField(this, 28, value);
};


/**
 * optional string AppLanguage = 29;
 * @return {string}
 */
proto.xcommon.AccountProfileInfo.prototype.getApplanguage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 29, ""));
};


/** @param {string} value */
proto.xcommon.AccountProfileInfo.prototype.setApplanguage = function(value) {
  jspb.Message.setProto3StringField(this, 29, value);
};


/**
 * optional string BankName = 30;
 * @return {string}
 */
proto.xcommon.AccountProfileInfo.prototype.getBankname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 30, ""));
};


/** @param {string} value */
proto.xcommon.AccountProfileInfo.prototype.setBankname = function(value) {
  jspb.Message.setProto3StringField(this, 30, value);
};


/**
 * optional string BankNo = 31;
 * @return {string}
 */
proto.xcommon.AccountProfileInfo.prototype.getBankno = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 31, ""));
};


/** @param {string} value */
proto.xcommon.AccountProfileInfo.prototype.setBankno = function(value) {
  jspb.Message.setProto3StringField(this, 31, value);
};


/**
 * optional string RepayBankCode = 32;
 * @return {string}
 */
proto.xcommon.AccountProfileInfo.prototype.getRepaybankcode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 32, ""));
};


/** @param {string} value */
proto.xcommon.AccountProfileInfo.prototype.setRepaybankcode = function(value) {
  jspb.Message.setProto3StringField(this, 32, value);
};


/**
 * optional string IdPhotoQuality = 33;
 * @return {string}
 */
proto.xcommon.AccountProfileInfo.prototype.getIdphotoquality = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 33, ""));
};


/** @param {string} value */
proto.xcommon.AccountProfileInfo.prototype.setIdphotoquality = function(value) {
  jspb.Message.setProto3StringField(this, 33, value);
};


/**
 * optional string IdPhotoQualityThreshold = 34;
 * @return {string}
 */
proto.xcommon.AccountProfileInfo.prototype.getIdphotoqualitythreshold = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 34, ""));
};


/** @param {string} value */
proto.xcommon.AccountProfileInfo.prototype.setIdphotoqualitythreshold = function(value) {
  jspb.Message.setProto3StringField(this, 34, value);
};


/**
 * optional string HandPhotoQuality = 35;
 * @return {string}
 */
proto.xcommon.AccountProfileInfo.prototype.getHandphotoquality = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 35, ""));
};


/** @param {string} value */
proto.xcommon.AccountProfileInfo.prototype.setHandphotoquality = function(value) {
  jspb.Message.setProto3StringField(this, 35, value);
};


/**
 * optional string HandPhotoQualityThreshold = 36;
 * @return {string}
 */
proto.xcommon.AccountProfileInfo.prototype.getHandphotoqualitythreshold = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 36, ""));
};


/** @param {string} value */
proto.xcommon.AccountProfileInfo.prototype.setHandphotoqualitythreshold = function(value) {
  jspb.Message.setProto3StringField(this, 36, value);
};


/**
 * optional string FaceComparison = 37;
 * @return {string}
 */
proto.xcommon.AccountProfileInfo.prototype.getFacecomparison = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 37, ""));
};


/** @param {string} value */
proto.xcommon.AccountProfileInfo.prototype.setFacecomparison = function(value) {
  jspb.Message.setProto3StringField(this, 37, value);
};


/**
 * optional string FaceComparisonIhID = 38;
 * @return {string}
 */
proto.xcommon.AccountProfileInfo.prototype.getFacecomparisonihid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 38, ""));
};


/** @param {string} value */
proto.xcommon.AccountProfileInfo.prototype.setFacecomparisonihid = function(value) {
  jspb.Message.setProto3StringField(this, 38, value);
};


/**
 * optional string IdHoldingPhotoCheck = 39;
 * @return {string}
 */
proto.xcommon.AccountProfileInfo.prototype.getIdholdingphotocheck = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 39, ""));
};


/** @param {string} value */
proto.xcommon.AccountProfileInfo.prototype.setIdholdingphotocheck = function(value) {
  jspb.Message.setProto3StringField(this, 39, value);
};


/**
 * optional int32 BankVerification = 40;
 * @return {number}
 */
proto.xcommon.AccountProfileInfo.prototype.getBankverification = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 40, 0));
};


/** @param {number} value */
proto.xcommon.AccountProfileInfo.prototype.setBankverification = function(value) {
  jspb.Message.setProto3IntField(this, 40, value);
};


/**
 * optional string CompanyTelephone = 41;
 * @return {string}
 */
proto.xcommon.AccountProfileInfo.prototype.getCompanytelephone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 41, ""));
};


/** @param {string} value */
proto.xcommon.AccountProfileInfo.prototype.setCompanytelephone = function(value) {
  jspb.Message.setProto3StringField(this, 41, value);
};


/**
 * optional string SalaryDay = 42;
 * @return {string}
 */
proto.xcommon.AccountProfileInfo.prototype.getSalaryday = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 42, ""));
};


/** @param {string} value */
proto.xcommon.AccountProfileInfo.prototype.setSalaryday = function(value) {
  jspb.Message.setProto3StringField(this, 42, value);
};


/**
 * optional int64 Ctime = 43;
 * @return {number}
 */
proto.xcommon.AccountProfileInfo.prototype.getCtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 43, 0));
};


/** @param {number} value */
proto.xcommon.AccountProfileInfo.prototype.setCtime = function(value) {
  jspb.Message.setProto3IntField(this, 43, value);
};


/**
 * optional int64 Utime = 44;
 * @return {number}
 */
proto.xcommon.AccountProfileInfo.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 44, 0));
};


/** @param {number} value */
proto.xcommon.AccountProfileInfo.prototype.setUtime = function(value) {
  jspb.Message.setProto3IntField(this, 44, value);
};


/**
 * optional int64 DateOfBirth = 45;
 * @return {number}
 */
proto.xcommon.AccountProfileInfo.prototype.getDateofbirth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 45, 0));
};


/** @param {number} value */
proto.xcommon.AccountProfileInfo.prototype.setDateofbirth = function(value) {
  jspb.Message.setProto3IntField(this, 45, value);
};


/**
 * optional string IfscCode = 46;
 * @return {string}
 */
proto.xcommon.AccountProfileInfo.prototype.getIfsccode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 46, ""));
};


/** @param {string} value */
proto.xcommon.AccountProfileInfo.prototype.setIfsccode = function(value) {
  jspb.Message.setProto3StringField(this, 46, value);
};


/**
 * optional int64 PhotoAadhaarFront = 47;
 * @return {number}
 */
proto.xcommon.AccountProfileInfo.prototype.getPhotoaadhaarfront = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 47, 0));
};


/** @param {number} value */
proto.xcommon.AccountProfileInfo.prototype.setPhotoaadhaarfront = function(value) {
  jspb.Message.setProto3IntField(this, 47, value);
};


/**
 * optional int64 PhotoAadhaarBack = 48;
 * @return {number}
 */
proto.xcommon.AccountProfileInfo.prototype.getPhotoaadhaarback = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 48, 0));
};


/** @param {number} value */
proto.xcommon.AccountProfileInfo.prototype.setPhotoaadhaarback = function(value) {
  jspb.Message.setProto3IntField(this, 48, value);
};


/**
 * optional int32 AddressPhotoType = 49;
 * @return {number}
 */
proto.xcommon.AccountProfileInfo.prototype.getAddressphototype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 49, 0));
};


/** @param {number} value */
proto.xcommon.AccountProfileInfo.prototype.setAddressphototype = function(value) {
  jspb.Message.setProto3IntField(this, 49, value);
};


/**
 * optional int64 AddressPhotoUploadTime = 50;
 * @return {number}
 */
proto.xcommon.AccountProfileInfo.prototype.getAddressphotouploadtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 50, 0));
};


/** @param {number} value */
proto.xcommon.AccountProfileInfo.prototype.setAddressphotouploadtime = function(value) {
  jspb.Message.setProto3IntField(this, 50, value);
};


/**
 * optional string FamilyPhone = 51;
 * @return {string}
 */
proto.xcommon.AccountProfileInfo.prototype.getFamilyphone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 51, ""));
};


/** @param {string} value */
proto.xcommon.AccountProfileInfo.prototype.setFamilyphone = function(value) {
  jspb.Message.setProto3StringField(this, 51, value);
};


/**
 * optional int32 SalaryType = 52;
 * @return {number}
 */
proto.xcommon.AccountProfileInfo.prototype.getSalarytype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 52, 0));
};


/** @param {number} value */
proto.xcommon.AccountProfileInfo.prototype.setSalarytype = function(value) {
  jspb.Message.setProto3IntField(this, 52, value);
};


/**
 * optional string Contact3 = 53;
 * @return {string}
 */
proto.xcommon.AccountProfileInfo.prototype.getContact3 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 53, ""));
};


/** @param {string} value */
proto.xcommon.AccountProfileInfo.prototype.setContact3 = function(value) {
  jspb.Message.setProto3StringField(this, 53, value);
};


/**
 * optional string Contact3Name = 54;
 * @return {string}
 */
proto.xcommon.AccountProfileInfo.prototype.getContact3name = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 54, ""));
};


/** @param {string} value */
proto.xcommon.AccountProfileInfo.prototype.setContact3name = function(value) {
  jspb.Message.setProto3StringField(this, 54, value);
};


/**
 * optional int32 Relationship3 = 55;
 * @return {number}
 */
proto.xcommon.AccountProfileInfo.prototype.getRelationship3 = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 55, 0));
};


/** @param {number} value */
proto.xcommon.AccountProfileInfo.prototype.setRelationship3 = function(value) {
  jspb.Message.setProto3IntField(this, 55, value);
};


/**
 * optional string SpareMobile = 56;
 * @return {string}
 */
proto.xcommon.AccountProfileInfo.prototype.getSparemobile = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 56, ""));
};


/** @param {string} value */
proto.xcommon.AccountProfileInfo.prototype.setSparemobile = function(value) {
  jspb.Message.setProto3StringField(this, 56, value);
};


/**
 * map<string, string> Concat = 57;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.xcommon.AccountProfileInfo.prototype.getConcatMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 57, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 */
proto.xcommon.AccountProfileInfo.prototype.clearConcatMap = function() {
  this.getConcatMap().clear();
};


/**
 * optional string AppName = 58;
 * @return {string}
 */
proto.xcommon.AccountProfileInfo.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 58, ""));
};


/** @param {string} value */
proto.xcommon.AccountProfileInfo.prototype.setAppname = function(value) {
  jspb.Message.setProto3StringField(this, 58, value);
};


/**
 * map<string, string> CallLog = 59;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.xcommon.AccountProfileInfo.prototype.getCalllogMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 59, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 */
proto.xcommon.AccountProfileInfo.prototype.clearCalllogMap = function() {
  this.getCalllogMap().clear();
};


/**
 * repeated CallLog CallLogs = 60;
 * @return {!Array<!proto.xcommon.CallLog>}
 */
proto.xcommon.AccountProfileInfo.prototype.getCalllogsList = function() {
  return /** @type{!Array<!proto.xcommon.CallLog>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.CallLog, 60));
};


/** @param {!Array<!proto.xcommon.CallLog>} value */
proto.xcommon.AccountProfileInfo.prototype.setCalllogsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 60, value);
};


/**
 * @param {!proto.xcommon.CallLog=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.CallLog}
 */
proto.xcommon.AccountProfileInfo.prototype.addCalllogs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 60, opt_value, proto.xcommon.CallLog, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.AccountProfileInfo.prototype.clearCalllogsList = function() {
  this.setCalllogsList([]);
};


/**
 * repeated SmsLog SmsLog = 61;
 * @return {!Array<!proto.xcommon.SmsLog>}
 */
proto.xcommon.AccountProfileInfo.prototype.getSmslogList = function() {
  return /** @type{!Array<!proto.xcommon.SmsLog>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.SmsLog, 61));
};


/** @param {!Array<!proto.xcommon.SmsLog>} value */
proto.xcommon.AccountProfileInfo.prototype.setSmslogList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 61, value);
};


/**
 * @param {!proto.xcommon.SmsLog=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.SmsLog}
 */
proto.xcommon.AccountProfileInfo.prototype.addSmslog = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 61, opt_value, proto.xcommon.SmsLog, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.AccountProfileInfo.prototype.clearSmslogList = function() {
  this.setSmslogList([]);
};


/**
 * optional string Contact4 = 62;
 * @return {string}
 */
proto.xcommon.AccountProfileInfo.prototype.getContact4 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 62, ""));
};


/** @param {string} value */
proto.xcommon.AccountProfileInfo.prototype.setContact4 = function(value) {
  jspb.Message.setProto3StringField(this, 62, value);
};


/**
 * optional string Contact4Name = 63;
 * @return {string}
 */
proto.xcommon.AccountProfileInfo.prototype.getContact4name = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 63, ""));
};


/** @param {string} value */
proto.xcommon.AccountProfileInfo.prototype.setContact4name = function(value) {
  jspb.Message.setProto3StringField(this, 63, value);
};


/**
 * optional int32 Relationship4 = 64;
 * @return {number}
 */
proto.xcommon.AccountProfileInfo.prototype.getRelationship4 = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 64, 0));
};


/** @param {number} value */
proto.xcommon.AccountProfileInfo.prototype.setRelationship4 = function(value) {
  jspb.Message.setProto3IntField(this, 64, value);
};


/**
 * optional AccountWalletInfo CurrentWallet = 65;
 * @return {?proto.xcommon.AccountWalletInfo}
 */
proto.xcommon.AccountProfileInfo.prototype.getCurrentwallet = function() {
  return /** @type{?proto.xcommon.AccountWalletInfo} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.AccountWalletInfo, 65));
};


/** @param {?proto.xcommon.AccountWalletInfo|undefined} value */
proto.xcommon.AccountProfileInfo.prototype.setCurrentwallet = function(value) {
  jspb.Message.setWrapperField(this, 65, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.AccountProfileInfo.prototype.clearCurrentwallet = function() {
  this.setCurrentwallet(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.AccountProfileInfo.prototype.hasCurrentwallet = function() {
  return jspb.Message.getField(this, 65) != null;
};


/**
 * optional string HistoryWallets = 66;
 * @return {string}
 */
proto.xcommon.AccountProfileInfo.prototype.getHistorywallets = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 66, ""));
};


/** @param {string} value */
proto.xcommon.AccountProfileInfo.prototype.setHistorywallets = function(value) {
  jspb.Message.setProto3StringField(this, 66, value);
};


/**
 * optional string AppLogo = 67;
 * @return {string}
 */
proto.xcommon.AccountProfileInfo.prototype.getApplogo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 67, ""));
};


/** @param {string} value */
proto.xcommon.AccountProfileInfo.prototype.setApplogo = function(value) {
  jspb.Message.setProto3StringField(this, 67, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.AccountWalletInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.AccountWalletInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.AccountWalletInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.AccountWalletInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    walletname: jspb.Message.getFieldWithDefault(msg, 1, ""),
    walletno: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.AccountWalletInfo}
 */
proto.xcommon.AccountWalletInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.AccountWalletInfo;
  return proto.xcommon.AccountWalletInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.AccountWalletInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.AccountWalletInfo}
 */
proto.xcommon.AccountWalletInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setWalletname(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setWalletno(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.AccountWalletInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.AccountWalletInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.AccountWalletInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.AccountWalletInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWalletname();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getWalletno();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string WalletName = 1;
 * @return {string}
 */
proto.xcommon.AccountWalletInfo.prototype.getWalletname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.xcommon.AccountWalletInfo.prototype.setWalletname = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string WalletNo = 2;
 * @return {string}
 */
proto.xcommon.AccountWalletInfo.prototype.getWalletno = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.AccountWalletInfo.prototype.setWalletno = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.AccountSocialInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.AccountSocialInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.AccountSocialInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.AccountSocialInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    whatsapp: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.AccountSocialInfo}
 */
proto.xcommon.AccountSocialInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.AccountSocialInfo;
  return proto.xcommon.AccountSocialInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.AccountSocialInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.AccountSocialInfo}
 */
proto.xcommon.AccountSocialInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setWhatsapp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.AccountSocialInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.AccountSocialInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.AccountSocialInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.AccountSocialInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWhatsapp();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string WhatsApp = 1;
 * @return {string}
 */
proto.xcommon.AccountSocialInfo.prototype.getWhatsapp = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.xcommon.AccountSocialInfo.prototype.setWhatsapp = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.RepayPlanInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.RepayPlanInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.RepayPlanInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.RepayPlanInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    orderid: jspb.Message.getFieldWithDefault(msg, 2, "0"),
    overduedays: jspb.Message.getFieldWithDefault(msg, 3, 0),
    currentstageid: jspb.Message.getFieldWithDefault(msg, 4, 0),
    stagenum: jspb.Message.getFieldWithDefault(msg, 5, 0),
    amount: jspb.Message.getFieldWithDefault(msg, 6, 0),
    amountpayed: jspb.Message.getFieldWithDefault(msg, 7, 0),
    amountreduced: jspb.Message.getFieldWithDefault(msg, 8, 0),
    penalty: jspb.Message.getFieldWithDefault(msg, 20, 0),
    penaltypayed: jspb.Message.getFieldWithDefault(msg, 21, 0),
    penaltyreduced: jspb.Message.getFieldWithDefault(msg, 22, 0),
    repaydate: jspb.Message.getFieldWithDefault(msg, 25, 0),
    ctime: jspb.Message.getFieldWithDefault(msg, 26, 0),
    utime: jspb.Message.getFieldWithDefault(msg, 27, 0),
    extrafiled: jspb.Message.getFieldWithDefault(msg, 28, ""),
    cleartime: jspb.Message.getFieldWithDefault(msg, 29, 0),
    amountleftcanreduce: jspb.Message.getFieldWithDefault(msg, 30, 0),
    appname: jspb.Message.getFieldWithDefault(msg, 31, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.RepayPlanInfo}
 */
proto.xcommon.RepayPlanInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.RepayPlanInfo;
  return proto.xcommon.RepayPlanInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.RepayPlanInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.RepayPlanInfo}
 */
proto.xcommon.RepayPlanInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOverduedays(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCurrentstageid(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStagenum(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmount(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmountpayed(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmountreduced(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPenalty(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPenaltypayed(value);
      break;
    case 22:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPenaltyreduced(value);
      break;
    case 25:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRepaydate(value);
      break;
    case 26:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCtime(value);
      break;
    case 27:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUtime(value);
      break;
    case 28:
      var value = /** @type {string} */ (reader.readString());
      msg.setExtrafiled(value);
      break;
    case 29:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCleartime(value);
      break;
    case 30:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmountleftcanreduce(value);
      break;
    case 31:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.RepayPlanInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.RepayPlanInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.RepayPlanInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.RepayPlanInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      1,
      f
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      2,
      f
    );
  }
  f = message.getOverduedays();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getCurrentstageid();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getStagenum();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getAmount();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getAmountpayed();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getAmountreduced();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getPenalty();
  if (f !== 0) {
    writer.writeInt64(
      20,
      f
    );
  }
  f = message.getPenaltypayed();
  if (f !== 0) {
    writer.writeInt64(
      21,
      f
    );
  }
  f = message.getPenaltyreduced();
  if (f !== 0) {
    writer.writeInt64(
      22,
      f
    );
  }
  f = message.getRepaydate();
  if (f !== 0) {
    writer.writeInt64(
      25,
      f
    );
  }
  f = message.getCtime();
  if (f !== 0) {
    writer.writeInt64(
      26,
      f
    );
  }
  f = message.getUtime();
  if (f !== 0) {
    writer.writeInt64(
      27,
      f
    );
  }
  f = message.getExtrafiled();
  if (f.length > 0) {
    writer.writeString(
      28,
      f
    );
  }
  f = message.getCleartime();
  if (f !== 0) {
    writer.writeInt64(
      29,
      f
    );
  }
  f = message.getAmountleftcanreduce();
  if (f !== 0) {
    writer.writeInt64(
      30,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      31,
      f
    );
  }
};


/**
 * optional int64 Id = 1;
 * @return {string}
 */
proto.xcommon.RepayPlanInfo.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/** @param {string} value */
proto.xcommon.RepayPlanInfo.prototype.setId = function(value) {
  jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional int64 OrderId = 2;
 * @return {string}
 */
proto.xcommon.RepayPlanInfo.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/** @param {string} value */
proto.xcommon.RepayPlanInfo.prototype.setOrderid = function(value) {
  jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * optional int32 OverdueDays = 3;
 * @return {number}
 */
proto.xcommon.RepayPlanInfo.prototype.getOverduedays = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.RepayPlanInfo.prototype.setOverduedays = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 CurrentStageId = 4;
 * @return {number}
 */
proto.xcommon.RepayPlanInfo.prototype.getCurrentstageid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.RepayPlanInfo.prototype.setCurrentstageid = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 StageNum = 5;
 * @return {number}
 */
proto.xcommon.RepayPlanInfo.prototype.getStagenum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.RepayPlanInfo.prototype.setStagenum = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 Amount = 6;
 * @return {number}
 */
proto.xcommon.RepayPlanInfo.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.xcommon.RepayPlanInfo.prototype.setAmount = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 AmountPayed = 7;
 * @return {number}
 */
proto.xcommon.RepayPlanInfo.prototype.getAmountpayed = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.xcommon.RepayPlanInfo.prototype.setAmountpayed = function(value) {
  jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int64 AmountReduced = 8;
 * @return {number}
 */
proto.xcommon.RepayPlanInfo.prototype.getAmountreduced = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/** @param {number} value */
proto.xcommon.RepayPlanInfo.prototype.setAmountreduced = function(value) {
  jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int64 Penalty = 20;
 * @return {number}
 */
proto.xcommon.RepayPlanInfo.prototype.getPenalty = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/** @param {number} value */
proto.xcommon.RepayPlanInfo.prototype.setPenalty = function(value) {
  jspb.Message.setProto3IntField(this, 20, value);
};


/**
 * optional int64 PenaltyPayed = 21;
 * @return {number}
 */
proto.xcommon.RepayPlanInfo.prototype.getPenaltypayed = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};


/** @param {number} value */
proto.xcommon.RepayPlanInfo.prototype.setPenaltypayed = function(value) {
  jspb.Message.setProto3IntField(this, 21, value);
};


/**
 * optional int64 PenaltyReduced = 22;
 * @return {number}
 */
proto.xcommon.RepayPlanInfo.prototype.getPenaltyreduced = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 22, 0));
};


/** @param {number} value */
proto.xcommon.RepayPlanInfo.prototype.setPenaltyreduced = function(value) {
  jspb.Message.setProto3IntField(this, 22, value);
};


/**
 * optional int64 RepayDate = 25;
 * @return {number}
 */
proto.xcommon.RepayPlanInfo.prototype.getRepaydate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 25, 0));
};


/** @param {number} value */
proto.xcommon.RepayPlanInfo.prototype.setRepaydate = function(value) {
  jspb.Message.setProto3IntField(this, 25, value);
};


/**
 * optional int64 Ctime = 26;
 * @return {number}
 */
proto.xcommon.RepayPlanInfo.prototype.getCtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 26, 0));
};


/** @param {number} value */
proto.xcommon.RepayPlanInfo.prototype.setCtime = function(value) {
  jspb.Message.setProto3IntField(this, 26, value);
};


/**
 * optional int64 Utime = 27;
 * @return {number}
 */
proto.xcommon.RepayPlanInfo.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 27, 0));
};


/** @param {number} value */
proto.xcommon.RepayPlanInfo.prototype.setUtime = function(value) {
  jspb.Message.setProto3IntField(this, 27, value);
};


/**
 * optional string ExtraFiled = 28;
 * @return {string}
 */
proto.xcommon.RepayPlanInfo.prototype.getExtrafiled = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 28, ""));
};


/** @param {string} value */
proto.xcommon.RepayPlanInfo.prototype.setExtrafiled = function(value) {
  jspb.Message.setProto3StringField(this, 28, value);
};


/**
 * optional int64 ClearTime = 29;
 * @return {number}
 */
proto.xcommon.RepayPlanInfo.prototype.getCleartime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 29, 0));
};


/** @param {number} value */
proto.xcommon.RepayPlanInfo.prototype.setCleartime = function(value) {
  jspb.Message.setProto3IntField(this, 29, value);
};


/**
 * optional int64 AmountLeftCanReduce = 30;
 * @return {number}
 */
proto.xcommon.RepayPlanInfo.prototype.getAmountleftcanreduce = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 30, 0));
};


/** @param {number} value */
proto.xcommon.RepayPlanInfo.prototype.setAmountleftcanreduce = function(value) {
  jspb.Message.setProto3IntField(this, 30, value);
};


/**
 * optional string AppName = 31;
 * @return {string}
 */
proto.xcommon.RepayPlanInfo.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 31, ""));
};


/** @param {string} value */
proto.xcommon.RepayPlanInfo.prototype.setAppname = function(value) {
  jspb.Message.setProto3StringField(this, 31, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.AccountBaseInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.AccountBaseInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.AccountBaseInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.AccountBaseInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    mobile: jspb.Message.getFieldWithDefault(msg, 2, ""),
    gender: jspb.Message.getFieldWithDefault(msg, 5, 0),
    realname: jspb.Message.getFieldWithDefault(msg, 6, ""),
    identity: jspb.Message.getFieldWithDefault(msg, 10, ""),
    thirdprovince: jspb.Message.getFieldWithDefault(msg, 19, ""),
    thirdcity: jspb.Message.getFieldWithDefault(msg, 20, ""),
    thirddistrict: jspb.Message.getFieldWithDefault(msg, 21, ""),
    thirdvillage: jspb.Message.getFieldWithDefault(msg, 22, ""),
    status: jspb.Message.getFieldWithDefault(msg, 23, 0),
    email: jspb.Message.getFieldWithDefault(msg, 36, ""),
    ocraddress: jspb.Message.getFieldWithDefault(msg, 39, ""),
    pmdstatus: jspb.Message.getFieldWithDefault(msg, 40, ""),
    accountstatus: jspb.Message.getFieldWithDefault(msg, 41, ""),
    appname: jspb.Message.getFieldWithDefault(msg, 42, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.AccountBaseInfo}
 */
proto.xcommon.AccountBaseInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.AccountBaseInfo;
  return proto.xcommon.AccountBaseInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.AccountBaseInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.AccountBaseInfo}
 */
proto.xcommon.AccountBaseInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMobile(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setGender(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setRealname(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdentity(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setThirdprovince(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setThirdcity(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setThirddistrict(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readString());
      msg.setThirdvillage(value);
      break;
    case 23:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStatus(value);
      break;
    case 36:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 39:
      var value = /** @type {string} */ (reader.readString());
      msg.setOcraddress(value);
      break;
    case 40:
      var value = /** @type {string} */ (reader.readString());
      msg.setPmdstatus(value);
      break;
    case 41:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountstatus(value);
      break;
    case 42:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.AccountBaseInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.AccountBaseInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.AccountBaseInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.AccountBaseInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      1,
      f
    );
  }
  f = message.getMobile();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getGender();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getRealname();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getIdentity();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getThirdprovince();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getThirdcity();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getThirddistrict();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getThirdvillage();
  if (f.length > 0) {
    writer.writeString(
      22,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0) {
    writer.writeInt32(
      23,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      36,
      f
    );
  }
  f = message.getOcraddress();
  if (f.length > 0) {
    writer.writeString(
      39,
      f
    );
  }
  f = message.getPmdstatus();
  if (f.length > 0) {
    writer.writeString(
      40,
      f
    );
  }
  f = message.getAccountstatus();
  if (f.length > 0) {
    writer.writeString(
      41,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      42,
      f
    );
  }
};


/**
 * optional int64 Id = 1;
 * @return {string}
 */
proto.xcommon.AccountBaseInfo.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/** @param {string} value */
proto.xcommon.AccountBaseInfo.prototype.setId = function(value) {
  jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional string Mobile = 2;
 * @return {string}
 */
proto.xcommon.AccountBaseInfo.prototype.getMobile = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.AccountBaseInfo.prototype.setMobile = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 Gender = 5;
 * @return {number}
 */
proto.xcommon.AccountBaseInfo.prototype.getGender = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.AccountBaseInfo.prototype.setGender = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string Realname = 6;
 * @return {string}
 */
proto.xcommon.AccountBaseInfo.prototype.getRealname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.xcommon.AccountBaseInfo.prototype.setRealname = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string Identity = 10;
 * @return {string}
 */
proto.xcommon.AccountBaseInfo.prototype.getIdentity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/** @param {string} value */
proto.xcommon.AccountBaseInfo.prototype.setIdentity = function(value) {
  jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string ThirdProvince = 19;
 * @return {string}
 */
proto.xcommon.AccountBaseInfo.prototype.getThirdprovince = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/** @param {string} value */
proto.xcommon.AccountBaseInfo.prototype.setThirdprovince = function(value) {
  jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional string ThirdCity = 20;
 * @return {string}
 */
proto.xcommon.AccountBaseInfo.prototype.getThirdcity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/** @param {string} value */
proto.xcommon.AccountBaseInfo.prototype.setThirdcity = function(value) {
  jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional string ThirdDistrict = 21;
 * @return {string}
 */
proto.xcommon.AccountBaseInfo.prototype.getThirddistrict = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/** @param {string} value */
proto.xcommon.AccountBaseInfo.prototype.setThirddistrict = function(value) {
  jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional string ThirdVillage = 22;
 * @return {string}
 */
proto.xcommon.AccountBaseInfo.prototype.getThirdvillage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/** @param {string} value */
proto.xcommon.AccountBaseInfo.prototype.setThirdvillage = function(value) {
  jspb.Message.setProto3StringField(this, 22, value);
};


/**
 * optional int32 Status = 23;
 * @return {number}
 */
proto.xcommon.AccountBaseInfo.prototype.getStatus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 23, 0));
};


/** @param {number} value */
proto.xcommon.AccountBaseInfo.prototype.setStatus = function(value) {
  jspb.Message.setProto3IntField(this, 23, value);
};


/**
 * optional string Email = 36;
 * @return {string}
 */
proto.xcommon.AccountBaseInfo.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 36, ""));
};


/** @param {string} value */
proto.xcommon.AccountBaseInfo.prototype.setEmail = function(value) {
  jspb.Message.setProto3StringField(this, 36, value);
};


/**
 * optional string OcrAddress = 39;
 * @return {string}
 */
proto.xcommon.AccountBaseInfo.prototype.getOcraddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 39, ""));
};


/** @param {string} value */
proto.xcommon.AccountBaseInfo.prototype.setOcraddress = function(value) {
  jspb.Message.setProto3StringField(this, 39, value);
};


/**
 * optional string PMDStatus = 40;
 * @return {string}
 */
proto.xcommon.AccountBaseInfo.prototype.getPmdstatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 40, ""));
};


/** @param {string} value */
proto.xcommon.AccountBaseInfo.prototype.setPmdstatus = function(value) {
  jspb.Message.setProto3StringField(this, 40, value);
};


/**
 * optional string AccountStatus = 41;
 * @return {string}
 */
proto.xcommon.AccountBaseInfo.prototype.getAccountstatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 41, ""));
};


/** @param {string} value */
proto.xcommon.AccountBaseInfo.prototype.setAccountstatus = function(value) {
  jspb.Message.setProto3StringField(this, 41, value);
};


/**
 * optional string AppName = 42;
 * @return {string}
 */
proto.xcommon.AccountBaseInfo.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 42, ""));
};


/** @param {string} value */
proto.xcommon.AccountBaseInfo.prototype.setAppname = function(value) {
  jspb.Message.setProto3StringField(this, 42, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.EAccountNumberInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.EAccountNumberInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.EAccountNumberInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.EAccountNumberInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    eaccountnumber: jspb.Message.getFieldWithDefault(msg, 1, ""),
    vaaccountname: jspb.Message.getFieldWithDefault(msg, 2, ""),
    bankname: jspb.Message.getFieldWithDefault(msg, 3, ""),
    repaybankcode: jspb.Message.getFieldWithDefault(msg, 4, ""),
    bankbranchname: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.EAccountNumberInfo}
 */
proto.xcommon.EAccountNumberInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.EAccountNumberInfo;
  return proto.xcommon.EAccountNumberInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.EAccountNumberInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.EAccountNumberInfo}
 */
proto.xcommon.EAccountNumberInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEaccountnumber(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setVaaccountname(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setBankname(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setRepaybankcode(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setBankbranchname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.EAccountNumberInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.EAccountNumberInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.EAccountNumberInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.EAccountNumberInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEaccountnumber();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getVaaccountname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getBankname();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getRepaybankcode();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getBankbranchname();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string EAccountNumber = 1;
 * @return {string}
 */
proto.xcommon.EAccountNumberInfo.prototype.getEaccountnumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.xcommon.EAccountNumberInfo.prototype.setEaccountnumber = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string VaAccountName = 2;
 * @return {string}
 */
proto.xcommon.EAccountNumberInfo.prototype.getVaaccountname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.EAccountNumberInfo.prototype.setVaaccountname = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string BankName = 3;
 * @return {string}
 */
proto.xcommon.EAccountNumberInfo.prototype.getBankname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.EAccountNumberInfo.prototype.setBankname = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string RepayBankCode = 4;
 * @return {string}
 */
proto.xcommon.EAccountNumberInfo.prototype.getRepaybankcode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.EAccountNumberInfo.prototype.setRepaybankcode = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string BankBranchName = 5;
 * @return {string}
 */
proto.xcommon.EAccountNumberInfo.prototype.getBankbranchname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.xcommon.EAccountNumberInfo.prototype.setBankbranchname = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.CouponInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.CouponInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.CouponInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CouponInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    name: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.CouponInfo}
 */
proto.xcommon.CouponInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.CouponInfo;
  return proto.xcommon.CouponInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.CouponInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.CouponInfo}
 */
proto.xcommon.CouponInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.CouponInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.CouponInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.CouponInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CouponInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int64 Id = 1;
 * @return {number}
 */
proto.xcommon.CouponInfo.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.CouponInfo.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string Name = 2;
 * @return {string}
 */
proto.xcommon.CouponInfo.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.CouponInfo.prototype.setName = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.RepayPlanStageInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.RepayPlanStageInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.RepayPlanStageInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.RepayPlanStageInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    orderid: jspb.Message.getFieldWithDefault(msg, 2, "0"),
    stageindex: jspb.Message.getFieldWithDefault(msg, 3, 0),
    isclear: jspb.Message.getFieldWithDefault(msg, 4, 0),
    cleartime: jspb.Message.getFieldWithDefault(msg, 5, 0),
    overduedays: jspb.Message.getFieldWithDefault(msg, 6, 0),
    amount: jspb.Message.getFieldWithDefault(msg, 7, 0),
    amountpayed: jspb.Message.getFieldWithDefault(msg, 8, 0),
    amountreduced: jspb.Message.getFieldWithDefault(msg, 9, 0),
    penalty: jspb.Message.getFieldWithDefault(msg, 21, 0),
    penaltypayed: jspb.Message.getFieldWithDefault(msg, 22, 0),
    penaltyreduced: jspb.Message.getFieldWithDefault(msg, 23, 0),
    repaydate: jspb.Message.getFieldWithDefault(msg, 24, 0),
    ctime: jspb.Message.getFieldWithDefault(msg, 25, 0),
    utime: jspb.Message.getFieldWithDefault(msg, 26, 0),
    totalamount: jspb.Message.getFieldWithDefault(msg, 29, 0),
    totalpayedamount: jspb.Message.getFieldWithDefault(msg, 30, 0),
    totalreducedamount: jspb.Message.getFieldWithDefault(msg, 31, 0),
    totalleftamount: jspb.Message.getFieldWithDefault(msg, 32, 0),
    extrafiled: jspb.Message.getFieldWithDefault(msg, 33, ""),
    appname: jspb.Message.getFieldWithDefault(msg, 34, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.RepayPlanStageInfo}
 */
proto.xcommon.RepayPlanStageInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.RepayPlanStageInfo;
  return proto.xcommon.RepayPlanStageInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.RepayPlanStageInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.RepayPlanStageInfo}
 */
proto.xcommon.RepayPlanStageInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStageindex(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIsclear(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCleartime(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOverduedays(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmount(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmountpayed(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmountreduced(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPenalty(value);
      break;
    case 22:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPenaltypayed(value);
      break;
    case 23:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPenaltyreduced(value);
      break;
    case 24:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRepaydate(value);
      break;
    case 25:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCtime(value);
      break;
    case 26:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUtime(value);
      break;
    case 29:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalamount(value);
      break;
    case 30:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalpayedamount(value);
      break;
    case 31:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalreducedamount(value);
      break;
    case 32:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalleftamount(value);
      break;
    case 33:
      var value = /** @type {string} */ (reader.readString());
      msg.setExtrafiled(value);
      break;
    case 34:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.RepayPlanStageInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.RepayPlanStageInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.RepayPlanStageInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.RepayPlanStageInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      1,
      f
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      2,
      f
    );
  }
  f = message.getStageindex();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getIsclear();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getCleartime();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getOverduedays();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getAmount();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getAmountpayed();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getAmountreduced();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getPenalty();
  if (f !== 0) {
    writer.writeInt64(
      21,
      f
    );
  }
  f = message.getPenaltypayed();
  if (f !== 0) {
    writer.writeInt64(
      22,
      f
    );
  }
  f = message.getPenaltyreduced();
  if (f !== 0) {
    writer.writeInt64(
      23,
      f
    );
  }
  f = message.getRepaydate();
  if (f !== 0) {
    writer.writeInt64(
      24,
      f
    );
  }
  f = message.getCtime();
  if (f !== 0) {
    writer.writeInt64(
      25,
      f
    );
  }
  f = message.getUtime();
  if (f !== 0) {
    writer.writeInt64(
      26,
      f
    );
  }
  f = message.getTotalamount();
  if (f !== 0) {
    writer.writeInt64(
      29,
      f
    );
  }
  f = message.getTotalpayedamount();
  if (f !== 0) {
    writer.writeInt64(
      30,
      f
    );
  }
  f = message.getTotalreducedamount();
  if (f !== 0) {
    writer.writeInt64(
      31,
      f
    );
  }
  f = message.getTotalleftamount();
  if (f !== 0) {
    writer.writeInt64(
      32,
      f
    );
  }
  f = message.getExtrafiled();
  if (f.length > 0) {
    writer.writeString(
      33,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      34,
      f
    );
  }
};


/**
 * optional int64 Id = 1;
 * @return {string}
 */
proto.xcommon.RepayPlanStageInfo.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/** @param {string} value */
proto.xcommon.RepayPlanStageInfo.prototype.setId = function(value) {
  jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional int64 OrderId = 2;
 * @return {string}
 */
proto.xcommon.RepayPlanStageInfo.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/** @param {string} value */
proto.xcommon.RepayPlanStageInfo.prototype.setOrderid = function(value) {
  jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * optional int32 StageIndex = 3;
 * @return {number}
 */
proto.xcommon.RepayPlanStageInfo.prototype.getStageindex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.RepayPlanStageInfo.prototype.setStageindex = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 IsClear = 4;
 * @return {number}
 */
proto.xcommon.RepayPlanStageInfo.prototype.getIsclear = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.RepayPlanStageInfo.prototype.setIsclear = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 ClearTime = 5;
 * @return {number}
 */
proto.xcommon.RepayPlanStageInfo.prototype.getCleartime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.RepayPlanStageInfo.prototype.setCleartime = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 OverdueDays = 6;
 * @return {number}
 */
proto.xcommon.RepayPlanStageInfo.prototype.getOverduedays = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.xcommon.RepayPlanStageInfo.prototype.setOverduedays = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 Amount = 7;
 * @return {number}
 */
proto.xcommon.RepayPlanStageInfo.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.xcommon.RepayPlanStageInfo.prototype.setAmount = function(value) {
  jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int64 AmountPayed = 8;
 * @return {number}
 */
proto.xcommon.RepayPlanStageInfo.prototype.getAmountpayed = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/** @param {number} value */
proto.xcommon.RepayPlanStageInfo.prototype.setAmountpayed = function(value) {
  jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int64 AmountReduced = 9;
 * @return {number}
 */
proto.xcommon.RepayPlanStageInfo.prototype.getAmountreduced = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/** @param {number} value */
proto.xcommon.RepayPlanStageInfo.prototype.setAmountreduced = function(value) {
  jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int64 Penalty = 21;
 * @return {number}
 */
proto.xcommon.RepayPlanStageInfo.prototype.getPenalty = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};


/** @param {number} value */
proto.xcommon.RepayPlanStageInfo.prototype.setPenalty = function(value) {
  jspb.Message.setProto3IntField(this, 21, value);
};


/**
 * optional int64 PenaltyPayed = 22;
 * @return {number}
 */
proto.xcommon.RepayPlanStageInfo.prototype.getPenaltypayed = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 22, 0));
};


/** @param {number} value */
proto.xcommon.RepayPlanStageInfo.prototype.setPenaltypayed = function(value) {
  jspb.Message.setProto3IntField(this, 22, value);
};


/**
 * optional int64 PenaltyReduced = 23;
 * @return {number}
 */
proto.xcommon.RepayPlanStageInfo.prototype.getPenaltyreduced = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 23, 0));
};


/** @param {number} value */
proto.xcommon.RepayPlanStageInfo.prototype.setPenaltyreduced = function(value) {
  jspb.Message.setProto3IntField(this, 23, value);
};


/**
 * optional int64 RepayDate = 24;
 * @return {number}
 */
proto.xcommon.RepayPlanStageInfo.prototype.getRepaydate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 24, 0));
};


/** @param {number} value */
proto.xcommon.RepayPlanStageInfo.prototype.setRepaydate = function(value) {
  jspb.Message.setProto3IntField(this, 24, value);
};


/**
 * optional int64 Ctime = 25;
 * @return {number}
 */
proto.xcommon.RepayPlanStageInfo.prototype.getCtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 25, 0));
};


/** @param {number} value */
proto.xcommon.RepayPlanStageInfo.prototype.setCtime = function(value) {
  jspb.Message.setProto3IntField(this, 25, value);
};


/**
 * optional int64 Utime = 26;
 * @return {number}
 */
proto.xcommon.RepayPlanStageInfo.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 26, 0));
};


/** @param {number} value */
proto.xcommon.RepayPlanStageInfo.prototype.setUtime = function(value) {
  jspb.Message.setProto3IntField(this, 26, value);
};


/**
 * optional int64 TotalAmount = 29;
 * @return {number}
 */
proto.xcommon.RepayPlanStageInfo.prototype.getTotalamount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 29, 0));
};


/** @param {number} value */
proto.xcommon.RepayPlanStageInfo.prototype.setTotalamount = function(value) {
  jspb.Message.setProto3IntField(this, 29, value);
};


/**
 * optional int64 TotalPayedAmount = 30;
 * @return {number}
 */
proto.xcommon.RepayPlanStageInfo.prototype.getTotalpayedamount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 30, 0));
};


/** @param {number} value */
proto.xcommon.RepayPlanStageInfo.prototype.setTotalpayedamount = function(value) {
  jspb.Message.setProto3IntField(this, 30, value);
};


/**
 * optional int64 TotalReducedAmount = 31;
 * @return {number}
 */
proto.xcommon.RepayPlanStageInfo.prototype.getTotalreducedamount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 31, 0));
};


/** @param {number} value */
proto.xcommon.RepayPlanStageInfo.prototype.setTotalreducedamount = function(value) {
  jspb.Message.setProto3IntField(this, 31, value);
};


/**
 * optional int64 TotalLeftAmount = 32;
 * @return {number}
 */
proto.xcommon.RepayPlanStageInfo.prototype.getTotalleftamount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 32, 0));
};


/** @param {number} value */
proto.xcommon.RepayPlanStageInfo.prototype.setTotalleftamount = function(value) {
  jspb.Message.setProto3IntField(this, 32, value);
};


/**
 * optional string ExtraFiled = 33;
 * @return {string}
 */
proto.xcommon.RepayPlanStageInfo.prototype.getExtrafiled = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 33, ""));
};


/** @param {string} value */
proto.xcommon.RepayPlanStageInfo.prototype.setExtrafiled = function(value) {
  jspb.Message.setProto3StringField(this, 33, value);
};


/**
 * optional string AppName = 34;
 * @return {string}
 */
proto.xcommon.RepayPlanStageInfo.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 34, ""));
};


/** @param {string} value */
proto.xcommon.RepayPlanStageInfo.prototype.setAppname = function(value) {
  jspb.Message.setProto3StringField(this, 34, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.AccountAlternativeContactInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.AccountAlternativeContactInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.AccountAlternativeContactInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.AccountAlternativeContactInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    accountid: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    alternativenumber: jspb.Message.getFieldWithDefault(msg, 2, ""),
    alternativename: jspb.Message.getFieldWithDefault(msg, 3, ""),
    relationship: jspb.Message.getFieldWithDefault(msg, 4, 0),
    ctime: jspb.Message.getFieldWithDefault(msg, 5, 0),
    utime: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.AccountAlternativeContactInfo}
 */
proto.xcommon.AccountAlternativeContactInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.AccountAlternativeContactInfo;
  return proto.xcommon.AccountAlternativeContactInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.AccountAlternativeContactInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.AccountAlternativeContactInfo}
 */
proto.xcommon.AccountAlternativeContactInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setAccountid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAlternativenumber(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAlternativename(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRelationship(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCtime(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUtime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.AccountAlternativeContactInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.AccountAlternativeContactInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.AccountAlternativeContactInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.AccountAlternativeContactInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      1,
      f
    );
  }
  f = message.getAlternativenumber();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAlternativename();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getRelationship();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getCtime();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getUtime();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
};


/**
 * optional int64 AccountId = 1;
 * @return {string}
 */
proto.xcommon.AccountAlternativeContactInfo.prototype.getAccountid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/** @param {string} value */
proto.xcommon.AccountAlternativeContactInfo.prototype.setAccountid = function(value) {
  jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional string AlternativeNumber = 2;
 * @return {string}
 */
proto.xcommon.AccountAlternativeContactInfo.prototype.getAlternativenumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.AccountAlternativeContactInfo.prototype.setAlternativenumber = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string AlternativeName = 3;
 * @return {string}
 */
proto.xcommon.AccountAlternativeContactInfo.prototype.getAlternativename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.AccountAlternativeContactInfo.prototype.setAlternativename = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 Relationship = 4;
 * @return {number}
 */
proto.xcommon.AccountAlternativeContactInfo.prototype.getRelationship = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.AccountAlternativeContactInfo.prototype.setRelationship = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 Ctime = 5;
 * @return {number}
 */
proto.xcommon.AccountAlternativeContactInfo.prototype.getCtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.AccountAlternativeContactInfo.prototype.setCtime = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 Utime = 6;
 * @return {number}
 */
proto.xcommon.AccountAlternativeContactInfo.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.xcommon.AccountAlternativeContactInfo.prototype.setUtime = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.AutoCallResultInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.AutoCallResultInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.AutoCallResultInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.AutoCallResultInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    result: (f = msg.getResult()) && proto.xcommon.AutoCallCoreResult.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.AutoCallResultInfo}
 */
proto.xcommon.AutoCallResultInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.AutoCallResultInfo;
  return proto.xcommon.AutoCallResultInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.AutoCallResultInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.AutoCallResultInfo}
 */
proto.xcommon.AutoCallResultInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.xcommon.AutoCallCoreResult;
      reader.readMessage(value,proto.xcommon.AutoCallCoreResult.deserializeBinaryFromReader);
      msg.setResult(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.AutoCallResultInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.AutoCallResultInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.AutoCallResultInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.AutoCallResultInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getResult();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.xcommon.AutoCallCoreResult.serializeBinaryToWriter
    );
  }
};


/**
 * optional AutoCallCoreResult Result = 1;
 * @return {?proto.xcommon.AutoCallCoreResult}
 */
proto.xcommon.AutoCallResultInfo.prototype.getResult = function() {
  return /** @type{?proto.xcommon.AutoCallCoreResult} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.AutoCallCoreResult, 1));
};


/** @param {?proto.xcommon.AutoCallCoreResult|undefined} value */
proto.xcommon.AutoCallResultInfo.prototype.setResult = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.AutoCallResultInfo.prototype.clearResult = function() {
  this.setResult(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.AutoCallResultInfo.prototype.hasResult = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ReductionListParam.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ReductionListParam.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ReductionListParam} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ReductionListParam.toObject = function(includeInstance, msg) {
  var f, obj = {
    caseid: jspb.Message.getFieldWithDefault(msg, 1, 0),
    orderid: jspb.Message.getFieldWithDefault(msg, 2, "0"),
    useraccountid: jspb.Message.getFieldWithDefault(msg, 3, "0"),
    reducetype: jspb.Message.getFieldWithDefault(msg, 4, 0),
    reducestatus: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ReductionListParam}
 */
proto.xcommon.ReductionListParam.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ReductionListParam;
  return proto.xcommon.ReductionListParam.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ReductionListParam} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ReductionListParam}
 */
proto.xcommon.ReductionListParam.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCaseid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setUseraccountid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setReducetype(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setReducestatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ReductionListParam.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ReductionListParam.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ReductionListParam} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ReductionListParam.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCaseid();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      2,
      f
    );
  }
  f = message.getUseraccountid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      3,
      f
    );
  }
  f = message.getReducetype();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getReducestatus();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
};


/**
 * optional int64 CaseId = 1;
 * @return {number}
 */
proto.xcommon.ReductionListParam.prototype.getCaseid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.ReductionListParam.prototype.setCaseid = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 OrderId = 2;
 * @return {string}
 */
proto.xcommon.ReductionListParam.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/** @param {string} value */
proto.xcommon.ReductionListParam.prototype.setOrderid = function(value) {
  jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * optional int64 UserAccountId = 3;
 * @return {string}
 */
proto.xcommon.ReductionListParam.prototype.getUseraccountid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, "0"));
};


/** @param {string} value */
proto.xcommon.ReductionListParam.prototype.setUseraccountid = function(value) {
  jspb.Message.setProto3StringIntField(this, 3, value);
};


/**
 * optional int32 ReduceType = 4;
 * @return {number}
 */
proto.xcommon.ReductionListParam.prototype.getReducetype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.ReductionListParam.prototype.setReducetype = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 ReduceStatus = 5;
 * @return {number}
 */
proto.xcommon.ReductionListParam.prototype.getReducestatus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.ReductionListParam.prototype.setReducestatus = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ReduceRecordNew.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ReduceRecordNew.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ReduceRecordNew} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ReduceRecordNew.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    orderid: jspb.Message.getFieldWithDefault(msg, 2, "0"),
    useraccountid: jspb.Message.getFieldWithDefault(msg, 3, "0"),
    applyuid: jspb.Message.getFieldWithDefault(msg, 4, 0),
    confirmuid: jspb.Message.getFieldWithDefault(msg, 5, 0),
    amountreduced: jspb.Message.getFieldWithDefault(msg, 6, 0),
    penaltyreduced: jspb.Message.getFieldWithDefault(msg, 7, 0),
    graceinterestreduced: jspb.Message.getFieldWithDefault(msg, 8, 0),
    reducetype: jspb.Message.getFieldWithDefault(msg, 9, 0),
    reducestatus: jspb.Message.getFieldWithDefault(msg, 10, 0),
    opreason: jspb.Message.getFieldWithDefault(msg, 11, ""),
    confirmremark: jspb.Message.getFieldWithDefault(msg, 12, ""),
    applytime: jspb.Message.getFieldWithDefault(msg, 13, 0),
    confirmtime: jspb.Message.getFieldWithDefault(msg, 14, 0),
    caseid: jspb.Message.getFieldWithDefault(msg, 15, 0),
    derateratio: jspb.Message.getFloatingPointFieldWithDefault(msg, 16, 0.0),
    graceperiodinterestprededuced: jspb.Message.getFieldWithDefault(msg, 17, 0),
    penaltyprereduced: jspb.Message.getFieldWithDefault(msg, 18, 0),
    invalidreason: jspb.Message.getFieldWithDefault(msg, 19, ""),
    ctime: jspb.Message.getFieldWithDefault(msg, 20, 0),
    utime: jspb.Message.getFieldWithDefault(msg, 21, 0),
    appname: jspb.Message.getFieldWithDefault(msg, 22, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ReduceRecordNew}
 */
proto.xcommon.ReduceRecordNew.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ReduceRecordNew;
  return proto.xcommon.ReduceRecordNew.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ReduceRecordNew} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ReduceRecordNew}
 */
proto.xcommon.ReduceRecordNew.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setUseraccountid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setApplyuid(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setConfirmuid(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmountreduced(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPenaltyreduced(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setGraceinterestreduced(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setReducetype(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setReducestatus(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setOpreason(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setConfirmremark(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setApplytime(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setConfirmtime(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCaseid(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setDerateratio(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setGraceperiodinterestprededuced(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPenaltyprereduced(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setInvalidreason(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCtime(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUtime(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ReduceRecordNew.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ReduceRecordNew.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ReduceRecordNew} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ReduceRecordNew.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      2,
      f
    );
  }
  f = message.getUseraccountid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      3,
      f
    );
  }
  f = message.getApplyuid();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getConfirmuid();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getAmountreduced();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getPenaltyreduced();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getGraceinterestreduced();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getReducetype();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getReducestatus();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getOpreason();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getConfirmremark();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getApplytime();
  if (f !== 0) {
    writer.writeInt64(
      13,
      f
    );
  }
  f = message.getConfirmtime();
  if (f !== 0) {
    writer.writeInt64(
      14,
      f
    );
  }
  f = message.getCaseid();
  if (f !== 0) {
    writer.writeInt64(
      15,
      f
    );
  }
  f = message.getDerateratio();
  if (f !== 0.0) {
    writer.writeDouble(
      16,
      f
    );
  }
  f = message.getGraceperiodinterestprededuced();
  if (f !== 0) {
    writer.writeInt64(
      17,
      f
    );
  }
  f = message.getPenaltyprereduced();
  if (f !== 0) {
    writer.writeInt64(
      18,
      f
    );
  }
  f = message.getInvalidreason();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getCtime();
  if (f !== 0) {
    writer.writeInt64(
      20,
      f
    );
  }
  f = message.getUtime();
  if (f !== 0) {
    writer.writeInt64(
      21,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      22,
      f
    );
  }
};


/**
 * optional int64 Id = 1;
 * @return {number}
 */
proto.xcommon.ReduceRecordNew.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.ReduceRecordNew.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 OrderId = 2;
 * @return {string}
 */
proto.xcommon.ReduceRecordNew.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/** @param {string} value */
proto.xcommon.ReduceRecordNew.prototype.setOrderid = function(value) {
  jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * optional int64 UserAccountId = 3;
 * @return {string}
 */
proto.xcommon.ReduceRecordNew.prototype.getUseraccountid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, "0"));
};


/** @param {string} value */
proto.xcommon.ReduceRecordNew.prototype.setUseraccountid = function(value) {
  jspb.Message.setProto3StringIntField(this, 3, value);
};


/**
 * optional int64 ApplyUid = 4;
 * @return {number}
 */
proto.xcommon.ReduceRecordNew.prototype.getApplyuid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.ReduceRecordNew.prototype.setApplyuid = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 ConfirmUid = 5;
 * @return {number}
 */
proto.xcommon.ReduceRecordNew.prototype.getConfirmuid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.ReduceRecordNew.prototype.setConfirmuid = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 AmountReduced = 6;
 * @return {number}
 */
proto.xcommon.ReduceRecordNew.prototype.getAmountreduced = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.xcommon.ReduceRecordNew.prototype.setAmountreduced = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 PenaltyReduced = 7;
 * @return {number}
 */
proto.xcommon.ReduceRecordNew.prototype.getPenaltyreduced = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.xcommon.ReduceRecordNew.prototype.setPenaltyreduced = function(value) {
  jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int64 GraceInterestReduced = 8;
 * @return {number}
 */
proto.xcommon.ReduceRecordNew.prototype.getGraceinterestreduced = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/** @param {number} value */
proto.xcommon.ReduceRecordNew.prototype.setGraceinterestreduced = function(value) {
  jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int32 ReduceType = 9;
 * @return {number}
 */
proto.xcommon.ReduceRecordNew.prototype.getReducetype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/** @param {number} value */
proto.xcommon.ReduceRecordNew.prototype.setReducetype = function(value) {
  jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int32 ReduceStatus = 10;
 * @return {number}
 */
proto.xcommon.ReduceRecordNew.prototype.getReducestatus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/** @param {number} value */
proto.xcommon.ReduceRecordNew.prototype.setReducestatus = function(value) {
  jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional string OpReason = 11;
 * @return {string}
 */
proto.xcommon.ReduceRecordNew.prototype.getOpreason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/** @param {string} value */
proto.xcommon.ReduceRecordNew.prototype.setOpreason = function(value) {
  jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string ConfirmRemark = 12;
 * @return {string}
 */
proto.xcommon.ReduceRecordNew.prototype.getConfirmremark = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/** @param {string} value */
proto.xcommon.ReduceRecordNew.prototype.setConfirmremark = function(value) {
  jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional int64 ApplyTime = 13;
 * @return {number}
 */
proto.xcommon.ReduceRecordNew.prototype.getApplytime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/** @param {number} value */
proto.xcommon.ReduceRecordNew.prototype.setApplytime = function(value) {
  jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional int64 ConfirmTime = 14;
 * @return {number}
 */
proto.xcommon.ReduceRecordNew.prototype.getConfirmtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/** @param {number} value */
proto.xcommon.ReduceRecordNew.prototype.setConfirmtime = function(value) {
  jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional int64 CaseID = 15;
 * @return {number}
 */
proto.xcommon.ReduceRecordNew.prototype.getCaseid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/** @param {number} value */
proto.xcommon.ReduceRecordNew.prototype.setCaseid = function(value) {
  jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional double DerateRatio = 16;
 * @return {number}
 */
proto.xcommon.ReduceRecordNew.prototype.getDerateratio = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 16, 0.0));
};


/** @param {number} value */
proto.xcommon.ReduceRecordNew.prototype.setDerateratio = function(value) {
  jspb.Message.setProto3FloatField(this, 16, value);
};


/**
 * optional int64 GracePeriodInterestPrededuced = 17;
 * @return {number}
 */
proto.xcommon.ReduceRecordNew.prototype.getGraceperiodinterestprededuced = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/** @param {number} value */
proto.xcommon.ReduceRecordNew.prototype.setGraceperiodinterestprededuced = function(value) {
  jspb.Message.setProto3IntField(this, 17, value);
};


/**
 * optional int64 PenaltyPrereduced = 18;
 * @return {number}
 */
proto.xcommon.ReduceRecordNew.prototype.getPenaltyprereduced = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/** @param {number} value */
proto.xcommon.ReduceRecordNew.prototype.setPenaltyprereduced = function(value) {
  jspb.Message.setProto3IntField(this, 18, value);
};


/**
 * optional string InvalidReason = 19;
 * @return {string}
 */
proto.xcommon.ReduceRecordNew.prototype.getInvalidreason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/** @param {string} value */
proto.xcommon.ReduceRecordNew.prototype.setInvalidreason = function(value) {
  jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional int64 Ctime = 20;
 * @return {number}
 */
proto.xcommon.ReduceRecordNew.prototype.getCtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/** @param {number} value */
proto.xcommon.ReduceRecordNew.prototype.setCtime = function(value) {
  jspb.Message.setProto3IntField(this, 20, value);
};


/**
 * optional int64 Utime = 21;
 * @return {number}
 */
proto.xcommon.ReduceRecordNew.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};


/** @param {number} value */
proto.xcommon.ReduceRecordNew.prototype.setUtime = function(value) {
  jspb.Message.setProto3IntField(this, 21, value);
};


/**
 * optional string AppName = 22;
 * @return {string}
 */
proto.xcommon.ReduceRecordNew.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/** @param {string} value */
proto.xcommon.ReduceRecordNew.prototype.setAppname = function(value) {
  jspb.Message.setProto3StringField(this, 22, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ReduceRecordListItem.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ReduceRecordListItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ReduceRecordListItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ReduceRecordListItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    reducerecordnew: (f = msg.getReducerecordnew()) && proto.xcommon.ReduceRecordNew.toObject(includeInstance, f),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    mobile: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ReduceRecordListItem}
 */
proto.xcommon.ReduceRecordListItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ReduceRecordListItem;
  return proto.xcommon.ReduceRecordListItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ReduceRecordListItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ReduceRecordListItem}
 */
proto.xcommon.ReduceRecordListItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.xcommon.ReduceRecordNew;
      reader.readMessage(value,proto.xcommon.ReduceRecordNew.deserializeBinaryFromReader);
      msg.setReducerecordnew(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMobile(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ReduceRecordListItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ReduceRecordListItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ReduceRecordListItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ReduceRecordListItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReducerecordnew();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.xcommon.ReduceRecordNew.serializeBinaryToWriter
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMobile();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional ReduceRecordNew ReduceRecordNew = 1;
 * @return {?proto.xcommon.ReduceRecordNew}
 */
proto.xcommon.ReduceRecordListItem.prototype.getReducerecordnew = function() {
  return /** @type{?proto.xcommon.ReduceRecordNew} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.ReduceRecordNew, 1));
};


/** @param {?proto.xcommon.ReduceRecordNew|undefined} value */
proto.xcommon.ReduceRecordListItem.prototype.setReducerecordnew = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.ReduceRecordListItem.prototype.clearReducerecordnew = function() {
  this.setReducerecordnew(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.ReduceRecordListItem.prototype.hasReducerecordnew = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string Name = 2;
 * @return {string}
 */
proto.xcommon.ReduceRecordListItem.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.ReduceRecordListItem.prototype.setName = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Mobile = 3;
 * @return {string}
 */
proto.xcommon.ReduceRecordListItem.prototype.getMobile = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.ReduceRecordListItem.prototype.setMobile = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.CustomerDetailItem.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.CustomerDetailItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.CustomerDetailItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CustomerDetailItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    label: jspb.Message.getFieldWithDefault(msg, 1, ""),
    value: jspb.Message.getFieldWithDefault(msg, 2, ""),
    linkshowtype: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.CustomerDetailItem}
 */
proto.xcommon.CustomerDetailItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.CustomerDetailItem;
  return proto.xcommon.CustomerDetailItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.CustomerDetailItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.CustomerDetailItem}
 */
proto.xcommon.CustomerDetailItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabel(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    case 3:
      var value = /** @type {!proto.xcommon.URLLinkShowType} */ (reader.readEnum());
      msg.setLinkshowtype(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.CustomerDetailItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.CustomerDetailItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.CustomerDetailItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CustomerDetailItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLabel();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLinkshowtype();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional string Label = 1;
 * @return {string}
 */
proto.xcommon.CustomerDetailItem.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.xcommon.CustomerDetailItem.prototype.setLabel = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Value = 2;
 * @return {string}
 */
proto.xcommon.CustomerDetailItem.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.CustomerDetailItem.prototype.setValue = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional URLLinkShowType LinkShowType = 3;
 * @return {!proto.xcommon.URLLinkShowType}
 */
proto.xcommon.CustomerDetailItem.prototype.getLinkshowtype = function() {
  return /** @type {!proto.xcommon.URLLinkShowType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {!proto.xcommon.URLLinkShowType} value */
proto.xcommon.CustomerDetailItem.prototype.setLinkshowtype = function(value) {
  jspb.Message.setProto3EnumField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.CustomerDetailSection.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.CustomerDetailSection.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.CustomerDetailSection.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.CustomerDetailSection} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CustomerDetailSection.toObject = function(includeInstance, msg) {
  var f, obj = {
    title: jspb.Message.getFieldWithDefault(msg, 1, ""),
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.xcommon.CustomerDetailItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.CustomerDetailSection}
 */
proto.xcommon.CustomerDetailSection.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.CustomerDetailSection;
  return proto.xcommon.CustomerDetailSection.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.CustomerDetailSection} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.CustomerDetailSection}
 */
proto.xcommon.CustomerDetailSection.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 2:
      var value = new proto.xcommon.CustomerDetailItem;
      reader.readMessage(value,proto.xcommon.CustomerDetailItem.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.CustomerDetailSection.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.CustomerDetailSection.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.CustomerDetailSection} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CustomerDetailSection.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.xcommon.CustomerDetailItem.serializeBinaryToWriter
    );
  }
};


/**
 * optional string Title = 1;
 * @return {string}
 */
proto.xcommon.CustomerDetailSection.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.xcommon.CustomerDetailSection.prototype.setTitle = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated CustomerDetailItem Items = 2;
 * @return {!Array<!proto.xcommon.CustomerDetailItem>}
 */
proto.xcommon.CustomerDetailSection.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.xcommon.CustomerDetailItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.CustomerDetailItem, 2));
};


/** @param {!Array<!proto.xcommon.CustomerDetailItem>} value */
proto.xcommon.CustomerDetailSection.prototype.setItemsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.xcommon.CustomerDetailItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.CustomerDetailItem}
 */
proto.xcommon.CustomerDetailSection.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.xcommon.CustomerDetailItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.CustomerDetailSection.prototype.clearItemsList = function() {
  this.setItemsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.CustomerDetailTab.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.CustomerDetailTab.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.CustomerDetailTab.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.CustomerDetailTab} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CustomerDetailTab.toObject = function(includeInstance, msg) {
  var f, obj = {
    tabname: jspb.Message.getFieldWithDefault(msg, 1, ""),
    sectionsList: jspb.Message.toObjectList(msg.getSectionsList(),
    proto.xcommon.CustomerDetailSection.toObject, includeInstance),
    appname: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.CustomerDetailTab}
 */
proto.xcommon.CustomerDetailTab.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.CustomerDetailTab;
  return proto.xcommon.CustomerDetailTab.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.CustomerDetailTab} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.CustomerDetailTab}
 */
proto.xcommon.CustomerDetailTab.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTabname(value);
      break;
    case 2:
      var value = new proto.xcommon.CustomerDetailSection;
      reader.readMessage(value,proto.xcommon.CustomerDetailSection.deserializeBinaryFromReader);
      msg.addSections(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.CustomerDetailTab.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.CustomerDetailTab.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.CustomerDetailTab} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CustomerDetailTab.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTabname();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSectionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.xcommon.CustomerDetailSection.serializeBinaryToWriter
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string TabName = 1;
 * @return {string}
 */
proto.xcommon.CustomerDetailTab.prototype.getTabname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.xcommon.CustomerDetailTab.prototype.setTabname = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated CustomerDetailSection Sections = 2;
 * @return {!Array<!proto.xcommon.CustomerDetailSection>}
 */
proto.xcommon.CustomerDetailTab.prototype.getSectionsList = function() {
  return /** @type{!Array<!proto.xcommon.CustomerDetailSection>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.CustomerDetailSection, 2));
};


/** @param {!Array<!proto.xcommon.CustomerDetailSection>} value */
proto.xcommon.CustomerDetailTab.prototype.setSectionsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.xcommon.CustomerDetailSection=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.CustomerDetailSection}
 */
proto.xcommon.CustomerDetailTab.prototype.addSections = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.xcommon.CustomerDetailSection, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.CustomerDetailTab.prototype.clearSectionsList = function() {
  this.setSectionsList([]);
};


/**
 * optional string AppName = 3;
 * @return {string}
 */
proto.xcommon.CustomerDetailTab.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.CustomerDetailTab.prototype.setAppname = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.AccountLoanHistory.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.AccountLoanHistory.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.AccountLoanHistory} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.AccountLoanHistory.toObject = function(includeInstance, msg) {
  var f, obj = {
    orderid: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    preorder: jspb.Message.getFieldWithDefault(msg, 2, "0"),
    accountid: jspb.Message.getFieldWithDefault(msg, 3, "0"),
    realname: jspb.Message.getFieldWithDefault(msg, 4, ""),
    amount: jspb.Message.getFieldWithDefault(msg, 5, 0),
    loan: jspb.Message.getFieldWithDefault(msg, 6, 0),
    isreloan: jspb.Message.getFieldWithDefault(msg, 7, 0),
    period: jspb.Message.getFieldWithDefault(msg, 8, 0),
    checkstatus: jspb.Message.getFieldWithDefault(msg, 9, 0),
    riskctlstatus: jspb.Message.getFieldWithDefault(msg, 10, 0),
    riskctlfinishtime: jspb.Message.getFieldWithDefault(msg, 11, 0),
    phoneverifytime: jspb.Message.getFieldWithDefault(msg, 12, 0),
    riskctlregular: jspb.Message.getFieldWithDefault(msg, 13, ""),
    checktime: jspb.Message.getFieldWithDefault(msg, 14, 0),
    applytime: jspb.Message.getFieldWithDefault(msg, 15, 0),
    randomvalue: jspb.Message.getFieldWithDefault(msg, 16, 0),
    fixedrandom: jspb.Message.getFieldWithDefault(msg, 17, 0),
    loantime: jspb.Message.getFieldWithDefault(msg, 18, 0),
    finishtime: jspb.Message.getFieldWithDefault(msg, 19, 0),
    opuid: jspb.Message.getFieldWithDefault(msg, 20, 0),
    loanstatus: jspb.Message.getFieldWithDefault(msg, 21, ""),
    appname: jspb.Message.getFieldWithDefault(msg, 22, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.AccountLoanHistory}
 */
proto.xcommon.AccountLoanHistory.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.AccountLoanHistory;
  return proto.xcommon.AccountLoanHistory.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.AccountLoanHistory} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.AccountLoanHistory}
 */
proto.xcommon.AccountLoanHistory.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setPreorder(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setAccountid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setRealname(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmount(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLoan(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIsreloan(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPeriod(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCheckstatus(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRiskctlstatus(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRiskctlfinishtime(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPhoneverifytime(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setRiskctlregular(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setChecktime(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setApplytime(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRandomvalue(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFixedrandom(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLoantime(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setFinishtime(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOpuid(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setLoanstatus(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.AccountLoanHistory.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.AccountLoanHistory.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.AccountLoanHistory} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.AccountLoanHistory.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      1,
      f
    );
  }
  f = message.getPreorder();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      2,
      f
    );
  }
  f = message.getAccountid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      3,
      f
    );
  }
  f = message.getRealname();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAmount();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getLoan();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getIsreloan();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getPeriod();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getCheckstatus();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getRiskctlstatus();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getRiskctlfinishtime();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
  f = message.getPhoneverifytime();
  if (f !== 0) {
    writer.writeInt64(
      12,
      f
    );
  }
  f = message.getRiskctlregular();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getChecktime();
  if (f !== 0) {
    writer.writeInt64(
      14,
      f
    );
  }
  f = message.getApplytime();
  if (f !== 0) {
    writer.writeInt64(
      15,
      f
    );
  }
  f = message.getRandomvalue();
  if (f !== 0) {
    writer.writeInt32(
      16,
      f
    );
  }
  f = message.getFixedrandom();
  if (f !== 0) {
    writer.writeInt32(
      17,
      f
    );
  }
  f = message.getLoantime();
  if (f !== 0) {
    writer.writeInt64(
      18,
      f
    );
  }
  f = message.getFinishtime();
  if (f !== 0) {
    writer.writeInt64(
      19,
      f
    );
  }
  f = message.getOpuid();
  if (f !== 0) {
    writer.writeInt64(
      20,
      f
    );
  }
  f = message.getLoanstatus();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      22,
      f
    );
  }
};


/**
 * optional int64 OrderId = 1;
 * @return {string}
 */
proto.xcommon.AccountLoanHistory.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/** @param {string} value */
proto.xcommon.AccountLoanHistory.prototype.setOrderid = function(value) {
  jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional int64 PreOrder = 2;
 * @return {string}
 */
proto.xcommon.AccountLoanHistory.prototype.getPreorder = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/** @param {string} value */
proto.xcommon.AccountLoanHistory.prototype.setPreorder = function(value) {
  jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * optional int64 AccountId = 3;
 * @return {string}
 */
proto.xcommon.AccountLoanHistory.prototype.getAccountid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, "0"));
};


/** @param {string} value */
proto.xcommon.AccountLoanHistory.prototype.setAccountid = function(value) {
  jspb.Message.setProto3StringIntField(this, 3, value);
};


/**
 * optional string Realname = 4;
 * @return {string}
 */
proto.xcommon.AccountLoanHistory.prototype.getRealname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.AccountLoanHistory.prototype.setRealname = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int64 Amount = 5;
 * @return {number}
 */
proto.xcommon.AccountLoanHistory.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.AccountLoanHistory.prototype.setAmount = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 Loan = 6;
 * @return {number}
 */
proto.xcommon.AccountLoanHistory.prototype.getLoan = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.xcommon.AccountLoanHistory.prototype.setLoan = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 IsReloan = 7;
 * @return {number}
 */
proto.xcommon.AccountLoanHistory.prototype.getIsreloan = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.xcommon.AccountLoanHistory.prototype.setIsreloan = function(value) {
  jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int32 Period = 8;
 * @return {number}
 */
proto.xcommon.AccountLoanHistory.prototype.getPeriod = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/** @param {number} value */
proto.xcommon.AccountLoanHistory.prototype.setPeriod = function(value) {
  jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int32 CheckStatus = 9;
 * @return {number}
 */
proto.xcommon.AccountLoanHistory.prototype.getCheckstatus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/** @param {number} value */
proto.xcommon.AccountLoanHistory.prototype.setCheckstatus = function(value) {
  jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int32 RiskCtlStatus = 10;
 * @return {number}
 */
proto.xcommon.AccountLoanHistory.prototype.getRiskctlstatus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/** @param {number} value */
proto.xcommon.AccountLoanHistory.prototype.setRiskctlstatus = function(value) {
  jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int64 RiskCtlFinishTime = 11;
 * @return {number}
 */
proto.xcommon.AccountLoanHistory.prototype.getRiskctlfinishtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/** @param {number} value */
proto.xcommon.AccountLoanHistory.prototype.setRiskctlfinishtime = function(value) {
  jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional int64 PhoneVerifyTime = 12;
 * @return {number}
 */
proto.xcommon.AccountLoanHistory.prototype.getPhoneverifytime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/** @param {number} value */
proto.xcommon.AccountLoanHistory.prototype.setPhoneverifytime = function(value) {
  jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional string RiskCtlRegular = 13;
 * @return {string}
 */
proto.xcommon.AccountLoanHistory.prototype.getRiskctlregular = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/** @param {string} value */
proto.xcommon.AccountLoanHistory.prototype.setRiskctlregular = function(value) {
  jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional int64 CheckTime = 14;
 * @return {number}
 */
proto.xcommon.AccountLoanHistory.prototype.getChecktime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/** @param {number} value */
proto.xcommon.AccountLoanHistory.prototype.setChecktime = function(value) {
  jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional int64 ApplyTime = 15;
 * @return {number}
 */
proto.xcommon.AccountLoanHistory.prototype.getApplytime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/** @param {number} value */
proto.xcommon.AccountLoanHistory.prototype.setApplytime = function(value) {
  jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional int32 RandomValue = 16;
 * @return {number}
 */
proto.xcommon.AccountLoanHistory.prototype.getRandomvalue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/** @param {number} value */
proto.xcommon.AccountLoanHistory.prototype.setRandomvalue = function(value) {
  jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional int32 FixedRandom = 17;
 * @return {number}
 */
proto.xcommon.AccountLoanHistory.prototype.getFixedrandom = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/** @param {number} value */
proto.xcommon.AccountLoanHistory.prototype.setFixedrandom = function(value) {
  jspb.Message.setProto3IntField(this, 17, value);
};


/**
 * optional int64 LoanTime = 18;
 * @return {number}
 */
proto.xcommon.AccountLoanHistory.prototype.getLoantime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/** @param {number} value */
proto.xcommon.AccountLoanHistory.prototype.setLoantime = function(value) {
  jspb.Message.setProto3IntField(this, 18, value);
};


/**
 * optional int64 FinishTime = 19;
 * @return {number}
 */
proto.xcommon.AccountLoanHistory.prototype.getFinishtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/** @param {number} value */
proto.xcommon.AccountLoanHistory.prototype.setFinishtime = function(value) {
  jspb.Message.setProto3IntField(this, 19, value);
};


/**
 * optional int64 OpUid = 20;
 * @return {number}
 */
proto.xcommon.AccountLoanHistory.prototype.getOpuid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/** @param {number} value */
proto.xcommon.AccountLoanHistory.prototype.setOpuid = function(value) {
  jspb.Message.setProto3IntField(this, 20, value);
};


/**
 * optional string LoanStatus = 21;
 * @return {string}
 */
proto.xcommon.AccountLoanHistory.prototype.getLoanstatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/** @param {string} value */
proto.xcommon.AccountLoanHistory.prototype.setLoanstatus = function(value) {
  jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional string AppName = 22;
 * @return {string}
 */
proto.xcommon.AccountLoanHistory.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/** @param {string} value */
proto.xcommon.AccountLoanHistory.prototype.setAppname = function(value) {
  jspb.Message.setProto3StringField(this, 22, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.AccountLoanHistoryBackend.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.AccountLoanHistoryBackend.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.AccountLoanHistoryBackend} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.AccountLoanHistoryBackend.toObject = function(includeInstance, msg) {
  var f, obj = {
    orderid: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    amount: jspb.Message.getFieldWithDefault(msg, 2, 0),
    loanperiod: jspb.Message.getFieldWithDefault(msg, 3, 0),
    loanstatus: jspb.Message.getFieldWithDefault(msg, 4, ""),
    applytime: jspb.Message.getFieldWithDefault(msg, 5, 0),
    checktime: jspb.Message.getFieldWithDefault(msg, 6, 0),
    loantime: jspb.Message.getFieldWithDefault(msg, 7, 0),
    finishtime: jspb.Message.getFieldWithDefault(msg, 8, 0),
    overduedays: jspb.Message.getFieldWithDefault(msg, 9, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.AccountLoanHistoryBackend}
 */
proto.xcommon.AccountLoanHistoryBackend.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.AccountLoanHistoryBackend;
  return proto.xcommon.AccountLoanHistoryBackend.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.AccountLoanHistoryBackend} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.AccountLoanHistoryBackend}
 */
proto.xcommon.AccountLoanHistoryBackend.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmount(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLoanperiod(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setLoanstatus(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setApplytime(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setChecktime(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLoantime(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setFinishtime(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOverduedays(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.AccountLoanHistoryBackend.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.AccountLoanHistoryBackend.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.AccountLoanHistoryBackend} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.AccountLoanHistoryBackend.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      1,
      f
    );
  }
  f = message.getAmount();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getLoanperiod();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getLoanstatus();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getApplytime();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getChecktime();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getLoantime();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getFinishtime();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getOverduedays();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
};


/**
 * optional int64 OrderId = 1;
 * @return {string}
 */
proto.xcommon.AccountLoanHistoryBackend.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/** @param {string} value */
proto.xcommon.AccountLoanHistoryBackend.prototype.setOrderid = function(value) {
  jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional int64 Amount = 2;
 * @return {number}
 */
proto.xcommon.AccountLoanHistoryBackend.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.AccountLoanHistoryBackend.prototype.setAmount = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 LoanPeriod = 3;
 * @return {number}
 */
proto.xcommon.AccountLoanHistoryBackend.prototype.getLoanperiod = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.AccountLoanHistoryBackend.prototype.setLoanperiod = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string LoanStatus = 4;
 * @return {string}
 */
proto.xcommon.AccountLoanHistoryBackend.prototype.getLoanstatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.AccountLoanHistoryBackend.prototype.setLoanstatus = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int64 ApplyTime = 5;
 * @return {number}
 */
proto.xcommon.AccountLoanHistoryBackend.prototype.getApplytime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.AccountLoanHistoryBackend.prototype.setApplytime = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 CheckTime = 6;
 * @return {number}
 */
proto.xcommon.AccountLoanHistoryBackend.prototype.getChecktime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.xcommon.AccountLoanHistoryBackend.prototype.setChecktime = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 LoanTime = 7;
 * @return {number}
 */
proto.xcommon.AccountLoanHistoryBackend.prototype.getLoantime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.xcommon.AccountLoanHistoryBackend.prototype.setLoantime = function(value) {
  jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int64 FinishTime = 8;
 * @return {number}
 */
proto.xcommon.AccountLoanHistoryBackend.prototype.getFinishtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/** @param {number} value */
proto.xcommon.AccountLoanHistoryBackend.prototype.setFinishtime = function(value) {
  jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int32 OverdueDays = 9;
 * @return {number}
 */
proto.xcommon.AccountLoanHistoryBackend.prototype.getOverduedays = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/** @param {number} value */
proto.xcommon.AccountLoanHistoryBackend.prototype.setOverduedays = function(value) {
  jspb.Message.setProto3IntField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.AccountBillHistory.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.AccountBillHistory.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.AccountBillHistory} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.AccountBillHistory.toObject = function(includeInstance, msg) {
  var f, obj = {
    billid: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    billday: jspb.Message.getFieldWithDefault(msg, 2, 0),
    remainingamount: jspb.Message.getFieldWithDefault(msg, 3, 0),
    shipmentamount: jspb.Message.getFieldWithDefault(msg, 4, 0),
    minirepaymentamount: jspb.Message.getFieldWithDefault(msg, 5, 0),
    repaymentamount: jspb.Message.getFieldWithDefault(msg, 6, 0),
    lastrepaymentday: jspb.Message.getFieldWithDefault(msg, 7, 0),
    finalrepaymentday: jspb.Message.getFieldWithDefault(msg, 8, 0),
    finalaging: jspb.Message.getFieldWithDefault(msg, 9, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.AccountBillHistory}
 */
proto.xcommon.AccountBillHistory.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.AccountBillHistory;
  return proto.xcommon.AccountBillHistory.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.AccountBillHistory} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.AccountBillHistory}
 */
proto.xcommon.AccountBillHistory.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setBillid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBillday(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRemainingamount(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setShipmentamount(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMinirepaymentamount(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRepaymentamount(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLastrepaymentday(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setFinalrepaymentday(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setFinalaging(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.AccountBillHistory.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.AccountBillHistory.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.AccountBillHistory} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.AccountBillHistory.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBillid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      1,
      f
    );
  }
  f = message.getBillday();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getRemainingamount();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getShipmentamount();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getMinirepaymentamount();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getRepaymentamount();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getLastrepaymentday();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getFinalrepaymentday();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getFinalaging();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
};


/**
 * optional int64 BillId = 1;
 * @return {string}
 */
proto.xcommon.AccountBillHistory.prototype.getBillid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/** @param {string} value */
proto.xcommon.AccountBillHistory.prototype.setBillid = function(value) {
  jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional int64 BillDay = 2;
 * @return {number}
 */
proto.xcommon.AccountBillHistory.prototype.getBillday = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.AccountBillHistory.prototype.setBillday = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 RemainingAmount = 3;
 * @return {number}
 */
proto.xcommon.AccountBillHistory.prototype.getRemainingamount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.AccountBillHistory.prototype.setRemainingamount = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 ShipmentAmount = 4;
 * @return {number}
 */
proto.xcommon.AccountBillHistory.prototype.getShipmentamount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.AccountBillHistory.prototype.setShipmentamount = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 MiniRepaymentAmount = 5;
 * @return {number}
 */
proto.xcommon.AccountBillHistory.prototype.getMinirepaymentamount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.AccountBillHistory.prototype.setMinirepaymentamount = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 RepaymentAmount = 6;
 * @return {number}
 */
proto.xcommon.AccountBillHistory.prototype.getRepaymentamount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.xcommon.AccountBillHistory.prototype.setRepaymentamount = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 LastRepaymentDay = 7;
 * @return {number}
 */
proto.xcommon.AccountBillHistory.prototype.getLastrepaymentday = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.xcommon.AccountBillHistory.prototype.setLastrepaymentday = function(value) {
  jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int64 FinalRepaymentDay = 8;
 * @return {number}
 */
proto.xcommon.AccountBillHistory.prototype.getFinalrepaymentday = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/** @param {number} value */
proto.xcommon.AccountBillHistory.prototype.setFinalrepaymentday = function(value) {
  jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional string FinalAging = 9;
 * @return {string}
 */
proto.xcommon.AccountBillHistory.prototype.getFinalaging = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/** @param {string} value */
proto.xcommon.AccountBillHistory.prototype.setFinalaging = function(value) {
  jspb.Message.setProto3StringField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.AccountChangeLog.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.AccountChangeLog.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.AccountChangeLog} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.AccountChangeLog.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    accountid: jspb.Message.getFieldWithDefault(msg, 2, "0"),
    recordtype: jspb.Message.getFieldWithDefault(msg, 3, ""),
    original: jspb.Message.getFieldWithDefault(msg, 4, ""),
    edit: jspb.Message.getFieldWithDefault(msg, 5, ""),
    opuid: jspb.Message.getFieldWithDefault(msg, 6, 0),
    ctime: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.AccountChangeLog}
 */
proto.xcommon.AccountChangeLog.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.AccountChangeLog;
  return proto.xcommon.AccountChangeLog.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.AccountChangeLog} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.AccountChangeLog}
 */
proto.xcommon.AccountChangeLog.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setAccountid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRecordtype(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setOriginal(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setEdit(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOpuid(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCtime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.AccountChangeLog.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.AccountChangeLog.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.AccountChangeLog} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.AccountChangeLog.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getAccountid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      2,
      f
    );
  }
  f = message.getRecordtype();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getOriginal();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getEdit();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getOpuid();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getCtime();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
};


/**
 * optional int64 Id = 1;
 * @return {number}
 */
proto.xcommon.AccountChangeLog.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.AccountChangeLog.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 AccountId = 2;
 * @return {string}
 */
proto.xcommon.AccountChangeLog.prototype.getAccountid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/** @param {string} value */
proto.xcommon.AccountChangeLog.prototype.setAccountid = function(value) {
  jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * optional string RecordType = 3;
 * @return {string}
 */
proto.xcommon.AccountChangeLog.prototype.getRecordtype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.AccountChangeLog.prototype.setRecordtype = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string Original = 4;
 * @return {string}
 */
proto.xcommon.AccountChangeLog.prototype.getOriginal = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.AccountChangeLog.prototype.setOriginal = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string Edit = 5;
 * @return {string}
 */
proto.xcommon.AccountChangeLog.prototype.getEdit = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.xcommon.AccountChangeLog.prototype.setEdit = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int64 OpUid = 6;
 * @return {number}
 */
proto.xcommon.AccountChangeLog.prototype.getOpuid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.xcommon.AccountChangeLog.prototype.setOpuid = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 Ctime = 7;
 * @return {number}
 */
proto.xcommon.AccountChangeLog.prototype.getCtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.xcommon.AccountChangeLog.prototype.setCtime = function(value) {
  jspb.Message.setProto3IntField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.CalcMarketPaymentFeeParam.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.CalcMarketPaymentFeeParam.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.CalcMarketPaymentFeeParam} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CalcMarketPaymentFeeParam.toObject = function(includeInstance, msg) {
  var f, obj = {
    paymentname: jspb.Message.getFieldWithDefault(msg, 1, ""),
    paymentcode: jspb.Message.getFieldWithDefault(msg, 2, ""),
    channelcode: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.CalcMarketPaymentFeeParam}
 */
proto.xcommon.CalcMarketPaymentFeeParam.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.CalcMarketPaymentFeeParam;
  return proto.xcommon.CalcMarketPaymentFeeParam.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.CalcMarketPaymentFeeParam} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.CalcMarketPaymentFeeParam}
 */
proto.xcommon.CalcMarketPaymentFeeParam.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaymentname(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaymentcode(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setChannelcode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.CalcMarketPaymentFeeParam.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.CalcMarketPaymentFeeParam.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.CalcMarketPaymentFeeParam} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CalcMarketPaymentFeeParam.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPaymentname();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPaymentcode();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getChannelcode();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string PaymentName = 1;
 * @return {string}
 */
proto.xcommon.CalcMarketPaymentFeeParam.prototype.getPaymentname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.xcommon.CalcMarketPaymentFeeParam.prototype.setPaymentname = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string PaymentCode = 2;
 * @return {string}
 */
proto.xcommon.CalcMarketPaymentFeeParam.prototype.getPaymentcode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.CalcMarketPaymentFeeParam.prototype.setPaymentcode = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string ChannelCode = 3;
 * @return {string}
 */
proto.xcommon.CalcMarketPaymentFeeParam.prototype.getChannelcode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.CalcMarketPaymentFeeParam.prototype.setChannelcode = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.CalcMarketPaymentFeeResult.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.CalcMarketPaymentFeeResult.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.CalcMarketPaymentFeeResult} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CalcMarketPaymentFeeResult.toObject = function(includeInstance, msg) {
  var f, obj = {
    paymentname: jspb.Message.getFieldWithDefault(msg, 1, ""),
    channelcode: jspb.Message.getFieldWithDefault(msg, 3, ""),
    servicefee: jspb.Message.getFieldWithDefault(msg, 4, 0),
    taxfee: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.CalcMarketPaymentFeeResult}
 */
proto.xcommon.CalcMarketPaymentFeeResult.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.CalcMarketPaymentFeeResult;
  return proto.xcommon.CalcMarketPaymentFeeResult.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.CalcMarketPaymentFeeResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.CalcMarketPaymentFeeResult}
 */
proto.xcommon.CalcMarketPaymentFeeResult.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaymentname(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setChannelcode(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setServicefee(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTaxfee(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.CalcMarketPaymentFeeResult.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.CalcMarketPaymentFeeResult.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.CalcMarketPaymentFeeResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CalcMarketPaymentFeeResult.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPaymentname();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getChannelcode();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getServicefee();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getTaxfee();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
};


/**
 * optional string PaymentName = 1;
 * @return {string}
 */
proto.xcommon.CalcMarketPaymentFeeResult.prototype.getPaymentname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.xcommon.CalcMarketPaymentFeeResult.prototype.setPaymentname = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string ChannelCode = 3;
 * @return {string}
 */
proto.xcommon.CalcMarketPaymentFeeResult.prototype.getChannelcode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.CalcMarketPaymentFeeResult.prototype.setChannelcode = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 ServiceFee = 4;
 * @return {number}
 */
proto.xcommon.CalcMarketPaymentFeeResult.prototype.getServicefee = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.CalcMarketPaymentFeeResult.prototype.setServicefee = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 TaxFee = 5;
 * @return {number}
 */
proto.xcommon.CalcMarketPaymentFeeResult.prototype.getTaxfee = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.CalcMarketPaymentFeeResult.prototype.setTaxfee = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.MarketPaymentItem.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.MarketPaymentItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.MarketPaymentItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.MarketPaymentItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    paymentname: jspb.Message.getFieldWithDefault(msg, 1, ""),
    paymentcode: jspb.Message.getFieldWithDefault(msg, 2, ""),
    amount: jspb.Message.getFieldWithDefault(msg, 3, 0),
    fee: jspb.Message.getFieldWithDefault(msg, 4, 0),
    feerate: jspb.Message.getFieldWithDefault(msg, 5, 0),
    openpayfee: jspb.Message.getFieldWithDefault(msg, 6, 0),
    openpayfeemethod: jspb.Message.getFieldWithDefault(msg, 7, 0),
    createtime: jspb.Message.getFieldWithDefault(msg, 8, 0),
    invalidtime: jspb.Message.getFieldWithDefault(msg, 9, 0),
    paymenttype: jspb.Message.getFieldWithDefault(msg, 10, 0),
    status: jspb.Message.getFieldWithDefault(msg, 11, 0),
    channelstatus: jspb.Message.getFieldWithDefault(msg, 12, ""),
    channelid: jspb.Message.getFieldWithDefault(msg, 13, 0),
    channelcode: jspb.Message.getFieldWithDefault(msg, 14, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.MarketPaymentItem}
 */
proto.xcommon.MarketPaymentItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.MarketPaymentItem;
  return proto.xcommon.MarketPaymentItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.MarketPaymentItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.MarketPaymentItem}
 */
proto.xcommon.MarketPaymentItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaymentname(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaymentcode(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmount(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setFee(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setFeerate(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOpenpayfee(value);
      break;
    case 7:
      var value = /** @type {!proto.xcommon.OpenPayHandingFeeMethod} */ (reader.readEnum());
      msg.setOpenpayfeemethod(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatetime(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setInvalidtime(value);
      break;
    case 10:
      var value = /** @type {!proto.xcommon.MarketPaymentType} */ (reader.readEnum());
      msg.setPaymenttype(value);
      break;
    case 11:
      var value = /** @type {!proto.xcommon.MarketPaymentStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setChannelstatus(value);
      break;
    case 13:
      var value = /** @type {!proto.xcommon.MarketPaymentChannel} */ (reader.readEnum());
      msg.setChannelid(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setChannelcode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.MarketPaymentItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.MarketPaymentItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.MarketPaymentItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.MarketPaymentItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPaymentname();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPaymentcode();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAmount();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getFee();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getFeerate();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getOpenpayfee();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getOpenpayfeemethod();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getCreatetime();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getInvalidtime();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getPaymenttype();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      11,
      f
    );
  }
  f = message.getChannelstatus();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getChannelid();
  if (f !== 0.0) {
    writer.writeEnum(
      13,
      f
    );
  }
  f = message.getChannelcode();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
};


/**
 * optional string PaymentName = 1;
 * @return {string}
 */
proto.xcommon.MarketPaymentItem.prototype.getPaymentname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.xcommon.MarketPaymentItem.prototype.setPaymentname = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string PaymentCode = 2;
 * @return {string}
 */
proto.xcommon.MarketPaymentItem.prototype.getPaymentcode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.MarketPaymentItem.prototype.setPaymentcode = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 Amount = 3;
 * @return {number}
 */
proto.xcommon.MarketPaymentItem.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.MarketPaymentItem.prototype.setAmount = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 Fee = 4;
 * @return {number}
 */
proto.xcommon.MarketPaymentItem.prototype.getFee = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.MarketPaymentItem.prototype.setFee = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 FeeRate = 5;
 * @return {number}
 */
proto.xcommon.MarketPaymentItem.prototype.getFeerate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.MarketPaymentItem.prototype.setFeerate = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 OpenPayFee = 6;
 * @return {number}
 */
proto.xcommon.MarketPaymentItem.prototype.getOpenpayfee = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.xcommon.MarketPaymentItem.prototype.setOpenpayfee = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional OpenPayHandingFeeMethod OpenPayFeeMethod = 7;
 * @return {!proto.xcommon.OpenPayHandingFeeMethod}
 */
proto.xcommon.MarketPaymentItem.prototype.getOpenpayfeemethod = function() {
  return /** @type {!proto.xcommon.OpenPayHandingFeeMethod} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {!proto.xcommon.OpenPayHandingFeeMethod} value */
proto.xcommon.MarketPaymentItem.prototype.setOpenpayfeemethod = function(value) {
  jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional int64 CreateTime = 8;
 * @return {number}
 */
proto.xcommon.MarketPaymentItem.prototype.getCreatetime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/** @param {number} value */
proto.xcommon.MarketPaymentItem.prototype.setCreatetime = function(value) {
  jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int64 InvalidTime = 9;
 * @return {number}
 */
proto.xcommon.MarketPaymentItem.prototype.getInvalidtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/** @param {number} value */
proto.xcommon.MarketPaymentItem.prototype.setInvalidtime = function(value) {
  jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional MarketPaymentType PaymentType = 10;
 * @return {!proto.xcommon.MarketPaymentType}
 */
proto.xcommon.MarketPaymentItem.prototype.getPaymenttype = function() {
  return /** @type {!proto.xcommon.MarketPaymentType} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/** @param {!proto.xcommon.MarketPaymentType} value */
proto.xcommon.MarketPaymentItem.prototype.setPaymenttype = function(value) {
  jspb.Message.setProto3EnumField(this, 10, value);
};


/**
 * optional MarketPaymentStatus Status = 11;
 * @return {!proto.xcommon.MarketPaymentStatus}
 */
proto.xcommon.MarketPaymentItem.prototype.getStatus = function() {
  return /** @type {!proto.xcommon.MarketPaymentStatus} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/** @param {!proto.xcommon.MarketPaymentStatus} value */
proto.xcommon.MarketPaymentItem.prototype.setStatus = function(value) {
  jspb.Message.setProto3EnumField(this, 11, value);
};


/**
 * optional string ChannelStatus = 12;
 * @return {string}
 */
proto.xcommon.MarketPaymentItem.prototype.getChannelstatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/** @param {string} value */
proto.xcommon.MarketPaymentItem.prototype.setChannelstatus = function(value) {
  jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional MarketPaymentChannel ChannelId = 13;
 * @return {!proto.xcommon.MarketPaymentChannel}
 */
proto.xcommon.MarketPaymentItem.prototype.getChannelid = function() {
  return /** @type {!proto.xcommon.MarketPaymentChannel} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/** @param {!proto.xcommon.MarketPaymentChannel} value */
proto.xcommon.MarketPaymentItem.prototype.setChannelid = function(value) {
  jspb.Message.setProto3EnumField(this, 13, value);
};


/**
 * optional string ChannelCode = 14;
 * @return {string}
 */
proto.xcommon.MarketPaymentItem.prototype.getChannelcode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/** @param {string} value */
proto.xcommon.MarketPaymentItem.prototype.setChannelcode = function(value) {
  jspb.Message.setProto3StringField(this, 14, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.MarketPaymentItemList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.MarketPaymentItemList.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.MarketPaymentItemList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.MarketPaymentItemList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.MarketPaymentItemList.toObject = function(includeInstance, msg) {
  var f, obj = {
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.MarketPaymentItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.MarketPaymentItemList}
 */
proto.xcommon.MarketPaymentItemList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.MarketPaymentItemList;
  return proto.xcommon.MarketPaymentItemList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.MarketPaymentItemList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.MarketPaymentItemList}
 */
proto.xcommon.MarketPaymentItemList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.xcommon.MarketPaymentItem;
      reader.readMessage(value,proto.xcommon.MarketPaymentItem.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.MarketPaymentItemList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.MarketPaymentItemList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.MarketPaymentItemList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.MarketPaymentItemList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.xcommon.MarketPaymentItem.serializeBinaryToWriter
    );
  }
};


/**
 * repeated MarketPaymentItem List = 1;
 * @return {!Array<!proto.xcommon.MarketPaymentItem>}
 */
proto.xcommon.MarketPaymentItemList.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.MarketPaymentItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.MarketPaymentItem, 1));
};


/** @param {!Array<!proto.xcommon.MarketPaymentItem>} value */
proto.xcommon.MarketPaymentItemList.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.xcommon.MarketPaymentItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.MarketPaymentItem}
 */
proto.xcommon.MarketPaymentItemList.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.xcommon.MarketPaymentItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.MarketPaymentItemList.prototype.clearListList = function() {
  this.setListList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.UrgeRepayInfo.repeatedFields_ = [3,7,12,13];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.UrgeRepayInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.UrgeRepayInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.UrgeRepayInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.UrgeRepayInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    vacode: jspb.Message.getFieldWithDefault(msg, 1, ""),
    leftamount: jspb.Message.getFieldWithDefault(msg, 2, 0),
    marketpaymentList: jspb.Message.toObjectList(msg.getMarketpaymentList(),
    proto.xcommon.MarketPaymentItem.toObject, includeInstance),
    feenote: jspb.Message.getFieldWithDefault(msg, 4, ""),
    rollinfo: (f = msg.getRollinfo()) && proto.xcommon.UrgeRollInfo.toObject(includeInstance, f),
    loaninfo: (f = msg.getLoaninfo()) && proto.xcommon.UrgeLoanInfo.toObject(includeInstance, f),
    repayinfodetailList: jspb.Message.toObjectList(msg.getRepayinfodetailList(),
    xcommon_common_pb.WebPageSection.toObject, includeInstance),
    userepayinfodetail: jspb.Message.getFieldWithDefault(msg, 8, 0),
    creditenhanceinfo: (f = msg.getCreditenhanceinfo()) && proto.xcommon.CreditEnhanceInfo.toObject(includeInstance, f),
    phoneverifynote: jspb.Message.getFieldWithDefault(msg, 10, ""),
    calcfeeversion: jspb.Message.getFieldWithDefault(msg, 11, 0),
    rollinfolistList: jspb.Message.toObjectList(msg.getRollinfolistList(),
    proto.xcommon.UrgeRollInfo.toObject, includeInstance),
    loaninfolistList: jspb.Message.toObjectList(msg.getLoaninfolistList(),
    proto.xcommon.UrgeLoanInfo.toObject, includeInstance),
    frozeninteresttype: jspb.Message.getFieldWithDefault(msg, 14, 0),
    suggest: (f = msg.getSuggest()) && proto.xcommon.SuggestInfo.toObject(includeInstance, f),
    appname: jspb.Message.getFieldWithDefault(msg, 16, ""),
    otherdataMap: (f = msg.getOtherdataMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.UrgeRepayInfo}
 */
proto.xcommon.UrgeRepayInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.UrgeRepayInfo;
  return proto.xcommon.UrgeRepayInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.UrgeRepayInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.UrgeRepayInfo}
 */
proto.xcommon.UrgeRepayInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setVacode(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLeftamount(value);
      break;
    case 3:
      var value = new proto.xcommon.MarketPaymentItem;
      reader.readMessage(value,proto.xcommon.MarketPaymentItem.deserializeBinaryFromReader);
      msg.addMarketpayment(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setFeenote(value);
      break;
    case 5:
      var value = new proto.xcommon.UrgeRollInfo;
      reader.readMessage(value,proto.xcommon.UrgeRollInfo.deserializeBinaryFromReader);
      msg.setRollinfo(value);
      break;
    case 6:
      var value = new proto.xcommon.UrgeLoanInfo;
      reader.readMessage(value,proto.xcommon.UrgeLoanInfo.deserializeBinaryFromReader);
      msg.setLoaninfo(value);
      break;
    case 7:
      var value = new xcommon_common_pb.WebPageSection;
      reader.readMessage(value,xcommon_common_pb.WebPageSection.deserializeBinaryFromReader);
      msg.addRepayinfodetail(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUserepayinfodetail(value);
      break;
    case 9:
      var value = new proto.xcommon.CreditEnhanceInfo;
      reader.readMessage(value,proto.xcommon.CreditEnhanceInfo.deserializeBinaryFromReader);
      msg.setCreditenhanceinfo(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhoneverifynote(value);
      break;
    case 11:
      var value = /** @type {!proto.xcommon.CalcMarketPaymentFeeVersion} */ (reader.readEnum());
      msg.setCalcfeeversion(value);
      break;
    case 12:
      var value = new proto.xcommon.UrgeRollInfo;
      reader.readMessage(value,proto.xcommon.UrgeRollInfo.deserializeBinaryFromReader);
      msg.addRollinfolist(value);
      break;
    case 13:
      var value = new proto.xcommon.UrgeLoanInfo;
      reader.readMessage(value,proto.xcommon.UrgeLoanInfo.deserializeBinaryFromReader);
      msg.addLoaninfolist(value);
      break;
    case 14:
      var value = /** @type {!proto.xcommon.FrozenInterestType} */ (reader.readEnum());
      msg.setFrozeninteresttype(value);
      break;
    case 15:
      var value = new proto.xcommon.SuggestInfo;
      reader.readMessage(value,proto.xcommon.SuggestInfo.deserializeBinaryFromReader);
      msg.setSuggest(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    case 17:
      var value = msg.getOtherdataMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "");
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.UrgeRepayInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.UrgeRepayInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.UrgeRepayInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.UrgeRepayInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVacode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLeftamount();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getMarketpaymentList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.MarketPaymentItem.serializeBinaryToWriter
    );
  }
  f = message.getFeenote();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getRollinfo();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.xcommon.UrgeRollInfo.serializeBinaryToWriter
    );
  }
  f = message.getLoaninfo();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.xcommon.UrgeLoanInfo.serializeBinaryToWriter
    );
  }
  f = message.getRepayinfodetailList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      xcommon_common_pb.WebPageSection.serializeBinaryToWriter
    );
  }
  f = message.getUserepayinfodetail();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getCreditenhanceinfo();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.xcommon.CreditEnhanceInfo.serializeBinaryToWriter
    );
  }
  f = message.getPhoneverifynote();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getCalcfeeversion();
  if (f !== 0.0) {
    writer.writeEnum(
      11,
      f
    );
  }
  f = message.getRollinfolistList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      12,
      f,
      proto.xcommon.UrgeRollInfo.serializeBinaryToWriter
    );
  }
  f = message.getLoaninfolistList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      13,
      f,
      proto.xcommon.UrgeLoanInfo.serializeBinaryToWriter
    );
  }
  f = message.getFrozeninteresttype();
  if (f !== 0.0) {
    writer.writeEnum(
      14,
      f
    );
  }
  f = message.getSuggest();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      proto.xcommon.SuggestInfo.serializeBinaryToWriter
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getOtherdataMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(17, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
};


/**
 * optional string VACode = 1;
 * @return {string}
 */
proto.xcommon.UrgeRepayInfo.prototype.getVacode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.xcommon.UrgeRepayInfo.prototype.setVacode = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 LeftAmount = 2;
 * @return {number}
 */
proto.xcommon.UrgeRepayInfo.prototype.getLeftamount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.UrgeRepayInfo.prototype.setLeftamount = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * repeated MarketPaymentItem MarketPayment = 3;
 * @return {!Array<!proto.xcommon.MarketPaymentItem>}
 */
proto.xcommon.UrgeRepayInfo.prototype.getMarketpaymentList = function() {
  return /** @type{!Array<!proto.xcommon.MarketPaymentItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.MarketPaymentItem, 3));
};


/** @param {!Array<!proto.xcommon.MarketPaymentItem>} value */
proto.xcommon.UrgeRepayInfo.prototype.setMarketpaymentList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.MarketPaymentItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.MarketPaymentItem}
 */
proto.xcommon.UrgeRepayInfo.prototype.addMarketpayment = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.MarketPaymentItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.UrgeRepayInfo.prototype.clearMarketpaymentList = function() {
  this.setMarketpaymentList([]);
};


/**
 * optional string FeeNote = 4;
 * @return {string}
 */
proto.xcommon.UrgeRepayInfo.prototype.getFeenote = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.UrgeRepayInfo.prototype.setFeenote = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional UrgeRollInfo RollInfo = 5;
 * @return {?proto.xcommon.UrgeRollInfo}
 */
proto.xcommon.UrgeRepayInfo.prototype.getRollinfo = function() {
  return /** @type{?proto.xcommon.UrgeRollInfo} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.UrgeRollInfo, 5));
};


/** @param {?proto.xcommon.UrgeRollInfo|undefined} value */
proto.xcommon.UrgeRepayInfo.prototype.setRollinfo = function(value) {
  jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.UrgeRepayInfo.prototype.clearRollinfo = function() {
  this.setRollinfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.UrgeRepayInfo.prototype.hasRollinfo = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional UrgeLoanInfo LoanInfo = 6;
 * @return {?proto.xcommon.UrgeLoanInfo}
 */
proto.xcommon.UrgeRepayInfo.prototype.getLoaninfo = function() {
  return /** @type{?proto.xcommon.UrgeLoanInfo} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.UrgeLoanInfo, 6));
};


/** @param {?proto.xcommon.UrgeLoanInfo|undefined} value */
proto.xcommon.UrgeRepayInfo.prototype.setLoaninfo = function(value) {
  jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.UrgeRepayInfo.prototype.clearLoaninfo = function() {
  this.setLoaninfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.UrgeRepayInfo.prototype.hasLoaninfo = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * repeated WebPageSection RepayInfoDetail = 7;
 * @return {!Array<!proto.xcommon.WebPageSection>}
 */
proto.xcommon.UrgeRepayInfo.prototype.getRepayinfodetailList = function() {
  return /** @type{!Array<!proto.xcommon.WebPageSection>} */ (
    jspb.Message.getRepeatedWrapperField(this, xcommon_common_pb.WebPageSection, 7));
};


/** @param {!Array<!proto.xcommon.WebPageSection>} value */
proto.xcommon.UrgeRepayInfo.prototype.setRepayinfodetailList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.xcommon.WebPageSection=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.WebPageSection}
 */
proto.xcommon.UrgeRepayInfo.prototype.addRepayinfodetail = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.xcommon.WebPageSection, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.UrgeRepayInfo.prototype.clearRepayinfodetailList = function() {
  this.setRepayinfodetailList([]);
};


/**
 * optional int32 UseRepayInfoDetail = 8;
 * @return {number}
 */
proto.xcommon.UrgeRepayInfo.prototype.getUserepayinfodetail = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/** @param {number} value */
proto.xcommon.UrgeRepayInfo.prototype.setUserepayinfodetail = function(value) {
  jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional CreditEnhanceInfo CreditEnhanceInfo = 9;
 * @return {?proto.xcommon.CreditEnhanceInfo}
 */
proto.xcommon.UrgeRepayInfo.prototype.getCreditenhanceinfo = function() {
  return /** @type{?proto.xcommon.CreditEnhanceInfo} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.CreditEnhanceInfo, 9));
};


/** @param {?proto.xcommon.CreditEnhanceInfo|undefined} value */
proto.xcommon.UrgeRepayInfo.prototype.setCreditenhanceinfo = function(value) {
  jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.UrgeRepayInfo.prototype.clearCreditenhanceinfo = function() {
  this.setCreditenhanceinfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.UrgeRepayInfo.prototype.hasCreditenhanceinfo = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional string PhoneVerifyNote = 10;
 * @return {string}
 */
proto.xcommon.UrgeRepayInfo.prototype.getPhoneverifynote = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/** @param {string} value */
proto.xcommon.UrgeRepayInfo.prototype.setPhoneverifynote = function(value) {
  jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional CalcMarketPaymentFeeVersion CalcFeeVersion = 11;
 * @return {!proto.xcommon.CalcMarketPaymentFeeVersion}
 */
proto.xcommon.UrgeRepayInfo.prototype.getCalcfeeversion = function() {
  return /** @type {!proto.xcommon.CalcMarketPaymentFeeVersion} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/** @param {!proto.xcommon.CalcMarketPaymentFeeVersion} value */
proto.xcommon.UrgeRepayInfo.prototype.setCalcfeeversion = function(value) {
  jspb.Message.setProto3EnumField(this, 11, value);
};


/**
 * repeated UrgeRollInfo RollInfoList = 12;
 * @return {!Array<!proto.xcommon.UrgeRollInfo>}
 */
proto.xcommon.UrgeRepayInfo.prototype.getRollinfolistList = function() {
  return /** @type{!Array<!proto.xcommon.UrgeRollInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.UrgeRollInfo, 12));
};


/** @param {!Array<!proto.xcommon.UrgeRollInfo>} value */
proto.xcommon.UrgeRepayInfo.prototype.setRollinfolistList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 12, value);
};


/**
 * @param {!proto.xcommon.UrgeRollInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.UrgeRollInfo}
 */
proto.xcommon.UrgeRepayInfo.prototype.addRollinfolist = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 12, opt_value, proto.xcommon.UrgeRollInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.UrgeRepayInfo.prototype.clearRollinfolistList = function() {
  this.setRollinfolistList([]);
};


/**
 * repeated UrgeLoanInfo LoanInfoList = 13;
 * @return {!Array<!proto.xcommon.UrgeLoanInfo>}
 */
proto.xcommon.UrgeRepayInfo.prototype.getLoaninfolistList = function() {
  return /** @type{!Array<!proto.xcommon.UrgeLoanInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.UrgeLoanInfo, 13));
};


/** @param {!Array<!proto.xcommon.UrgeLoanInfo>} value */
proto.xcommon.UrgeRepayInfo.prototype.setLoaninfolistList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 13, value);
};


/**
 * @param {!proto.xcommon.UrgeLoanInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.UrgeLoanInfo}
 */
proto.xcommon.UrgeRepayInfo.prototype.addLoaninfolist = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 13, opt_value, proto.xcommon.UrgeLoanInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.UrgeRepayInfo.prototype.clearLoaninfolistList = function() {
  this.setLoaninfolistList([]);
};


/**
 * optional FrozenInterestType FrozenInterestType = 14;
 * @return {!proto.xcommon.FrozenInterestType}
 */
proto.xcommon.UrgeRepayInfo.prototype.getFrozeninteresttype = function() {
  return /** @type {!proto.xcommon.FrozenInterestType} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/** @param {!proto.xcommon.FrozenInterestType} value */
proto.xcommon.UrgeRepayInfo.prototype.setFrozeninteresttype = function(value) {
  jspb.Message.setProto3EnumField(this, 14, value);
};


/**
 * optional SuggestInfo Suggest = 15;
 * @return {?proto.xcommon.SuggestInfo}
 */
proto.xcommon.UrgeRepayInfo.prototype.getSuggest = function() {
  return /** @type{?proto.xcommon.SuggestInfo} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.SuggestInfo, 15));
};


/** @param {?proto.xcommon.SuggestInfo|undefined} value */
proto.xcommon.UrgeRepayInfo.prototype.setSuggest = function(value) {
  jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.UrgeRepayInfo.prototype.clearSuggest = function() {
  this.setSuggest(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.UrgeRepayInfo.prototype.hasSuggest = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional string AppName = 16;
 * @return {string}
 */
proto.xcommon.UrgeRepayInfo.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/** @param {string} value */
proto.xcommon.UrgeRepayInfo.prototype.setAppname = function(value) {
  jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * map<string, string> OtherData = 17;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.xcommon.UrgeRepayInfo.prototype.getOtherdataMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 17, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 */
proto.xcommon.UrgeRepayInfo.prototype.clearOtherdataMap = function() {
  this.getOtherdataMap().clear();
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.CreditEnhanceInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.CreditEnhanceInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.CreditEnhanceInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CreditEnhanceInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    facebook: jspb.Message.getFieldWithDefault(msg, 1, ""),
    secondmobile: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.CreditEnhanceInfo}
 */
proto.xcommon.CreditEnhanceInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.CreditEnhanceInfo;
  return proto.xcommon.CreditEnhanceInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.CreditEnhanceInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.CreditEnhanceInfo}
 */
proto.xcommon.CreditEnhanceInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFacebook(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecondmobile(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.CreditEnhanceInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.CreditEnhanceInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.CreditEnhanceInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CreditEnhanceInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFacebook();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSecondmobile();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string Facebook = 1;
 * @return {string}
 */
proto.xcommon.CreditEnhanceInfo.prototype.getFacebook = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.xcommon.CreditEnhanceInfo.prototype.setFacebook = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string SecondMobile = 2;
 * @return {string}
 */
proto.xcommon.CreditEnhanceInfo.prototype.getSecondmobile = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.CreditEnhanceInfo.prototype.setSecondmobile = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.RollTCRepayCode.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.RollTCRepayCode.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.RollTCRepayCode} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.RollTCRepayCode.toObject = function(includeInstance, msg) {
  var f, obj = {
    thirdname: jspb.Message.getFieldWithDefault(msg, 1, ""),
    paymentcode: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.RollTCRepayCode}
 */
proto.xcommon.RollTCRepayCode.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.RollTCRepayCode;
  return proto.xcommon.RollTCRepayCode.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.RollTCRepayCode} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.RollTCRepayCode}
 */
proto.xcommon.RollTCRepayCode.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setThirdname(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaymentcode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.RollTCRepayCode.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.RollTCRepayCode.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.RollTCRepayCode} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.RollTCRepayCode.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getThirdname();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPaymentcode();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string ThirdName = 1;
 * @return {string}
 */
proto.xcommon.RollTCRepayCode.prototype.getThirdname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.xcommon.RollTCRepayCode.prototype.setThirdname = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string PaymentCode = 2;
 * @return {string}
 */
proto.xcommon.RollTCRepayCode.prototype.getPaymentcode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.RollTCRepayCode.prototype.setPaymentcode = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.RollTCDetail.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.RollTCDetail.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.RollTCDetail.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.RollTCDetail} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.RollTCDetail.toObject = function(includeInstance, msg) {
  var f, obj = {
    option: (f = msg.getOption()) && proto.xcommon.RollTCOption.toObject(includeInstance, f),
    currepayamount: jspb.Message.getFieldWithDefault(msg, 2, 0),
    currepaytime: jspb.Message.getFieldWithDefault(msg, 3, 0),
    nextrepayamount: jspb.Message.getFieldWithDefault(msg, 4, 0),
    nextrepaytime: jspb.Message.getFieldWithDefault(msg, 5, 0),
    repaycodeList: jspb.Message.toObjectList(msg.getRepaycodeList(),
    proto.xcommon.RollTCRepayCode.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.RollTCDetail}
 */
proto.xcommon.RollTCDetail.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.RollTCDetail;
  return proto.xcommon.RollTCDetail.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.RollTCDetail} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.RollTCDetail}
 */
proto.xcommon.RollTCDetail.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.xcommon.RollTCOption;
      reader.readMessage(value,proto.xcommon.RollTCOption.deserializeBinaryFromReader);
      msg.setOption(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCurrepayamount(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCurrepaytime(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNextrepayamount(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNextrepaytime(value);
      break;
    case 6:
      var value = new proto.xcommon.RollTCRepayCode;
      reader.readMessage(value,proto.xcommon.RollTCRepayCode.deserializeBinaryFromReader);
      msg.addRepaycode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.RollTCDetail.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.RollTCDetail.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.RollTCDetail} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.RollTCDetail.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOption();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.xcommon.RollTCOption.serializeBinaryToWriter
    );
  }
  f = message.getCurrepayamount();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getCurrepaytime();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getNextrepayamount();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getNextrepaytime();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getRepaycodeList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.xcommon.RollTCRepayCode.serializeBinaryToWriter
    );
  }
};


/**
 * optional RollTCOption Option = 1;
 * @return {?proto.xcommon.RollTCOption}
 */
proto.xcommon.RollTCDetail.prototype.getOption = function() {
  return /** @type{?proto.xcommon.RollTCOption} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.RollTCOption, 1));
};


/** @param {?proto.xcommon.RollTCOption|undefined} value */
proto.xcommon.RollTCDetail.prototype.setOption = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.RollTCDetail.prototype.clearOption = function() {
  this.setOption(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.RollTCDetail.prototype.hasOption = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 CurRepayAmount = 2;
 * @return {number}
 */
proto.xcommon.RollTCDetail.prototype.getCurrepayamount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.RollTCDetail.prototype.setCurrepayamount = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 CurRepayTime = 3;
 * @return {number}
 */
proto.xcommon.RollTCDetail.prototype.getCurrepaytime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.RollTCDetail.prototype.setCurrepaytime = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 NextRepayAmount = 4;
 * @return {number}
 */
proto.xcommon.RollTCDetail.prototype.getNextrepayamount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.RollTCDetail.prototype.setNextrepayamount = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 NextRepayTime = 5;
 * @return {number}
 */
proto.xcommon.RollTCDetail.prototype.getNextrepaytime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.RollTCDetail.prototype.setNextrepaytime = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * repeated RollTCRepayCode RepayCode = 6;
 * @return {!Array<!proto.xcommon.RollTCRepayCode>}
 */
proto.xcommon.RollTCDetail.prototype.getRepaycodeList = function() {
  return /** @type{!Array<!proto.xcommon.RollTCRepayCode>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.RollTCRepayCode, 6));
};


/** @param {!Array<!proto.xcommon.RollTCRepayCode>} value */
proto.xcommon.RollTCDetail.prototype.setRepaycodeList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.xcommon.RollTCRepayCode=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.RollTCRepayCode}
 */
proto.xcommon.RollTCDetail.prototype.addRepaycode = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.xcommon.RollTCRepayCode, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.RollTCDetail.prototype.clearRepaycodeList = function() {
  this.setRepaycodeList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.RollTCOption.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.RollTCOption.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.RollTCOption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.RollTCOption.toObject = function(includeInstance, msg) {
  var f, obj = {
    productid: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    rollday: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.RollTCOption}
 */
proto.xcommon.RollTCOption.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.RollTCOption;
  return proto.xcommon.RollTCOption.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.RollTCOption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.RollTCOption}
 */
proto.xcommon.RollTCOption.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setProductid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRollday(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.RollTCOption.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.RollTCOption.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.RollTCOption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.RollTCOption.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProductid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      1,
      f
    );
  }
  f = message.getRollday();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int64 ProductId = 1;
 * @return {string}
 */
proto.xcommon.RollTCOption.prototype.getProductid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/** @param {string} value */
proto.xcommon.RollTCOption.prototype.setProductid = function(value) {
  jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional int32 RollDay = 2;
 * @return {number}
 */
proto.xcommon.RollTCOption.prototype.getRollday = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.RollTCOption.prototype.setRollday = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.UrgeRollInfo.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.UrgeRollInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.UrgeRollInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.UrgeRollInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.UrgeRollInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: jspb.Message.getFieldWithDefault(msg, 1, 0),
    statustips: jspb.Message.getFieldWithDefault(msg, 2, ""),
    rollamount: jspb.Message.getFieldWithDefault(msg, 3, 0),
    detail: (f = msg.getDetail()) && proto.xcommon.RollTCDetail.toObject(includeInstance, f),
    rolloptionsList: jspb.Message.toObjectList(msg.getRolloptionsList(),
    proto.xcommon.RollTCOption.toObject, includeInstance),
    appname: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.UrgeRollInfo}
 */
proto.xcommon.UrgeRollInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.UrgeRollInfo;
  return proto.xcommon.UrgeRollInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.UrgeRollInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.UrgeRollInfo}
 */
proto.xcommon.UrgeRollInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.xcommon.RollStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatustips(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRollamount(value);
      break;
    case 4:
      var value = new proto.xcommon.RollTCDetail;
      reader.readMessage(value,proto.xcommon.RollTCDetail.deserializeBinaryFromReader);
      msg.setDetail(value);
      break;
    case 5:
      var value = new proto.xcommon.RollTCOption;
      reader.readMessage(value,proto.xcommon.RollTCOption.deserializeBinaryFromReader);
      msg.addRolloptions(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.UrgeRollInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.UrgeRollInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.UrgeRollInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.UrgeRollInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getStatustips();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRollamount();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getDetail();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.xcommon.RollTCDetail.serializeBinaryToWriter
    );
  }
  f = message.getRolloptionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.xcommon.RollTCOption.serializeBinaryToWriter
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional RollStatus Status = 1;
 * @return {!proto.xcommon.RollStatus}
 */
proto.xcommon.UrgeRollInfo.prototype.getStatus = function() {
  return /** @type {!proto.xcommon.RollStatus} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {!proto.xcommon.RollStatus} value */
proto.xcommon.UrgeRollInfo.prototype.setStatus = function(value) {
  jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string StatusTips = 2;
 * @return {string}
 */
proto.xcommon.UrgeRollInfo.prototype.getStatustips = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.UrgeRollInfo.prototype.setStatustips = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 RollAmount = 3;
 * @return {number}
 */
proto.xcommon.UrgeRollInfo.prototype.getRollamount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.UrgeRollInfo.prototype.setRollamount = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional RollTCDetail Detail = 4;
 * @return {?proto.xcommon.RollTCDetail}
 */
proto.xcommon.UrgeRollInfo.prototype.getDetail = function() {
  return /** @type{?proto.xcommon.RollTCDetail} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.RollTCDetail, 4));
};


/** @param {?proto.xcommon.RollTCDetail|undefined} value */
proto.xcommon.UrgeRollInfo.prototype.setDetail = function(value) {
  jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.UrgeRollInfo.prototype.clearDetail = function() {
  this.setDetail(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.UrgeRollInfo.prototype.hasDetail = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * repeated RollTCOption RollOptions = 5;
 * @return {!Array<!proto.xcommon.RollTCOption>}
 */
proto.xcommon.UrgeRollInfo.prototype.getRolloptionsList = function() {
  return /** @type{!Array<!proto.xcommon.RollTCOption>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.RollTCOption, 5));
};


/** @param {!Array<!proto.xcommon.RollTCOption>} value */
proto.xcommon.UrgeRollInfo.prototype.setRolloptionsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.xcommon.RollTCOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.RollTCOption}
 */
proto.xcommon.UrgeRollInfo.prototype.addRolloptions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.xcommon.RollTCOption, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.UrgeRollInfo.prototype.clearRolloptionsList = function() {
  this.setRolloptionsList([]);
};


/**
 * optional string AppName = 6;
 * @return {string}
 */
proto.xcommon.UrgeRollInfo.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.xcommon.UrgeRollInfo.prototype.setAppname = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.UrgeLoanStageInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.UrgeLoanStageInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.UrgeLoanStageInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.UrgeLoanStageInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    shouldrepaydate: jspb.Message.getFieldWithDefault(msg, 1, 0),
    leftover: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.UrgeLoanStageInfo}
 */
proto.xcommon.UrgeLoanStageInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.UrgeLoanStageInfo;
  return proto.xcommon.UrgeLoanStageInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.UrgeLoanStageInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.UrgeLoanStageInfo}
 */
proto.xcommon.UrgeLoanStageInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setShouldrepaydate(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLeftover(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.UrgeLoanStageInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.UrgeLoanStageInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.UrgeLoanStageInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.UrgeLoanStageInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getShouldrepaydate();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getLeftover();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional int64 ShouldRepayDate = 1;
 * @return {number}
 */
proto.xcommon.UrgeLoanStageInfo.prototype.getShouldrepaydate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.UrgeLoanStageInfo.prototype.setShouldrepaydate = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 LeftOver = 2;
 * @return {number}
 */
proto.xcommon.UrgeLoanStageInfo.prototype.getLeftover = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.UrgeLoanStageInfo.prototype.setLeftover = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.UrgeLoanInfo.repeatedFields_ = [7,9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.UrgeLoanInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.UrgeLoanInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.UrgeLoanInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.UrgeLoanInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    orderid: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    shouldrepaydate: jspb.Message.getFieldWithDefault(msg, 2, 0),
    leftover: jspb.Message.getFieldWithDefault(msg, 3, 0),
    overduedays: jspb.Message.getFieldWithDefault(msg, 4, 0),
    actualrepayedtotal: jspb.Message.getFieldWithDefault(msg, 5, 0),
    shouldrepayedtotal: jspb.Message.getFieldWithDefault(msg, 6, 0),
    stageinfosList: jspb.Message.toObjectList(msg.getStageinfosList(),
    proto.xcommon.UrgeLoanStageInfo.toObject, includeInstance),
    outurgetotal: jspb.Message.getFieldWithDefault(msg, 8, 0),
    extitemList: jspb.Message.toObjectList(msg.getExtitemList(),
    xcommon_common_pb.WebPageItem.toObject, includeInstance),
    urgeletterenable: jspb.Message.getFieldWithDefault(msg, 10, 0),
    appname: jspb.Message.getFieldWithDefault(msg, 11, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.UrgeLoanInfo}
 */
proto.xcommon.UrgeLoanInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.UrgeLoanInfo;
  return proto.xcommon.UrgeLoanInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.UrgeLoanInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.UrgeLoanInfo}
 */
proto.xcommon.UrgeLoanInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setShouldrepaydate(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLeftover(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOverduedays(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setActualrepayedtotal(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setShouldrepayedtotal(value);
      break;
    case 7:
      var value = new proto.xcommon.UrgeLoanStageInfo;
      reader.readMessage(value,proto.xcommon.UrgeLoanStageInfo.deserializeBinaryFromReader);
      msg.addStageinfos(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOuturgetotal(value);
      break;
    case 9:
      var value = new xcommon_common_pb.WebPageItem;
      reader.readMessage(value,xcommon_common_pb.WebPageItem.deserializeBinaryFromReader);
      msg.addExtitem(value);
      break;
    case 10:
      var value = /** @type {!proto.xcommon.Bool} */ (reader.readEnum());
      msg.setUrgeletterenable(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.UrgeLoanInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.UrgeLoanInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.UrgeLoanInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.UrgeLoanInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      1,
      f
    );
  }
  f = message.getShouldrepaydate();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getLeftover();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getOverduedays();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getActualrepayedtotal();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getShouldrepayedtotal();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getStageinfosList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.xcommon.UrgeLoanStageInfo.serializeBinaryToWriter
    );
  }
  f = message.getOuturgetotal();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getExtitemList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      xcommon_common_pb.WebPageItem.serializeBinaryToWriter
    );
  }
  f = message.getUrgeletterenable();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
};


/**
 * optional int64 OrderId = 1;
 * @return {string}
 */
proto.xcommon.UrgeLoanInfo.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/** @param {string} value */
proto.xcommon.UrgeLoanInfo.prototype.setOrderid = function(value) {
  jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional int64 ShouldRepayDate = 2;
 * @return {number}
 */
proto.xcommon.UrgeLoanInfo.prototype.getShouldrepaydate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.UrgeLoanInfo.prototype.setShouldrepaydate = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 LeftOver = 3;
 * @return {number}
 */
proto.xcommon.UrgeLoanInfo.prototype.getLeftover = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.UrgeLoanInfo.prototype.setLeftover = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 OverdueDays = 4;
 * @return {number}
 */
proto.xcommon.UrgeLoanInfo.prototype.getOverduedays = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.UrgeLoanInfo.prototype.setOverduedays = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 ActualRepayedTotal = 5;
 * @return {number}
 */
proto.xcommon.UrgeLoanInfo.prototype.getActualrepayedtotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.UrgeLoanInfo.prototype.setActualrepayedtotal = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 ShouldRepayedTotal = 6;
 * @return {number}
 */
proto.xcommon.UrgeLoanInfo.prototype.getShouldrepayedtotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.xcommon.UrgeLoanInfo.prototype.setShouldrepayedtotal = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * repeated UrgeLoanStageInfo StageInfos = 7;
 * @return {!Array<!proto.xcommon.UrgeLoanStageInfo>}
 */
proto.xcommon.UrgeLoanInfo.prototype.getStageinfosList = function() {
  return /** @type{!Array<!proto.xcommon.UrgeLoanStageInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.UrgeLoanStageInfo, 7));
};


/** @param {!Array<!proto.xcommon.UrgeLoanStageInfo>} value */
proto.xcommon.UrgeLoanInfo.prototype.setStageinfosList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.xcommon.UrgeLoanStageInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.UrgeLoanStageInfo}
 */
proto.xcommon.UrgeLoanInfo.prototype.addStageinfos = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.xcommon.UrgeLoanStageInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.UrgeLoanInfo.prototype.clearStageinfosList = function() {
  this.setStageinfosList([]);
};


/**
 * optional int64 OutUrgeTotal = 8;
 * @return {number}
 */
proto.xcommon.UrgeLoanInfo.prototype.getOuturgetotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/** @param {number} value */
proto.xcommon.UrgeLoanInfo.prototype.setOuturgetotal = function(value) {
  jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * repeated WebPageItem ExtItem = 9;
 * @return {!Array<!proto.xcommon.WebPageItem>}
 */
proto.xcommon.UrgeLoanInfo.prototype.getExtitemList = function() {
  return /** @type{!Array<!proto.xcommon.WebPageItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, xcommon_common_pb.WebPageItem, 9));
};


/** @param {!Array<!proto.xcommon.WebPageItem>} value */
proto.xcommon.UrgeLoanInfo.prototype.setExtitemList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.xcommon.WebPageItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.WebPageItem}
 */
proto.xcommon.UrgeLoanInfo.prototype.addExtitem = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.xcommon.WebPageItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.UrgeLoanInfo.prototype.clearExtitemList = function() {
  this.setExtitemList([]);
};


/**
 * optional Bool UrgeLetterEnable = 10;
 * @return {!proto.xcommon.Bool}
 */
proto.xcommon.UrgeLoanInfo.prototype.getUrgeletterenable = function() {
  return /** @type {!proto.xcommon.Bool} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/** @param {!proto.xcommon.Bool} value */
proto.xcommon.UrgeLoanInfo.prototype.setUrgeletterenable = function(value) {
  jspb.Message.setProto3EnumField(this, 10, value);
};


/**
 * optional string AppName = 11;
 * @return {string}
 */
proto.xcommon.UrgeLoanInfo.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/** @param {string} value */
proto.xcommon.UrgeLoanInfo.prototype.setAppname = function(value) {
  jspb.Message.setProto3StringField(this, 11, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ReducePenaltyBillDetail.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ReducePenaltyBillDetail.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ReducePenaltyBillDetail} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ReducePenaltyBillDetail.toObject = function(includeInstance, msg) {
  var f, obj = {
    shouldrepayname: jspb.Message.getFieldWithDefault(msg, 1, ""),
    shouldrepayvalue: jspb.Message.getFieldWithDefault(msg, 2, ""),
    actuallyrepayname: jspb.Message.getFieldWithDefault(msg, 3, ""),
    actuallyrepayvalue: jspb.Message.getFieldWithDefault(msg, 4, ""),
    alreadyreducename: jspb.Message.getFieldWithDefault(msg, 5, ""),
    alreadyreducevalue: jspb.Message.getFieldWithDefault(msg, 6, ""),
    leftreducename: jspb.Message.getFieldWithDefault(msg, 7, ""),
    leftreducevalue: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ReducePenaltyBillDetail}
 */
proto.xcommon.ReducePenaltyBillDetail.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ReducePenaltyBillDetail;
  return proto.xcommon.ReducePenaltyBillDetail.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ReducePenaltyBillDetail} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ReducePenaltyBillDetail}
 */
proto.xcommon.ReducePenaltyBillDetail.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setShouldrepayname(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setShouldrepayvalue(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setActuallyrepayname(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setActuallyrepayvalue(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setAlreadyreducename(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setAlreadyreducevalue(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setLeftreducename(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setLeftreducevalue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ReducePenaltyBillDetail.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ReducePenaltyBillDetail.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ReducePenaltyBillDetail} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ReducePenaltyBillDetail.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getShouldrepayname();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getShouldrepayvalue();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getActuallyrepayname();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getActuallyrepayvalue();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAlreadyreducename();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getAlreadyreducevalue();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getLeftreducename();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getLeftreducevalue();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional string ShouldRepayName = 1;
 * @return {string}
 */
proto.xcommon.ReducePenaltyBillDetail.prototype.getShouldrepayname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.xcommon.ReducePenaltyBillDetail.prototype.setShouldrepayname = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string ShouldRepayValue = 2;
 * @return {string}
 */
proto.xcommon.ReducePenaltyBillDetail.prototype.getShouldrepayvalue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.ReducePenaltyBillDetail.prototype.setShouldrepayvalue = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string ActuallyRepayName = 3;
 * @return {string}
 */
proto.xcommon.ReducePenaltyBillDetail.prototype.getActuallyrepayname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.ReducePenaltyBillDetail.prototype.setActuallyrepayname = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string ActuallyRepayValue = 4;
 * @return {string}
 */
proto.xcommon.ReducePenaltyBillDetail.prototype.getActuallyrepayvalue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.ReducePenaltyBillDetail.prototype.setActuallyrepayvalue = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string AlreadyReduceName = 5;
 * @return {string}
 */
proto.xcommon.ReducePenaltyBillDetail.prototype.getAlreadyreducename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.xcommon.ReducePenaltyBillDetail.prototype.setAlreadyreducename = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string AlreadyReduceValue = 6;
 * @return {string}
 */
proto.xcommon.ReducePenaltyBillDetail.prototype.getAlreadyreducevalue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.xcommon.ReducePenaltyBillDetail.prototype.setAlreadyreducevalue = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string LeftReduceName = 7;
 * @return {string}
 */
proto.xcommon.ReducePenaltyBillDetail.prototype.getLeftreducename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.xcommon.ReducePenaltyBillDetail.prototype.setLeftreducename = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string LeftReduceValue = 8;
 * @return {string}
 */
proto.xcommon.ReducePenaltyBillDetail.prototype.getLeftreducevalue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/** @param {string} value */
proto.xcommon.ReducePenaltyBillDetail.prototype.setLeftreducevalue = function(value) {
  jspb.Message.setProto3StringField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ReducePenaltyFieldDetail.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ReducePenaltyFieldDetail.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ReducePenaltyFieldDetail} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ReducePenaltyFieldDetail.toObject = function(includeInstance, msg) {
  var f, obj = {
    displayname: jspb.Message.getFieldWithDefault(msg, 1, ""),
    fieldname: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ReducePenaltyFieldDetail}
 */
proto.xcommon.ReducePenaltyFieldDetail.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ReducePenaltyFieldDetail;
  return proto.xcommon.ReducePenaltyFieldDetail.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ReducePenaltyFieldDetail} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ReducePenaltyFieldDetail}
 */
proto.xcommon.ReducePenaltyFieldDetail.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayname(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFieldname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ReducePenaltyFieldDetail.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ReducePenaltyFieldDetail.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ReducePenaltyFieldDetail} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ReducePenaltyFieldDetail.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDisplayname();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFieldname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string DisplayName = 1;
 * @return {string}
 */
proto.xcommon.ReducePenaltyFieldDetail.prototype.getDisplayname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.xcommon.ReducePenaltyFieldDetail.prototype.setDisplayname = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string FieldName = 2;
 * @return {string}
 */
proto.xcommon.ReducePenaltyFieldDetail.prototype.getFieldname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.ReducePenaltyFieldDetail.prototype.setFieldname = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.ApplyReducePenaltyFieldDetail.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.ApplyReducePenaltyFieldDetail.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.ApplyReducePenaltyFieldDetail} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ApplyReducePenaltyFieldDetail.toObject = function(includeInstance, msg) {
  var f, obj = {
    fieldname: jspb.Message.getFieldWithDefault(msg, 1, ""),
    value: jspb.Message.getFieldWithDefault(msg, 2, 0),
    displayname: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.ApplyReducePenaltyFieldDetail}
 */
proto.xcommon.ApplyReducePenaltyFieldDetail.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.ApplyReducePenaltyFieldDetail;
  return proto.xcommon.ApplyReducePenaltyFieldDetail.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.ApplyReducePenaltyFieldDetail} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.ApplyReducePenaltyFieldDetail}
 */
proto.xcommon.ApplyReducePenaltyFieldDetail.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFieldname(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setValue(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.ApplyReducePenaltyFieldDetail.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.ApplyReducePenaltyFieldDetail.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.ApplyReducePenaltyFieldDetail} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.ApplyReducePenaltyFieldDetail.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFieldname();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getValue();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getDisplayname();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string FieldName = 1;
 * @return {string}
 */
proto.xcommon.ApplyReducePenaltyFieldDetail.prototype.getFieldname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.xcommon.ApplyReducePenaltyFieldDetail.prototype.setFieldname = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 Value = 2;
 * @return {number}
 */
proto.xcommon.ApplyReducePenaltyFieldDetail.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.ApplyReducePenaltyFieldDetail.prototype.setValue = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string DisplayName = 3;
 * @return {string}
 */
proto.xcommon.ApplyReducePenaltyFieldDetail.prototype.getDisplayname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.ApplyReducePenaltyFieldDetail.prototype.setDisplayname = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.OrderRepaymentDetail.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.OrderRepaymentDetail.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.OrderRepaymentDetail.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.OrderRepaymentDetail} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.OrderRepaymentDetail.toObject = function(includeInstance, msg) {
  var f, obj = {
    orderid: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    amount: (f = msg.getAmount()) && proto.xcommon.LoadAmount.toObject(includeInstance, f),
    detailList: jspb.Message.toObjectList(msg.getDetailList(),
    proto.xcommon.RepaymentDetail.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.OrderRepaymentDetail}
 */
proto.xcommon.OrderRepaymentDetail.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.OrderRepaymentDetail;
  return proto.xcommon.OrderRepaymentDetail.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.OrderRepaymentDetail} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.OrderRepaymentDetail}
 */
proto.xcommon.OrderRepaymentDetail.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 2:
      var value = new proto.xcommon.LoadAmount;
      reader.readMessage(value,proto.xcommon.LoadAmount.deserializeBinaryFromReader);
      msg.setAmount(value);
      break;
    case 3:
      var value = new proto.xcommon.RepaymentDetail;
      reader.readMessage(value,proto.xcommon.RepaymentDetail.deserializeBinaryFromReader);
      msg.addDetail(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.OrderRepaymentDetail.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.OrderRepaymentDetail.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.OrderRepaymentDetail} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.OrderRepaymentDetail.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      1,
      f
    );
  }
  f = message.getAmount();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.xcommon.LoadAmount.serializeBinaryToWriter
    );
  }
  f = message.getDetailList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.RepaymentDetail.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 OrderId = 1;
 * @return {string}
 */
proto.xcommon.OrderRepaymentDetail.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/** @param {string} value */
proto.xcommon.OrderRepaymentDetail.prototype.setOrderid = function(value) {
  jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional LoadAmount Amount = 2;
 * @return {?proto.xcommon.LoadAmount}
 */
proto.xcommon.OrderRepaymentDetail.prototype.getAmount = function() {
  return /** @type{?proto.xcommon.LoadAmount} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.LoadAmount, 2));
};


/** @param {?proto.xcommon.LoadAmount|undefined} value */
proto.xcommon.OrderRepaymentDetail.prototype.setAmount = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.OrderRepaymentDetail.prototype.clearAmount = function() {
  this.setAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.OrderRepaymentDetail.prototype.hasAmount = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated RepaymentDetail Detail = 3;
 * @return {!Array<!proto.xcommon.RepaymentDetail>}
 */
proto.xcommon.OrderRepaymentDetail.prototype.getDetailList = function() {
  return /** @type{!Array<!proto.xcommon.RepaymentDetail>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.RepaymentDetail, 3));
};


/** @param {!Array<!proto.xcommon.RepaymentDetail>} value */
proto.xcommon.OrderRepaymentDetail.prototype.setDetailList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.RepaymentDetail=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.RepaymentDetail}
 */
proto.xcommon.OrderRepaymentDetail.prototype.addDetail = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.RepaymentDetail, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.OrderRepaymentDetail.prototype.clearDetailList = function() {
  this.setDetailList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.LoadAmount.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.LoadAmount.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.LoadAmount} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.LoadAmount.toObject = function(includeInstance, msg) {
  var f, obj = {
    unpaidprincipal: jspb.Message.getFieldWithDefault(msg, 1, 0),
    repayprincipal: jspb.Message.getFieldWithDefault(msg, 2, 0),
    repayvirtual: jspb.Message.getFieldWithDefault(msg, 3, 0),
    repaycoupon: jspb.Message.getFieldWithDefault(msg, 4, 0),
    repayreduce: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.LoadAmount}
 */
proto.xcommon.LoadAmount.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.LoadAmount;
  return proto.xcommon.LoadAmount.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.LoadAmount} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.LoadAmount}
 */
proto.xcommon.LoadAmount.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUnpaidprincipal(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRepayprincipal(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRepayvirtual(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRepaycoupon(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRepayreduce(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.LoadAmount.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.LoadAmount.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.LoadAmount} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.LoadAmount.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUnpaidprincipal();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getRepayprincipal();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getRepayvirtual();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getRepaycoupon();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getRepayreduce();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
};


/**
 * optional int64 UnpaidPrincipal = 1;
 * @return {number}
 */
proto.xcommon.LoadAmount.prototype.getUnpaidprincipal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.LoadAmount.prototype.setUnpaidprincipal = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 RepayPrincipal = 2;
 * @return {number}
 */
proto.xcommon.LoadAmount.prototype.getRepayprincipal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.LoadAmount.prototype.setRepayprincipal = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 RepayVirtual = 3;
 * @return {number}
 */
proto.xcommon.LoadAmount.prototype.getRepayvirtual = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.LoadAmount.prototype.setRepayvirtual = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 RepayCoupon = 4;
 * @return {number}
 */
proto.xcommon.LoadAmount.prototype.getRepaycoupon = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.LoadAmount.prototype.setRepaycoupon = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 RepayReduce = 5;
 * @return {number}
 */
proto.xcommon.LoadAmount.prototype.getRepayreduce = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.LoadAmount.prototype.setRepayreduce = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.RepaymentDetail.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.RepaymentDetail.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.RepaymentDetail} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.RepaymentDetail.toObject = function(includeInstance, msg) {
  var f, obj = {
    repaytype: jspb.Message.getFieldWithDefault(msg, 1, 0),
    amountpayed: jspb.Message.getFieldWithDefault(msg, 2, 0),
    ctime: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.RepaymentDetail}
 */
proto.xcommon.RepaymentDetail.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.RepaymentDetail;
  return proto.xcommon.RepaymentDetail.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.RepaymentDetail} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.RepaymentDetail}
 */
proto.xcommon.RepaymentDetail.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.xcommon.RepayTypeEnum} */ (reader.readEnum());
      msg.setRepaytype(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmountpayed(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCtime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.RepaymentDetail.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.RepaymentDetail.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.RepaymentDetail} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.RepaymentDetail.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRepaytype();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getAmountpayed();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getCtime();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional RepayTypeEnum RepayType = 1;
 * @return {!proto.xcommon.RepayTypeEnum}
 */
proto.xcommon.RepaymentDetail.prototype.getRepaytype = function() {
  return /** @type {!proto.xcommon.RepayTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {!proto.xcommon.RepayTypeEnum} value */
proto.xcommon.RepaymentDetail.prototype.setRepaytype = function(value) {
  jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional int64 AmountPayed = 2;
 * @return {number}
 */
proto.xcommon.RepaymentDetail.prototype.getAmountpayed = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.RepaymentDetail.prototype.setAmountpayed = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 Ctime = 3;
 * @return {number}
 */
proto.xcommon.RepaymentDetail.prototype.getCtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.RepaymentDetail.prototype.setCtime = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.AutoCallCoreParams.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.AutoCallCoreParams.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.AutoCallCoreParams} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.AutoCallCoreParams.toObject = function(includeInstance, msg) {
  var f, obj = {
    supplier: jspb.Message.getFieldWithDefault(msg, 1, 0),
    accountid: jspb.Message.getFieldWithDefault(msg, 2, "0"),
    orderid: jspb.Message.getFieldWithDefault(msg, 3, "0"),
    calledmobile: jspb.Message.getFieldWithDefault(msg, 4, ""),
    showmobile: jspb.Message.getFieldWithDefault(msg, 5, ""),
    createcalltimestart: jspb.Message.getFieldWithDefault(msg, 6, 0),
    createcalltimeend: jspb.Message.getFieldWithDefault(msg, 7, 0),
    truecalltimestart: jspb.Message.getFieldWithDefault(msg, 8, 0),
    truecalltimeend: jspb.Message.getFieldWithDefault(msg, 9, 0),
    offset: jspb.Message.getFieldWithDefault(msg, 10, 0),
    limitnum: jspb.Message.getFieldWithDefault(msg, 11, 0),
    appname: jspb.Message.getFieldWithDefault(msg, 12, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.AutoCallCoreParams}
 */
proto.xcommon.AutoCallCoreParams.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.AutoCallCoreParams;
  return proto.xcommon.AutoCallCoreParams.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.AutoCallCoreParams} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.AutoCallCoreParams}
 */
proto.xcommon.AutoCallCoreParams.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.xcommon.AutoCallSupplier} */ (reader.readEnum());
      msg.setSupplier(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setAccountid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCalledmobile(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setShowmobile(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatecalltimestart(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatecalltimeend(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTruecalltimestart(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTruecalltimeend(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOffset(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimitnum(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.AutoCallCoreParams.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.AutoCallCoreParams.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.AutoCallCoreParams} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.AutoCallCoreParams.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSupplier();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getAccountid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      2,
      f
    );
  }
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      3,
      f
    );
  }
  f = message.getCalledmobile();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getShowmobile();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCreatecalltimestart();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getCreatecalltimeend();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getTruecalltimestart();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getTruecalltimeend();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getOffset();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getLimitnum();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
};


/**
 * optional AutoCallSupplier Supplier = 1;
 * @return {!proto.xcommon.AutoCallSupplier}
 */
proto.xcommon.AutoCallCoreParams.prototype.getSupplier = function() {
  return /** @type {!proto.xcommon.AutoCallSupplier} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {!proto.xcommon.AutoCallSupplier} value */
proto.xcommon.AutoCallCoreParams.prototype.setSupplier = function(value) {
  jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional int64 AccountID = 2;
 * @return {string}
 */
proto.xcommon.AutoCallCoreParams.prototype.getAccountid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/** @param {string} value */
proto.xcommon.AutoCallCoreParams.prototype.setAccountid = function(value) {
  jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * optional int64 OrderID = 3;
 * @return {string}
 */
proto.xcommon.AutoCallCoreParams.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, "0"));
};


/** @param {string} value */
proto.xcommon.AutoCallCoreParams.prototype.setOrderid = function(value) {
  jspb.Message.setProto3StringIntField(this, 3, value);
};


/**
 * optional string CalledMobile = 4;
 * @return {string}
 */
proto.xcommon.AutoCallCoreParams.prototype.getCalledmobile = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.AutoCallCoreParams.prototype.setCalledmobile = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string ShowMobile = 5;
 * @return {string}
 */
proto.xcommon.AutoCallCoreParams.prototype.getShowmobile = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.xcommon.AutoCallCoreParams.prototype.setShowmobile = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int64 CreateCallTimeStart = 6;
 * @return {number}
 */
proto.xcommon.AutoCallCoreParams.prototype.getCreatecalltimestart = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.xcommon.AutoCallCoreParams.prototype.setCreatecalltimestart = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 CreateCallTimeEnd = 7;
 * @return {number}
 */
proto.xcommon.AutoCallCoreParams.prototype.getCreatecalltimeend = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.xcommon.AutoCallCoreParams.prototype.setCreatecalltimeend = function(value) {
  jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int64 TrueCallTimeStart = 8;
 * @return {number}
 */
proto.xcommon.AutoCallCoreParams.prototype.getTruecalltimestart = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/** @param {number} value */
proto.xcommon.AutoCallCoreParams.prototype.setTruecalltimestart = function(value) {
  jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int64 TrueCallTimeEnd = 9;
 * @return {number}
 */
proto.xcommon.AutoCallCoreParams.prototype.getTruecalltimeend = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/** @param {number} value */
proto.xcommon.AutoCallCoreParams.prototype.setTruecalltimeend = function(value) {
  jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int64 Offset = 10;
 * @return {number}
 */
proto.xcommon.AutoCallCoreParams.prototype.getOffset = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/** @param {number} value */
proto.xcommon.AutoCallCoreParams.prototype.setOffset = function(value) {
  jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int32 LimitNum = 11;
 * @return {number}
 */
proto.xcommon.AutoCallCoreParams.prototype.getLimitnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/** @param {number} value */
proto.xcommon.AutoCallCoreParams.prototype.setLimitnum = function(value) {
  jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional string AppName = 12;
 * @return {string}
 */
proto.xcommon.AutoCallCoreParams.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/** @param {string} value */
proto.xcommon.AutoCallCoreParams.prototype.setAppname = function(value) {
  jspb.Message.setProto3StringField(this, 12, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.AutoCallCoreResult.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.AutoCallCoreResult.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.AutoCallCoreResult} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.AutoCallCoreResult.toObject = function(includeInstance, msg) {
  var f, obj = {
    accountid: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    ordersid: jspb.Message.getFieldWithDefault(msg, 2, "0"),
    msgid: jspb.Message.getFieldWithDefault(msg, 3, ""),
    mobile: jspb.Message.getFieldWithDefault(msg, 4, ""),
    callcreatetime: jspb.Message.getFieldWithDefault(msg, 5, 0),
    callstarttime: jspb.Message.getFieldWithDefault(msg, 6, 0),
    callendtime: jspb.Message.getFieldWithDefault(msg, 7, 0),
    duration: jspb.Message.getFieldWithDefault(msg, 8, 0),
    showmobile: jspb.Message.getFieldWithDefault(msg, 9, ""),
    supplier: jspb.Message.getFieldWithDefault(msg, 10, 0),
    voiceid: jspb.Message.getFieldWithDefault(msg, 11, "0"),
    appname: jspb.Message.getFieldWithDefault(msg, 12, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.AutoCallCoreResult}
 */
proto.xcommon.AutoCallCoreResult.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.AutoCallCoreResult;
  return proto.xcommon.AutoCallCoreResult.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.AutoCallCoreResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.AutoCallCoreResult}
 */
proto.xcommon.AutoCallCoreResult.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setAccountid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrdersid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMsgid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setMobile(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCallcreatetime(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCallstarttime(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCallendtime(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDuration(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setShowmobile(value);
      break;
    case 10:
      var value = /** @type {!proto.xcommon.AutoCallSupplier} */ (reader.readEnum());
      msg.setSupplier(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setVoiceid(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.AutoCallCoreResult.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.AutoCallCoreResult.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.AutoCallCoreResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.AutoCallCoreResult.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      1,
      f
    );
  }
  f = message.getOrdersid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      2,
      f
    );
  }
  f = message.getMsgid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMobile();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCallcreatetime();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getCallstarttime();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getCallendtime();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getDuration();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getShowmobile();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getSupplier();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
  f = message.getVoiceid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      11,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
};


/**
 * optional int64 AccountID = 1;
 * @return {string}
 */
proto.xcommon.AutoCallCoreResult.prototype.getAccountid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/** @param {string} value */
proto.xcommon.AutoCallCoreResult.prototype.setAccountid = function(value) {
  jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional int64 OrdersID = 2;
 * @return {string}
 */
proto.xcommon.AutoCallCoreResult.prototype.getOrdersid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/** @param {string} value */
proto.xcommon.AutoCallCoreResult.prototype.setOrdersid = function(value) {
  jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * optional string MsgId = 3;
 * @return {string}
 */
proto.xcommon.AutoCallCoreResult.prototype.getMsgid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.AutoCallCoreResult.prototype.setMsgid = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string Mobile = 4;
 * @return {string}
 */
proto.xcommon.AutoCallCoreResult.prototype.getMobile = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.AutoCallCoreResult.prototype.setMobile = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int64 CallCreateTime = 5;
 * @return {number}
 */
proto.xcommon.AutoCallCoreResult.prototype.getCallcreatetime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.AutoCallCoreResult.prototype.setCallcreatetime = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 CallStartTime = 6;
 * @return {number}
 */
proto.xcommon.AutoCallCoreResult.prototype.getCallstarttime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.xcommon.AutoCallCoreResult.prototype.setCallstarttime = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 CallEndTime = 7;
 * @return {number}
 */
proto.xcommon.AutoCallCoreResult.prototype.getCallendtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.xcommon.AutoCallCoreResult.prototype.setCallendtime = function(value) {
  jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int32 Duration = 8;
 * @return {number}
 */
proto.xcommon.AutoCallCoreResult.prototype.getDuration = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/** @param {number} value */
proto.xcommon.AutoCallCoreResult.prototype.setDuration = function(value) {
  jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional string ShowMobile = 9;
 * @return {string}
 */
proto.xcommon.AutoCallCoreResult.prototype.getShowmobile = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/** @param {string} value */
proto.xcommon.AutoCallCoreResult.prototype.setShowmobile = function(value) {
  jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional AutoCallSupplier Supplier = 10;
 * @return {!proto.xcommon.AutoCallSupplier}
 */
proto.xcommon.AutoCallCoreResult.prototype.getSupplier = function() {
  return /** @type {!proto.xcommon.AutoCallSupplier} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/** @param {!proto.xcommon.AutoCallSupplier} value */
proto.xcommon.AutoCallCoreResult.prototype.setSupplier = function(value) {
  jspb.Message.setProto3EnumField(this, 10, value);
};


/**
 * optional int64 VoiceID = 11;
 * @return {string}
 */
proto.xcommon.AutoCallCoreResult.prototype.getVoiceid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, "0"));
};


/** @param {string} value */
proto.xcommon.AutoCallCoreResult.prototype.setVoiceid = function(value) {
  jspb.Message.setProto3StringIntField(this, 11, value);
};


/**
 * optional string AppName = 12;
 * @return {string}
 */
proto.xcommon.AutoCallCoreResult.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/** @param {string} value */
proto.xcommon.AutoCallCoreResult.prototype.setAppname = function(value) {
  jspb.Message.setProto3StringField(this, 12, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.OrderUrgeInfoDetail.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.OrderUrgeInfoDetail.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.OrderUrgeInfoDetail} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.OrderUrgeInfoDetail.toObject = function(includeInstance, msg) {
  var f, obj = {
    orderid: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    debtor: jspb.Message.getFieldWithDefault(msg, 2, ""),
    mobile: jspb.Message.getFieldWithDefault(msg, 3, ""),
    loandate: jspb.Message.getFieldWithDefault(msg, 4, ""),
    duedate: jspb.Message.getFieldWithDefault(msg, 5, ""),
    loanamount: jspb.Message.getFieldWithDefault(msg, 6, 0),
    arrears: jspb.Message.getFieldWithDefault(msg, 7, 0),
    unit: jspb.Message.getFieldWithDefault(msg, 8, ""),
    comments: jspb.Message.getFieldWithDefault(msg, 9, ""),
    gender: jspb.Message.getFieldWithDefault(msg, 10, ""),
    overdueperiod: jspb.Message.getFieldWithDefault(msg, 11, ""),
    overdueday: jspb.Message.getFieldWithDefault(msg, 12, ""),
    minrepayamount: jspb.Message.getFieldWithDefault(msg, 13, ""),
    appname: jspb.Message.getFieldWithDefault(msg, 14, ""),
    extvarsMap: (f = msg.getExtvarsMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.OrderUrgeInfoDetail}
 */
proto.xcommon.OrderUrgeInfoDetail.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.OrderUrgeInfoDetail;
  return proto.xcommon.OrderUrgeInfoDetail.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.OrderUrgeInfoDetail} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.OrderUrgeInfoDetail}
 */
proto.xcommon.OrderUrgeInfoDetail.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDebtor(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMobile(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setLoandate(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setDuedate(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLoanamount(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setArrears(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setUnit(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setComments(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setGender(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setOverdueperiod(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setOverdueday(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setMinrepayamount(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    case 15:
      var value = msg.getExtvarsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "");
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.OrderUrgeInfoDetail.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.OrderUrgeInfoDetail.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.OrderUrgeInfoDetail} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.OrderUrgeInfoDetail.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      1,
      f
    );
  }
  f = message.getDebtor();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMobile();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getLoandate();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDuedate();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getLoanamount();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getArrears();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getUnit();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getComments();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getGender();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getOverdueperiod();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getOverdueday();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getMinrepayamount();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getExtvarsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(15, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
};


/**
 * optional int64 OrderId = 1;
 * @return {string}
 */
proto.xcommon.OrderUrgeInfoDetail.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/** @param {string} value */
proto.xcommon.OrderUrgeInfoDetail.prototype.setOrderid = function(value) {
  jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional string Debtor = 2;
 * @return {string}
 */
proto.xcommon.OrderUrgeInfoDetail.prototype.getDebtor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.OrderUrgeInfoDetail.prototype.setDebtor = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Mobile = 3;
 * @return {string}
 */
proto.xcommon.OrderUrgeInfoDetail.prototype.getMobile = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.OrderUrgeInfoDetail.prototype.setMobile = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string LoanDate = 4;
 * @return {string}
 */
proto.xcommon.OrderUrgeInfoDetail.prototype.getLoandate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.OrderUrgeInfoDetail.prototype.setLoandate = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string DueDate = 5;
 * @return {string}
 */
proto.xcommon.OrderUrgeInfoDetail.prototype.getDuedate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.xcommon.OrderUrgeInfoDetail.prototype.setDuedate = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int64 LoanAmount = 6;
 * @return {number}
 */
proto.xcommon.OrderUrgeInfoDetail.prototype.getLoanamount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.xcommon.OrderUrgeInfoDetail.prototype.setLoanamount = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 Arrears = 7;
 * @return {number}
 */
proto.xcommon.OrderUrgeInfoDetail.prototype.getArrears = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.xcommon.OrderUrgeInfoDetail.prototype.setArrears = function(value) {
  jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string Unit = 8;
 * @return {string}
 */
proto.xcommon.OrderUrgeInfoDetail.prototype.getUnit = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/** @param {string} value */
proto.xcommon.OrderUrgeInfoDetail.prototype.setUnit = function(value) {
  jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string Comments = 9;
 * @return {string}
 */
proto.xcommon.OrderUrgeInfoDetail.prototype.getComments = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/** @param {string} value */
proto.xcommon.OrderUrgeInfoDetail.prototype.setComments = function(value) {
  jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string Gender = 10;
 * @return {string}
 */
proto.xcommon.OrderUrgeInfoDetail.prototype.getGender = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/** @param {string} value */
proto.xcommon.OrderUrgeInfoDetail.prototype.setGender = function(value) {
  jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string OverduePeriod = 11;
 * @return {string}
 */
proto.xcommon.OrderUrgeInfoDetail.prototype.getOverdueperiod = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/** @param {string} value */
proto.xcommon.OrderUrgeInfoDetail.prototype.setOverdueperiod = function(value) {
  jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string OverdueDay = 12;
 * @return {string}
 */
proto.xcommon.OrderUrgeInfoDetail.prototype.getOverdueday = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/** @param {string} value */
proto.xcommon.OrderUrgeInfoDetail.prototype.setOverdueday = function(value) {
  jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string MinRepayAmount = 13;
 * @return {string}
 */
proto.xcommon.OrderUrgeInfoDetail.prototype.getMinrepayamount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/** @param {string} value */
proto.xcommon.OrderUrgeInfoDetail.prototype.setMinrepayamount = function(value) {
  jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string AppName = 14;
 * @return {string}
 */
proto.xcommon.OrderUrgeInfoDetail.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/** @param {string} value */
proto.xcommon.OrderUrgeInfoDetail.prototype.setAppname = function(value) {
  jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * map<string, string> ExtVars = 15;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.xcommon.OrderUrgeInfoDetail.prototype.getExtvarsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 15, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 */
proto.xcommon.OrderUrgeInfoDetail.prototype.clearExtvarsMap = function() {
  this.getExtvarsMap().clear();
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.SmsTaskParamList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SmsTaskParamList.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SmsTaskParamList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SmsTaskParamList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SmsTaskParamList.toObject = function(includeInstance, msg) {
  var f, obj = {
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.xcommon.SmsTaskParam.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SmsTaskParamList}
 */
proto.xcommon.SmsTaskParamList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SmsTaskParamList;
  return proto.xcommon.SmsTaskParamList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SmsTaskParamList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SmsTaskParamList}
 */
proto.xcommon.SmsTaskParamList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.xcommon.SmsTaskParam;
      reader.readMessage(value,proto.xcommon.SmsTaskParam.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SmsTaskParamList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SmsTaskParamList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SmsTaskParamList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SmsTaskParamList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.xcommon.SmsTaskParam.serializeBinaryToWriter
    );
  }
};


/**
 * repeated SmsTaskParam List = 1;
 * @return {!Array<!proto.xcommon.SmsTaskParam>}
 */
proto.xcommon.SmsTaskParamList.prototype.getListList = function() {
  return /** @type{!Array<!proto.xcommon.SmsTaskParam>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.SmsTaskParam, 1));
};


/** @param {!Array<!proto.xcommon.SmsTaskParam>} value */
proto.xcommon.SmsTaskParamList.prototype.setListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.xcommon.SmsTaskParam=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.SmsTaskParam}
 */
proto.xcommon.SmsTaskParamList.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.xcommon.SmsTaskParam, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.SmsTaskParamList.prototype.clearListList = function() {
  this.setListList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.SmsTaskParam.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SmsTaskParam.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SmsTaskParam.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SmsTaskParam} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SmsTaskParam.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    optionsList: jspb.Message.toObjectList(msg.getOptionsList(),
    proto.xcommon.SmsTaskParamOption.toObject, includeInstance),
    appname: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SmsTaskParam}
 */
proto.xcommon.SmsTaskParam.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SmsTaskParam;
  return proto.xcommon.SmsTaskParam.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SmsTaskParam} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SmsTaskParam}
 */
proto.xcommon.SmsTaskParam.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = new proto.xcommon.SmsTaskParamOption;
      reader.readMessage(value,proto.xcommon.SmsTaskParamOption.deserializeBinaryFromReader);
      msg.addOptions(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SmsTaskParam.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SmsTaskParam.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SmsTaskParam} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SmsTaskParam.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getOptionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.xcommon.SmsTaskParamOption.serializeBinaryToWriter
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional int64 Id = 1;
 * @return {number}
 */
proto.xcommon.SmsTaskParam.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.SmsTaskParam.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string Name = 2;
 * @return {string}
 */
proto.xcommon.SmsTaskParam.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.SmsTaskParam.prototype.setName = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated SmsTaskParamOption Options = 3;
 * @return {!Array<!proto.xcommon.SmsTaskParamOption>}
 */
proto.xcommon.SmsTaskParam.prototype.getOptionsList = function() {
  return /** @type{!Array<!proto.xcommon.SmsTaskParamOption>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.SmsTaskParamOption, 3));
};


/** @param {!Array<!proto.xcommon.SmsTaskParamOption>} value */
proto.xcommon.SmsTaskParam.prototype.setOptionsList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.xcommon.SmsTaskParamOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.SmsTaskParamOption}
 */
proto.xcommon.SmsTaskParam.prototype.addOptions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.xcommon.SmsTaskParamOption, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.SmsTaskParam.prototype.clearOptionsList = function() {
  this.setOptionsList([]);
};


/**
 * optional string AppName = 4;
 * @return {string}
 */
proto.xcommon.SmsTaskParam.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.SmsTaskParam.prototype.setAppname = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SmsTaskParamOption.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SmsTaskParamOption.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SmsTaskParamOption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SmsTaskParamOption.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    appname: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SmsTaskParamOption}
 */
proto.xcommon.SmsTaskParamOption.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SmsTaskParamOption;
  return proto.xcommon.SmsTaskParamOption.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SmsTaskParamOption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SmsTaskParamOption}
 */
proto.xcommon.SmsTaskParamOption.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SmsTaskParamOption.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SmsTaskParamOption.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SmsTaskParamOption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SmsTaskParamOption.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional int64 Id = 1;
 * @return {number}
 */
proto.xcommon.SmsTaskParamOption.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.SmsTaskParamOption.prototype.setId = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string Name = 2;
 * @return {string}
 */
proto.xcommon.SmsTaskParamOption.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.SmsTaskParamOption.prototype.setName = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string AppName = 3;
 * @return {string}
 */
proto.xcommon.SmsTaskParamOption.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.SmsTaskParamOption.prototype.setAppname = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SmsTaskParamValue.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SmsTaskParamValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SmsTaskParamValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SmsTaskParamValue.toObject = function(includeInstance, msg) {
  var f, obj = {
    paramid: jspb.Message.getFieldWithDefault(msg, 1, 0),
    option: (f = msg.getOption()) && proto.xcommon.SmsTaskParamOption.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SmsTaskParamValue}
 */
proto.xcommon.SmsTaskParamValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SmsTaskParamValue;
  return proto.xcommon.SmsTaskParamValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SmsTaskParamValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SmsTaskParamValue}
 */
proto.xcommon.SmsTaskParamValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setParamid(value);
      break;
    case 2:
      var value = new proto.xcommon.SmsTaskParamOption;
      reader.readMessage(value,proto.xcommon.SmsTaskParamOption.deserializeBinaryFromReader);
      msg.setOption(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SmsTaskParamValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SmsTaskParamValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SmsTaskParamValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SmsTaskParamValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getParamid();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getOption();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.xcommon.SmsTaskParamOption.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 ParamId = 1;
 * @return {number}
 */
proto.xcommon.SmsTaskParamValue.prototype.getParamid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.SmsTaskParamValue.prototype.setParamid = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional SmsTaskParamOption Option = 2;
 * @return {?proto.xcommon.SmsTaskParamOption}
 */
proto.xcommon.SmsTaskParamValue.prototype.getOption = function() {
  return /** @type{?proto.xcommon.SmsTaskParamOption} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.SmsTaskParamOption, 2));
};


/** @param {?proto.xcommon.SmsTaskParamOption|undefined} value */
proto.xcommon.SmsTaskParamValue.prototype.setOption = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.SmsTaskParamValue.prototype.clearOption = function() {
  this.setOption(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.SmsTaskParamValue.prototype.hasOption = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.CustomerInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.CustomerInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.CustomerInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CustomerInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    realname: jspb.Message.getFieldWithDefault(msg, 1, ""),
    gender: jspb.Message.getFieldWithDefault(msg, 2, 0),
    cardtype: jspb.Message.getFieldWithDefault(msg, 3, ""),
    identity: jspb.Message.getFieldWithDefault(msg, 4, ""),
    mobile: jspb.Message.getFieldWithDefault(msg, 5, ""),
    email: jspb.Message.getFieldWithDefault(msg, 6, ""),
    appversion: jspb.Message.getFieldWithDefault(msg, 7, ""),
    appversioncode: jspb.Message.getFieldWithDefault(msg, 8, ""),
    dateofbirth: jspb.Message.getFieldWithDefault(msg, 9, ""),
    education: jspb.Message.getFieldWithDefault(msg, 10, ""),
    familyphone: jspb.Message.getFieldWithDefault(msg, 11, ""),
    maritalstatus: jspb.Message.getFieldWithDefault(msg, 12, ""),
    childrennumber: jspb.Message.getFieldWithDefault(msg, 13, ""),
    residentstate: jspb.Message.getFieldWithDefault(msg, 14, ""),
    residentaddress: jspb.Message.getFieldWithDefault(msg, 15, ""),
    idphoto: jspb.Message.getFieldWithDefault(msg, 16, ""),
    idbackphoto: jspb.Message.getFieldWithDefault(msg, 17, ""),
    handheldidphoto: jspb.Message.getFieldWithDefault(msg, 18, ""),
    imagebest: jspb.Message.getFieldWithDefault(msg, 19, ""),
    imageenv: jspb.Message.getFieldWithDefault(msg, 20, ""),
    imageref1: jspb.Message.getFieldWithDefault(msg, 21, ""),
    imageref2: jspb.Message.getFieldWithDefault(msg, 22, ""),
    imageref3: jspb.Message.getFieldWithDefault(msg, 23, ""),
    bankcardtype: jspb.Message.getFieldWithDefault(msg, 24, ""),
    bankname: jspb.Message.getFieldWithDefault(msg, 25, ""),
    bankno: jspb.Message.getFieldWithDefault(msg, 26, ""),
    worktype: jspb.Message.getFieldWithDefault(msg, 27, ""),
    monthlyincome: jspb.Message.getFieldWithDefault(msg, 28, ""),
    serviceyears: jspb.Message.getFieldWithDefault(msg, 29, ""),
    companytelephone: jspb.Message.getFieldWithDefault(msg, 30, ""),
    companyname: jspb.Message.getFieldWithDefault(msg, 31, ""),
    companyaddress: jspb.Message.getFieldWithDefault(msg, 32, ""),
    salaryday: jspb.Message.getFieldWithDefault(msg, 33, ""),
    salarytype: jspb.Message.getFieldWithDefault(msg, 34, ""),
    indebt: jspb.Message.getFieldWithDefault(msg, 35, ""),
    contact1name: jspb.Message.getFieldWithDefault(msg, 36, ""),
    relationship1: jspb.Message.getFieldWithDefault(msg, 37, ""),
    contact1: jspb.Message.getFieldWithDefault(msg, 38, ""),
    contact2name: jspb.Message.getFieldWithDefault(msg, 39, ""),
    relationship2: jspb.Message.getFieldWithDefault(msg, 40, ""),
    contact2: jspb.Message.getFieldWithDefault(msg, 41, ""),
    contact3name: jspb.Message.getFieldWithDefault(msg, 42, ""),
    relationship3: jspb.Message.getFieldWithDefault(msg, 43, ""),
    contact3: jspb.Message.getFieldWithDefault(msg, 44, ""),
    resourceid: (f = msg.getResourceid()) && proto.xcommon.CustomerInfoResourceIDs.toObject(includeInstance, f),
    previmagebest: jspb.Message.getFieldWithDefault(msg, 46, ""),
    contact1status: jspb.Message.getFieldWithDefault(msg, 47, 0),
    contact2status: jspb.Message.getFieldWithDefault(msg, 48, 0),
    contact3status: jspb.Message.getFieldWithDefault(msg, 49, 0),
    mobilestatus: jspb.Message.getFieldWithDefault(msg, 50, 0),
    idphotosourceMap: (f = msg.getIdphotosourceMap()) ? f.toObject(includeInstance, undefined) : [],
    corporatelicense: jspb.Message.getFieldWithDefault(msg, 52, ""),
    corporateflow: jspb.Message.getFieldWithDefault(msg, 53, ""),
    corporateenv1: jspb.Message.getFieldWithDefault(msg, 54, ""),
    corporateenv2: jspb.Message.getFieldWithDefault(msg, 55, ""),
    corporatephone: jspb.Message.getFieldWithDefault(msg, 56, ""),
    utilitybills: jspb.Message.getFieldWithDefault(msg, 57, ""),
    socialinsurance: jspb.Message.getFieldWithDefault(msg, 58, ""),
    salaryproof: jspb.Message.getFieldWithDefault(msg, 59, ""),
    identifyexpire: jspb.Message.getFieldWithDefault(msg, 60, ""),
    accounttype: jspb.Message.getFieldWithDefault(msg, 61, ""),
    walletname: jspb.Message.getFieldWithDefault(msg, 62, ""),
    accountname: jspb.Message.getFieldWithDefault(msg, 63, ""),
    accountno: jspb.Message.getFieldWithDefault(msg, 64, ""),
    avgincomelastthreemonth: jspb.Message.getFieldWithDefault(msg, 65, ""),
    avgexpenseslastthreemonth: jspb.Message.getFieldWithDefault(msg, 66, ""),
    imageaccount: jspb.Message.getFieldWithDefault(msg, 67, ""),
    imageaccountflow: jspb.Message.getFieldWithDefault(msg, 68, ""),
    paymenttype: jspb.Message.getFieldWithDefault(msg, 69, ""),
    paymentdate: jspb.Message.getFieldWithDefault(msg, 70, ""),
    paymentamount: jspb.Message.getFieldWithDefault(msg, 71, ""),
    paymentstate: jspb.Message.getFieldWithDefault(msg, 72, ""),
    paymentcity: jspb.Message.getFieldWithDefault(msg, 73, ""),
    paymentaddress: jspb.Message.getFieldWithDefault(msg, 74, ""),
    housingstatus: jspb.Message.getFieldWithDefault(msg, 75, ""),
    imagepayment: jspb.Message.getFieldWithDefault(msg, 76, ""),
    imagehousingstatus: jspb.Message.getFieldWithDefault(msg, 77, ""),
    contact4: jspb.Message.getFieldWithDefault(msg, 78, ""),
    contact4name: jspb.Message.getFieldWithDefault(msg, 79, ""),
    relationship4: jspb.Message.getFieldWithDefault(msg, 80, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.CustomerInfo}
 */
proto.xcommon.CustomerInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.CustomerInfo;
  return proto.xcommon.CustomerInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.CustomerInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.CustomerInfo}
 */
proto.xcommon.CustomerInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRealname(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setGender(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCardtype(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdentity(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setMobile(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppversion(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppversioncode(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setDateofbirth(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setEducation(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setFamilyphone(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setMaritalstatus(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setChildrennumber(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setResidentstate(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setResidentaddress(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdphoto(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdbackphoto(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setHandheldidphoto(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setImagebest(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setImageenv(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setImageref1(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readString());
      msg.setImageref2(value);
      break;
    case 23:
      var value = /** @type {string} */ (reader.readString());
      msg.setImageref3(value);
      break;
    case 24:
      var value = /** @type {string} */ (reader.readString());
      msg.setBankcardtype(value);
      break;
    case 25:
      var value = /** @type {string} */ (reader.readString());
      msg.setBankname(value);
      break;
    case 26:
      var value = /** @type {string} */ (reader.readString());
      msg.setBankno(value);
      break;
    case 27:
      var value = /** @type {string} */ (reader.readString());
      msg.setWorktype(value);
      break;
    case 28:
      var value = /** @type {string} */ (reader.readString());
      msg.setMonthlyincome(value);
      break;
    case 29:
      var value = /** @type {string} */ (reader.readString());
      msg.setServiceyears(value);
      break;
    case 30:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompanytelephone(value);
      break;
    case 31:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompanyname(value);
      break;
    case 32:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompanyaddress(value);
      break;
    case 33:
      var value = /** @type {string} */ (reader.readString());
      msg.setSalaryday(value);
      break;
    case 34:
      var value = /** @type {string} */ (reader.readString());
      msg.setSalarytype(value);
      break;
    case 35:
      var value = /** @type {string} */ (reader.readString());
      msg.setIndebt(value);
      break;
    case 36:
      var value = /** @type {string} */ (reader.readString());
      msg.setContact1name(value);
      break;
    case 37:
      var value = /** @type {string} */ (reader.readString());
      msg.setRelationship1(value);
      break;
    case 38:
      var value = /** @type {string} */ (reader.readString());
      msg.setContact1(value);
      break;
    case 39:
      var value = /** @type {string} */ (reader.readString());
      msg.setContact2name(value);
      break;
    case 40:
      var value = /** @type {string} */ (reader.readString());
      msg.setRelationship2(value);
      break;
    case 41:
      var value = /** @type {string} */ (reader.readString());
      msg.setContact2(value);
      break;
    case 42:
      var value = /** @type {string} */ (reader.readString());
      msg.setContact3name(value);
      break;
    case 43:
      var value = /** @type {string} */ (reader.readString());
      msg.setRelationship3(value);
      break;
    case 44:
      var value = /** @type {string} */ (reader.readString());
      msg.setContact3(value);
      break;
    case 45:
      var value = new proto.xcommon.CustomerInfoResourceIDs;
      reader.readMessage(value,proto.xcommon.CustomerInfoResourceIDs.deserializeBinaryFromReader);
      msg.setResourceid(value);
      break;
    case 46:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrevimagebest(value);
      break;
    case 47:
      var value = /** @type {!proto.xcommon.ContactStatusEnum} */ (reader.readEnum());
      msg.setContact1status(value);
      break;
    case 48:
      var value = /** @type {!proto.xcommon.ContactStatusEnum} */ (reader.readEnum());
      msg.setContact2status(value);
      break;
    case 49:
      var value = /** @type {!proto.xcommon.ContactStatusEnum} */ (reader.readEnum());
      msg.setContact3status(value);
      break;
    case 50:
      var value = /** @type {!proto.xcommon.ContactStatusEnum} */ (reader.readEnum());
      msg.setMobilestatus(value);
      break;
    case 51:
      var value = msg.getIdphotosourceMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "");
         });
      break;
    case 52:
      var value = /** @type {string} */ (reader.readString());
      msg.setCorporatelicense(value);
      break;
    case 53:
      var value = /** @type {string} */ (reader.readString());
      msg.setCorporateflow(value);
      break;
    case 54:
      var value = /** @type {string} */ (reader.readString());
      msg.setCorporateenv1(value);
      break;
    case 55:
      var value = /** @type {string} */ (reader.readString());
      msg.setCorporateenv2(value);
      break;
    case 56:
      var value = /** @type {string} */ (reader.readString());
      msg.setCorporatephone(value);
      break;
    case 57:
      var value = /** @type {string} */ (reader.readString());
      msg.setUtilitybills(value);
      break;
    case 58:
      var value = /** @type {string} */ (reader.readString());
      msg.setSocialinsurance(value);
      break;
    case 59:
      var value = /** @type {string} */ (reader.readString());
      msg.setSalaryproof(value);
      break;
    case 60:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdentifyexpire(value);
      break;
    case 61:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccounttype(value);
      break;
    case 62:
      var value = /** @type {string} */ (reader.readString());
      msg.setWalletname(value);
      break;
    case 63:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountname(value);
      break;
    case 64:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountno(value);
      break;
    case 65:
      var value = /** @type {string} */ (reader.readString());
      msg.setAvgincomelastthreemonth(value);
      break;
    case 66:
      var value = /** @type {string} */ (reader.readString());
      msg.setAvgexpenseslastthreemonth(value);
      break;
    case 67:
      var value = /** @type {string} */ (reader.readString());
      msg.setImageaccount(value);
      break;
    case 68:
      var value = /** @type {string} */ (reader.readString());
      msg.setImageaccountflow(value);
      break;
    case 69:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaymenttype(value);
      break;
    case 70:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaymentdate(value);
      break;
    case 71:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaymentamount(value);
      break;
    case 72:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaymentstate(value);
      break;
    case 73:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaymentcity(value);
      break;
    case 74:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaymentaddress(value);
      break;
    case 75:
      var value = /** @type {string} */ (reader.readString());
      msg.setHousingstatus(value);
      break;
    case 76:
      var value = /** @type {string} */ (reader.readString());
      msg.setImagepayment(value);
      break;
    case 77:
      var value = /** @type {string} */ (reader.readString());
      msg.setImagehousingstatus(value);
      break;
    case 78:
      var value = /** @type {string} */ (reader.readString());
      msg.setContact4(value);
      break;
    case 79:
      var value = /** @type {string} */ (reader.readString());
      msg.setContact4name(value);
      break;
    case 80:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRelationship4(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.CustomerInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.CustomerInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.CustomerInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CustomerInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRealname();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getGender();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getCardtype();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getIdentity();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getMobile();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getAppversion();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getAppversioncode();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getDateofbirth();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getEducation();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getFamilyphone();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getMaritalstatus();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getChildrennumber();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getResidentstate();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getResidentaddress();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getIdphoto();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getIdbackphoto();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getHandheldidphoto();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getImagebest();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getImageenv();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getImageref1();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getImageref2();
  if (f.length > 0) {
    writer.writeString(
      22,
      f
    );
  }
  f = message.getImageref3();
  if (f.length > 0) {
    writer.writeString(
      23,
      f
    );
  }
  f = message.getBankcardtype();
  if (f.length > 0) {
    writer.writeString(
      24,
      f
    );
  }
  f = message.getBankname();
  if (f.length > 0) {
    writer.writeString(
      25,
      f
    );
  }
  f = message.getBankno();
  if (f.length > 0) {
    writer.writeString(
      26,
      f
    );
  }
  f = message.getWorktype();
  if (f.length > 0) {
    writer.writeString(
      27,
      f
    );
  }
  f = message.getMonthlyincome();
  if (f.length > 0) {
    writer.writeString(
      28,
      f
    );
  }
  f = message.getServiceyears();
  if (f.length > 0) {
    writer.writeString(
      29,
      f
    );
  }
  f = message.getCompanytelephone();
  if (f.length > 0) {
    writer.writeString(
      30,
      f
    );
  }
  f = message.getCompanyname();
  if (f.length > 0) {
    writer.writeString(
      31,
      f
    );
  }
  f = message.getCompanyaddress();
  if (f.length > 0) {
    writer.writeString(
      32,
      f
    );
  }
  f = message.getSalaryday();
  if (f.length > 0) {
    writer.writeString(
      33,
      f
    );
  }
  f = message.getSalarytype();
  if (f.length > 0) {
    writer.writeString(
      34,
      f
    );
  }
  f = message.getIndebt();
  if (f.length > 0) {
    writer.writeString(
      35,
      f
    );
  }
  f = message.getContact1name();
  if (f.length > 0) {
    writer.writeString(
      36,
      f
    );
  }
  f = message.getRelationship1();
  if (f.length > 0) {
    writer.writeString(
      37,
      f
    );
  }
  f = message.getContact1();
  if (f.length > 0) {
    writer.writeString(
      38,
      f
    );
  }
  f = message.getContact2name();
  if (f.length > 0) {
    writer.writeString(
      39,
      f
    );
  }
  f = message.getRelationship2();
  if (f.length > 0) {
    writer.writeString(
      40,
      f
    );
  }
  f = message.getContact2();
  if (f.length > 0) {
    writer.writeString(
      41,
      f
    );
  }
  f = message.getContact3name();
  if (f.length > 0) {
    writer.writeString(
      42,
      f
    );
  }
  f = message.getRelationship3();
  if (f.length > 0) {
    writer.writeString(
      43,
      f
    );
  }
  f = message.getContact3();
  if (f.length > 0) {
    writer.writeString(
      44,
      f
    );
  }
  f = message.getResourceid();
  if (f != null) {
    writer.writeMessage(
      45,
      f,
      proto.xcommon.CustomerInfoResourceIDs.serializeBinaryToWriter
    );
  }
  f = message.getPrevimagebest();
  if (f.length > 0) {
    writer.writeString(
      46,
      f
    );
  }
  f = message.getContact1status();
  if (f !== 0.0) {
    writer.writeEnum(
      47,
      f
    );
  }
  f = message.getContact2status();
  if (f !== 0.0) {
    writer.writeEnum(
      48,
      f
    );
  }
  f = message.getContact3status();
  if (f !== 0.0) {
    writer.writeEnum(
      49,
      f
    );
  }
  f = message.getMobilestatus();
  if (f !== 0.0) {
    writer.writeEnum(
      50,
      f
    );
  }
  f = message.getIdphotosourceMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(51, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getCorporatelicense();
  if (f.length > 0) {
    writer.writeString(
      52,
      f
    );
  }
  f = message.getCorporateflow();
  if (f.length > 0) {
    writer.writeString(
      53,
      f
    );
  }
  f = message.getCorporateenv1();
  if (f.length > 0) {
    writer.writeString(
      54,
      f
    );
  }
  f = message.getCorporateenv2();
  if (f.length > 0) {
    writer.writeString(
      55,
      f
    );
  }
  f = message.getCorporatephone();
  if (f.length > 0) {
    writer.writeString(
      56,
      f
    );
  }
  f = message.getUtilitybills();
  if (f.length > 0) {
    writer.writeString(
      57,
      f
    );
  }
  f = message.getSocialinsurance();
  if (f.length > 0) {
    writer.writeString(
      58,
      f
    );
  }
  f = message.getSalaryproof();
  if (f.length > 0) {
    writer.writeString(
      59,
      f
    );
  }
  f = message.getIdentifyexpire();
  if (f.length > 0) {
    writer.writeString(
      60,
      f
    );
  }
  f = message.getAccounttype();
  if (f.length > 0) {
    writer.writeString(
      61,
      f
    );
  }
  f = message.getWalletname();
  if (f.length > 0) {
    writer.writeString(
      62,
      f
    );
  }
  f = message.getAccountname();
  if (f.length > 0) {
    writer.writeString(
      63,
      f
    );
  }
  f = message.getAccountno();
  if (f.length > 0) {
    writer.writeString(
      64,
      f
    );
  }
  f = message.getAvgincomelastthreemonth();
  if (f.length > 0) {
    writer.writeString(
      65,
      f
    );
  }
  f = message.getAvgexpenseslastthreemonth();
  if (f.length > 0) {
    writer.writeString(
      66,
      f
    );
  }
  f = message.getImageaccount();
  if (f.length > 0) {
    writer.writeString(
      67,
      f
    );
  }
  f = message.getImageaccountflow();
  if (f.length > 0) {
    writer.writeString(
      68,
      f
    );
  }
  f = message.getPaymenttype();
  if (f.length > 0) {
    writer.writeString(
      69,
      f
    );
  }
  f = message.getPaymentdate();
  if (f.length > 0) {
    writer.writeString(
      70,
      f
    );
  }
  f = message.getPaymentamount();
  if (f.length > 0) {
    writer.writeString(
      71,
      f
    );
  }
  f = message.getPaymentstate();
  if (f.length > 0) {
    writer.writeString(
      72,
      f
    );
  }
  f = message.getPaymentcity();
  if (f.length > 0) {
    writer.writeString(
      73,
      f
    );
  }
  f = message.getPaymentaddress();
  if (f.length > 0) {
    writer.writeString(
      74,
      f
    );
  }
  f = message.getHousingstatus();
  if (f.length > 0) {
    writer.writeString(
      75,
      f
    );
  }
  f = message.getImagepayment();
  if (f.length > 0) {
    writer.writeString(
      76,
      f
    );
  }
  f = message.getImagehousingstatus();
  if (f.length > 0) {
    writer.writeString(
      77,
      f
    );
  }
  f = message.getContact4();
  if (f.length > 0) {
    writer.writeString(
      78,
      f
    );
  }
  f = message.getContact4name();
  if (f.length > 0) {
    writer.writeString(
      79,
      f
    );
  }
  f = message.getRelationship4();
  if (f !== 0) {
    writer.writeInt32(
      80,
      f
    );
  }
};


/**
 * optional string Realname = 1;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getRealname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setRealname = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 Gender = 2;
 * @return {number}
 */
proto.xcommon.CustomerInfo.prototype.getGender = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.CustomerInfo.prototype.setGender = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string CardType = 3;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getCardtype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setCardtype = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string Identity = 4;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getIdentity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setIdentity = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string Mobile = 5;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getMobile = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setMobile = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string Email = 6;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setEmail = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string AppVersion = 7;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getAppversion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setAppversion = function(value) {
  jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string AppVersionCode = 8;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getAppversioncode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setAppversioncode = function(value) {
  jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string DateOfBirth = 9;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getDateofbirth = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setDateofbirth = function(value) {
  jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string Education = 10;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getEducation = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setEducation = function(value) {
  jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string FamilyPhone = 11;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getFamilyphone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setFamilyphone = function(value) {
  jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string MaritalStatus = 12;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getMaritalstatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setMaritalstatus = function(value) {
  jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string ChildrenNumber = 13;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getChildrennumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setChildrennumber = function(value) {
  jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string ResidentState = 14;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getResidentstate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setResidentstate = function(value) {
  jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string ResidentAddress = 15;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getResidentaddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setResidentaddress = function(value) {
  jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string IdPhoto = 16;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getIdphoto = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setIdphoto = function(value) {
  jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string IdBackPhoto = 17;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getIdbackphoto = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setIdbackphoto = function(value) {
  jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string HandHeldIdPhoto = 18;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getHandheldidphoto = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setHandheldidphoto = function(value) {
  jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional string ImageBest = 19;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getImagebest = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setImagebest = function(value) {
  jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional string ImageEnv = 20;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getImageenv = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setImageenv = function(value) {
  jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional string ImageRef1 = 21;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getImageref1 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setImageref1 = function(value) {
  jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional string ImageRef2 = 22;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getImageref2 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setImageref2 = function(value) {
  jspb.Message.setProto3StringField(this, 22, value);
};


/**
 * optional string ImageRef3 = 23;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getImageref3 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 23, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setImageref3 = function(value) {
  jspb.Message.setProto3StringField(this, 23, value);
};


/**
 * optional string BankCardType = 24;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getBankcardtype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 24, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setBankcardtype = function(value) {
  jspb.Message.setProto3StringField(this, 24, value);
};


/**
 * optional string BankName = 25;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getBankname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 25, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setBankname = function(value) {
  jspb.Message.setProto3StringField(this, 25, value);
};


/**
 * optional string BankNo = 26;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getBankno = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 26, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setBankno = function(value) {
  jspb.Message.setProto3StringField(this, 26, value);
};


/**
 * optional string WorkType = 27;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getWorktype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 27, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setWorktype = function(value) {
  jspb.Message.setProto3StringField(this, 27, value);
};


/**
 * optional string MonthlyIncome = 28;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getMonthlyincome = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 28, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setMonthlyincome = function(value) {
  jspb.Message.setProto3StringField(this, 28, value);
};


/**
 * optional string ServiceYears = 29;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getServiceyears = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 29, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setServiceyears = function(value) {
  jspb.Message.setProto3StringField(this, 29, value);
};


/**
 * optional string CompanyTelephone = 30;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getCompanytelephone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 30, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setCompanytelephone = function(value) {
  jspb.Message.setProto3StringField(this, 30, value);
};


/**
 * optional string CompanyName = 31;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getCompanyname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 31, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setCompanyname = function(value) {
  jspb.Message.setProto3StringField(this, 31, value);
};


/**
 * optional string CompanyAddress = 32;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getCompanyaddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 32, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setCompanyaddress = function(value) {
  jspb.Message.setProto3StringField(this, 32, value);
};


/**
 * optional string SalaryDay = 33;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getSalaryday = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 33, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setSalaryday = function(value) {
  jspb.Message.setProto3StringField(this, 33, value);
};


/**
 * optional string SalaryType = 34;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getSalarytype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 34, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setSalarytype = function(value) {
  jspb.Message.setProto3StringField(this, 34, value);
};


/**
 * optional string InDebt = 35;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getIndebt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 35, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setIndebt = function(value) {
  jspb.Message.setProto3StringField(this, 35, value);
};


/**
 * optional string Contact1Name = 36;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getContact1name = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 36, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setContact1name = function(value) {
  jspb.Message.setProto3StringField(this, 36, value);
};


/**
 * optional string Relationship1 = 37;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getRelationship1 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 37, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setRelationship1 = function(value) {
  jspb.Message.setProto3StringField(this, 37, value);
};


/**
 * optional string Contact1 = 38;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getContact1 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 38, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setContact1 = function(value) {
  jspb.Message.setProto3StringField(this, 38, value);
};


/**
 * optional string Contact2Name = 39;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getContact2name = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 39, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setContact2name = function(value) {
  jspb.Message.setProto3StringField(this, 39, value);
};


/**
 * optional string Relationship2 = 40;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getRelationship2 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 40, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setRelationship2 = function(value) {
  jspb.Message.setProto3StringField(this, 40, value);
};


/**
 * optional string Contact2 = 41;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getContact2 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 41, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setContact2 = function(value) {
  jspb.Message.setProto3StringField(this, 41, value);
};


/**
 * optional string Contact3Name = 42;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getContact3name = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 42, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setContact3name = function(value) {
  jspb.Message.setProto3StringField(this, 42, value);
};


/**
 * optional string Relationship3 = 43;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getRelationship3 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 43, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setRelationship3 = function(value) {
  jspb.Message.setProto3StringField(this, 43, value);
};


/**
 * optional string Contact3 = 44;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getContact3 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 44, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setContact3 = function(value) {
  jspb.Message.setProto3StringField(this, 44, value);
};


/**
 * optional CustomerInfoResourceIDs ResourceID = 45;
 * @return {?proto.xcommon.CustomerInfoResourceIDs}
 */
proto.xcommon.CustomerInfo.prototype.getResourceid = function() {
  return /** @type{?proto.xcommon.CustomerInfoResourceIDs} */ (
    jspb.Message.getWrapperField(this, proto.xcommon.CustomerInfoResourceIDs, 45));
};


/** @param {?proto.xcommon.CustomerInfoResourceIDs|undefined} value */
proto.xcommon.CustomerInfo.prototype.setResourceid = function(value) {
  jspb.Message.setWrapperField(this, 45, value);
};


/**
 * Clears the message field making it undefined.
 */
proto.xcommon.CustomerInfo.prototype.clearResourceid = function() {
  this.setResourceid(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.xcommon.CustomerInfo.prototype.hasResourceid = function() {
  return jspb.Message.getField(this, 45) != null;
};


/**
 * optional string PrevImageBest = 46;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getPrevimagebest = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 46, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setPrevimagebest = function(value) {
  jspb.Message.setProto3StringField(this, 46, value);
};


/**
 * optional ContactStatusEnum Contact1Status = 47;
 * @return {!proto.xcommon.ContactStatusEnum}
 */
proto.xcommon.CustomerInfo.prototype.getContact1status = function() {
  return /** @type {!proto.xcommon.ContactStatusEnum} */ (jspb.Message.getFieldWithDefault(this, 47, 0));
};


/** @param {!proto.xcommon.ContactStatusEnum} value */
proto.xcommon.CustomerInfo.prototype.setContact1status = function(value) {
  jspb.Message.setProto3EnumField(this, 47, value);
};


/**
 * optional ContactStatusEnum Contact2Status = 48;
 * @return {!proto.xcommon.ContactStatusEnum}
 */
proto.xcommon.CustomerInfo.prototype.getContact2status = function() {
  return /** @type {!proto.xcommon.ContactStatusEnum} */ (jspb.Message.getFieldWithDefault(this, 48, 0));
};


/** @param {!proto.xcommon.ContactStatusEnum} value */
proto.xcommon.CustomerInfo.prototype.setContact2status = function(value) {
  jspb.Message.setProto3EnumField(this, 48, value);
};


/**
 * optional ContactStatusEnum Contact3Status = 49;
 * @return {!proto.xcommon.ContactStatusEnum}
 */
proto.xcommon.CustomerInfo.prototype.getContact3status = function() {
  return /** @type {!proto.xcommon.ContactStatusEnum} */ (jspb.Message.getFieldWithDefault(this, 49, 0));
};


/** @param {!proto.xcommon.ContactStatusEnum} value */
proto.xcommon.CustomerInfo.prototype.setContact3status = function(value) {
  jspb.Message.setProto3EnumField(this, 49, value);
};


/**
 * optional ContactStatusEnum MobileStatus = 50;
 * @return {!proto.xcommon.ContactStatusEnum}
 */
proto.xcommon.CustomerInfo.prototype.getMobilestatus = function() {
  return /** @type {!proto.xcommon.ContactStatusEnum} */ (jspb.Message.getFieldWithDefault(this, 50, 0));
};


/** @param {!proto.xcommon.ContactStatusEnum} value */
proto.xcommon.CustomerInfo.prototype.setMobilestatus = function(value) {
  jspb.Message.setProto3EnumField(this, 50, value);
};


/**
 * map<string, string> IdPhotoSource = 51;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.xcommon.CustomerInfo.prototype.getIdphotosourceMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 51, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 */
proto.xcommon.CustomerInfo.prototype.clearIdphotosourceMap = function() {
  this.getIdphotosourceMap().clear();
};


/**
 * optional string CorporateLicense = 52;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getCorporatelicense = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 52, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setCorporatelicense = function(value) {
  jspb.Message.setProto3StringField(this, 52, value);
};


/**
 * optional string CorporateFlow = 53;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getCorporateflow = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 53, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setCorporateflow = function(value) {
  jspb.Message.setProto3StringField(this, 53, value);
};


/**
 * optional string CorporateEnv1 = 54;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getCorporateenv1 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 54, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setCorporateenv1 = function(value) {
  jspb.Message.setProto3StringField(this, 54, value);
};


/**
 * optional string CorporateEnv2 = 55;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getCorporateenv2 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 55, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setCorporateenv2 = function(value) {
  jspb.Message.setProto3StringField(this, 55, value);
};


/**
 * optional string CorporatePhone = 56;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getCorporatephone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 56, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setCorporatephone = function(value) {
  jspb.Message.setProto3StringField(this, 56, value);
};


/**
 * optional string UtilityBills = 57;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getUtilitybills = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 57, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setUtilitybills = function(value) {
  jspb.Message.setProto3StringField(this, 57, value);
};


/**
 * optional string SocialInsurance = 58;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getSocialinsurance = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 58, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setSocialinsurance = function(value) {
  jspb.Message.setProto3StringField(this, 58, value);
};


/**
 * optional string SalaryProof = 59;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getSalaryproof = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 59, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setSalaryproof = function(value) {
  jspb.Message.setProto3StringField(this, 59, value);
};


/**
 * optional string IdentifyExpire = 60;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getIdentifyexpire = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 60, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setIdentifyexpire = function(value) {
  jspb.Message.setProto3StringField(this, 60, value);
};


/**
 * optional string AccountType = 61;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getAccounttype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 61, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setAccounttype = function(value) {
  jspb.Message.setProto3StringField(this, 61, value);
};


/**
 * optional string WalletName = 62;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getWalletname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 62, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setWalletname = function(value) {
  jspb.Message.setProto3StringField(this, 62, value);
};


/**
 * optional string AccountName = 63;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getAccountname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 63, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setAccountname = function(value) {
  jspb.Message.setProto3StringField(this, 63, value);
};


/**
 * optional string AccountNo = 64;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getAccountno = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 64, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setAccountno = function(value) {
  jspb.Message.setProto3StringField(this, 64, value);
};


/**
 * optional string AvgIncomeLastThreeMonth = 65;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getAvgincomelastthreemonth = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 65, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setAvgincomelastthreemonth = function(value) {
  jspb.Message.setProto3StringField(this, 65, value);
};


/**
 * optional string AvgExpensesLastThreeMonth = 66;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getAvgexpenseslastthreemonth = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 66, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setAvgexpenseslastthreemonth = function(value) {
  jspb.Message.setProto3StringField(this, 66, value);
};


/**
 * optional string ImageAccount = 67;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getImageaccount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 67, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setImageaccount = function(value) {
  jspb.Message.setProto3StringField(this, 67, value);
};


/**
 * optional string ImageAccountFlow = 68;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getImageaccountflow = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 68, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setImageaccountflow = function(value) {
  jspb.Message.setProto3StringField(this, 68, value);
};


/**
 * optional string PaymentType = 69;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getPaymenttype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 69, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setPaymenttype = function(value) {
  jspb.Message.setProto3StringField(this, 69, value);
};


/**
 * optional string PaymentDate = 70;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getPaymentdate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 70, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setPaymentdate = function(value) {
  jspb.Message.setProto3StringField(this, 70, value);
};


/**
 * optional string PaymentAmount = 71;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getPaymentamount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 71, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setPaymentamount = function(value) {
  jspb.Message.setProto3StringField(this, 71, value);
};


/**
 * optional string PaymentState = 72;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getPaymentstate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 72, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setPaymentstate = function(value) {
  jspb.Message.setProto3StringField(this, 72, value);
};


/**
 * optional string PaymentCity = 73;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getPaymentcity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 73, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setPaymentcity = function(value) {
  jspb.Message.setProto3StringField(this, 73, value);
};


/**
 * optional string PaymentAddress = 74;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getPaymentaddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 74, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setPaymentaddress = function(value) {
  jspb.Message.setProto3StringField(this, 74, value);
};


/**
 * optional string HousingStatus = 75;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getHousingstatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 75, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setHousingstatus = function(value) {
  jspb.Message.setProto3StringField(this, 75, value);
};


/**
 * optional string ImagePayment = 76;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getImagepayment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 76, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setImagepayment = function(value) {
  jspb.Message.setProto3StringField(this, 76, value);
};


/**
 * optional string ImageHousingStatus = 77;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getImagehousingstatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 77, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setImagehousingstatus = function(value) {
  jspb.Message.setProto3StringField(this, 77, value);
};


/**
 * optional string Contact4 = 78;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getContact4 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 78, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setContact4 = function(value) {
  jspb.Message.setProto3StringField(this, 78, value);
};


/**
 * optional string Contact4Name = 79;
 * @return {string}
 */
proto.xcommon.CustomerInfo.prototype.getContact4name = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 79, ""));
};


/** @param {string} value */
proto.xcommon.CustomerInfo.prototype.setContact4name = function(value) {
  jspb.Message.setProto3StringField(this, 79, value);
};


/**
 * optional int32 Relationship4 = 80;
 * @return {number}
 */
proto.xcommon.CustomerInfo.prototype.getRelationship4 = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 80, 0));
};


/** @param {number} value */
proto.xcommon.CustomerInfo.prototype.setRelationship4 = function(value) {
  jspb.Message.setProto3IntField(this, 80, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.CustomerInfoResourceIDs.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.CustomerInfoResourceIDs.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.CustomerInfoResourceIDs} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CustomerInfoResourceIDs.toObject = function(includeInstance, msg) {
  var f, obj = {
    idphoto: jspb.Message.getFieldWithDefault(msg, 1, 0),
    idbackphoto: jspb.Message.getFieldWithDefault(msg, 2, 0),
    handheldidphoto: jspb.Message.getFieldWithDefault(msg, 3, 0),
    imagebest: jspb.Message.getFieldWithDefault(msg, 4, 0),
    imageenv: jspb.Message.getFieldWithDefault(msg, 5, 0),
    imageref1: jspb.Message.getFieldWithDefault(msg, 6, 0),
    imageref2: jspb.Message.getFieldWithDefault(msg, 7, 0),
    imageref3: jspb.Message.getFieldWithDefault(msg, 8, 0),
    previmagebest: jspb.Message.getFieldWithDefault(msg, 9, 0),
    corporatelicense: jspb.Message.getFieldWithDefault(msg, 10, 0),
    corporateflow: jspb.Message.getFieldWithDefault(msg, 11, 0),
    corporateenv1: jspb.Message.getFieldWithDefault(msg, 12, 0),
    corporateenv2: jspb.Message.getFieldWithDefault(msg, 13, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.CustomerInfoResourceIDs}
 */
proto.xcommon.CustomerInfoResourceIDs.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.CustomerInfoResourceIDs;
  return proto.xcommon.CustomerInfoResourceIDs.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.CustomerInfoResourceIDs} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.CustomerInfoResourceIDs}
 */
proto.xcommon.CustomerInfoResourceIDs.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setIdphoto(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setIdbackphoto(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setHandheldidphoto(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setImagebest(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setImageenv(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setImageref1(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setImageref2(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setImageref3(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPrevimagebest(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCorporatelicense(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCorporateflow(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCorporateenv1(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCorporateenv2(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.CustomerInfoResourceIDs.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.CustomerInfoResourceIDs.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.CustomerInfoResourceIDs} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CustomerInfoResourceIDs.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIdphoto();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getIdbackphoto();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getHandheldidphoto();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getImagebest();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getImageenv();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getImageref1();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getImageref2();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getImageref3();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getPrevimagebest();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getCorporatelicense();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getCorporateflow();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
  f = message.getCorporateenv1();
  if (f !== 0) {
    writer.writeInt64(
      12,
      f
    );
  }
  f = message.getCorporateenv2();
  if (f !== 0) {
    writer.writeInt64(
      13,
      f
    );
  }
};


/**
 * optional int64 IdPhoto = 1;
 * @return {number}
 */
proto.xcommon.CustomerInfoResourceIDs.prototype.getIdphoto = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.CustomerInfoResourceIDs.prototype.setIdphoto = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 IdBackPhoto = 2;
 * @return {number}
 */
proto.xcommon.CustomerInfoResourceIDs.prototype.getIdbackphoto = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.CustomerInfoResourceIDs.prototype.setIdbackphoto = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 HandHeldIdPhoto = 3;
 * @return {number}
 */
proto.xcommon.CustomerInfoResourceIDs.prototype.getHandheldidphoto = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.CustomerInfoResourceIDs.prototype.setHandheldidphoto = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 ImageBest = 4;
 * @return {number}
 */
proto.xcommon.CustomerInfoResourceIDs.prototype.getImagebest = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.CustomerInfoResourceIDs.prototype.setImagebest = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 ImageEnv = 5;
 * @return {number}
 */
proto.xcommon.CustomerInfoResourceIDs.prototype.getImageenv = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.CustomerInfoResourceIDs.prototype.setImageenv = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 ImageRef1 = 6;
 * @return {number}
 */
proto.xcommon.CustomerInfoResourceIDs.prototype.getImageref1 = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.xcommon.CustomerInfoResourceIDs.prototype.setImageref1 = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 ImageRef2 = 7;
 * @return {number}
 */
proto.xcommon.CustomerInfoResourceIDs.prototype.getImageref2 = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.xcommon.CustomerInfoResourceIDs.prototype.setImageref2 = function(value) {
  jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int64 ImageRef3 = 8;
 * @return {number}
 */
proto.xcommon.CustomerInfoResourceIDs.prototype.getImageref3 = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/** @param {number} value */
proto.xcommon.CustomerInfoResourceIDs.prototype.setImageref3 = function(value) {
  jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int64 PrevImageBest = 9;
 * @return {number}
 */
proto.xcommon.CustomerInfoResourceIDs.prototype.getPrevimagebest = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/** @param {number} value */
proto.xcommon.CustomerInfoResourceIDs.prototype.setPrevimagebest = function(value) {
  jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int64 CorporateLicense = 10;
 * @return {number}
 */
proto.xcommon.CustomerInfoResourceIDs.prototype.getCorporatelicense = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/** @param {number} value */
proto.xcommon.CustomerInfoResourceIDs.prototype.setCorporatelicense = function(value) {
  jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int64 CorporateFlow = 11;
 * @return {number}
 */
proto.xcommon.CustomerInfoResourceIDs.prototype.getCorporateflow = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/** @param {number} value */
proto.xcommon.CustomerInfoResourceIDs.prototype.setCorporateflow = function(value) {
  jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional int64 CorporateEnv1 = 12;
 * @return {number}
 */
proto.xcommon.CustomerInfoResourceIDs.prototype.getCorporateenv1 = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/** @param {number} value */
proto.xcommon.CustomerInfoResourceIDs.prototype.setCorporateenv1 = function(value) {
  jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional int64 CorporateEnv2 = 13;
 * @return {number}
 */
proto.xcommon.CustomerInfoResourceIDs.prototype.getCorporateenv2 = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/** @param {number} value */
proto.xcommon.CustomerInfoResourceIDs.prototype.setCorporateenv2 = function(value) {
  jspb.Message.setProto3IntField(this, 13, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.OrderInspectReasonItem.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.OrderInspectReasonItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.OrderInspectReasonItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.OrderInspectReasonItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    reasonid: jspb.Message.getFieldWithDefault(msg, 1, 0),
    reasonkey: jspb.Message.getFieldWithDefault(msg, 2, ""),
    questionid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    questionkey: jspb.Message.getFieldWithDefault(msg, 4, ""),
    reasonaction: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.OrderInspectReasonItem}
 */
proto.xcommon.OrderInspectReasonItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.OrderInspectReasonItem;
  return proto.xcommon.OrderInspectReasonItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.OrderInspectReasonItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.OrderInspectReasonItem}
 */
proto.xcommon.OrderInspectReasonItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setReasonid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setReasonkey(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setQuestionid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionkey(value);
      break;
    case 5:
      var value = /** @type {!proto.xcommon.VerifyAction} */ (reader.readEnum());
      msg.setReasonaction(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.OrderInspectReasonItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.OrderInspectReasonItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.OrderInspectReasonItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.OrderInspectReasonItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReasonid();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getReasonkey();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getQuestionid();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getQuestionkey();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getReasonaction();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
};


/**
 * optional int64 ReasonID = 1;
 * @return {number}
 */
proto.xcommon.OrderInspectReasonItem.prototype.getReasonid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.xcommon.OrderInspectReasonItem.prototype.setReasonid = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string ReasonKey = 2;
 * @return {string}
 */
proto.xcommon.OrderInspectReasonItem.prototype.getReasonkey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.OrderInspectReasonItem.prototype.setReasonkey = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 QuestionID = 3;
 * @return {number}
 */
proto.xcommon.OrderInspectReasonItem.prototype.getQuestionid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.OrderInspectReasonItem.prototype.setQuestionid = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string QuestionKey = 4;
 * @return {string}
 */
proto.xcommon.OrderInspectReasonItem.prototype.getQuestionkey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.OrderInspectReasonItem.prototype.setQuestionkey = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional VerifyAction ReasonAction = 5;
 * @return {!proto.xcommon.VerifyAction}
 */
proto.xcommon.OrderInspectReasonItem.prototype.getReasonaction = function() {
  return /** @type {!proto.xcommon.VerifyAction} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {!proto.xcommon.VerifyAction} value */
proto.xcommon.OrderInspectReasonItem.prototype.setReasonaction = function(value) {
  jspb.Message.setProto3EnumField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.CorporateCustomer.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.CorporateCustomer.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.CorporateCustomer} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CorporateCustomer.toObject = function(includeInstance, msg) {
  var f, obj = {
    accountid: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    address: jspb.Message.getFieldWithDefault(msg, 3, ""),
    businessphone: jspb.Message.getFieldWithDefault(msg, 4, ""),
    jobtitle: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.CorporateCustomer}
 */
proto.xcommon.CorporateCustomer.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.CorporateCustomer;
  return proto.xcommon.CorporateCustomer.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.CorporateCustomer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.CorporateCustomer}
 */
proto.xcommon.CorporateCustomer.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setAccountid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddress(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setBusinessphone(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobtitle(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.CorporateCustomer.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.CorporateCustomer.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.CorporateCustomer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CorporateCustomer.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAddress();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getBusinessphone();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getJobtitle();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional int64 AccountID = 1;
 * @return {string}
 */
proto.xcommon.CorporateCustomer.prototype.getAccountid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/** @param {string} value */
proto.xcommon.CorporateCustomer.prototype.setAccountid = function(value) {
  jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional string Name = 2;
 * @return {string}
 */
proto.xcommon.CorporateCustomer.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.CorporateCustomer.prototype.setName = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Address = 3;
 * @return {string}
 */
proto.xcommon.CorporateCustomer.prototype.getAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.CorporateCustomer.prototype.setAddress = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string BusinessPhone = 4;
 * @return {string}
 */
proto.xcommon.CorporateCustomer.prototype.getBusinessphone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.CorporateCustomer.prototype.setBusinessphone = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string JobTitle = 5;
 * @return {string}
 */
proto.xcommon.CorporateCustomer.prototype.getJobtitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.xcommon.CorporateCustomer.prototype.setJobtitle = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.File.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.File.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.File} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.File.toObject = function(includeInstance, msg) {
  var f, obj = {
    filename: jspb.Message.getFieldWithDefault(msg, 1, ""),
    contenttype: jspb.Message.getFieldWithDefault(msg, 2, ""),
    exten: jspb.Message.getFieldWithDefault(msg, 3, ""),
    data: msg.getData_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.File}
 */
proto.xcommon.File.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.File;
  return proto.xcommon.File.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.File} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.File}
 */
proto.xcommon.File.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilename(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setContenttype(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setExten(value);
      break;
    case 4:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.File.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.File.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.File} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.File.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFilename();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getContenttype();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getExten();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getData_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      4,
      f
    );
  }
};


/**
 * optional string FileName = 1;
 * @return {string}
 */
proto.xcommon.File.prototype.getFilename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.xcommon.File.prototype.setFilename = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string ContentType = 2;
 * @return {string}
 */
proto.xcommon.File.prototype.getContenttype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.File.prototype.setContenttype = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Exten = 3;
 * @return {string}
 */
proto.xcommon.File.prototype.getExten = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.File.prototype.setExten = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bytes Data = 4;
 * @return {!(string|Uint8Array)}
 */
proto.xcommon.File.prototype.getData = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * optional bytes Data = 4;
 * This is a type-conversion wrapper around `getData()`
 * @return {string}
 */
proto.xcommon.File.prototype.getData_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getData()));
};


/**
 * optional bytes Data = 4;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getData()`
 * @return {!Uint8Array}
 */
proto.xcommon.File.prototype.getData_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getData()));
};


/** @param {!(string|Uint8Array)} value */
proto.xcommon.File.prototype.setData = function(value) {
  jspb.Message.setProto3BytesField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.OrderRepayDetail.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.OrderRepayDetail.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.OrderRepayDetail} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.OrderRepayDetail.toObject = function(includeInstance, msg) {
  var f, obj = {
    orderid: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    ticketid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    name: jspb.Message.getFieldWithDefault(msg, 3, ""),
    employeeid: jspb.Message.getFieldWithDefault(msg, 4, ""),
    repayamount: jspb.Message.getFieldWithDefault(msg, 5, 0),
    repaytime: jspb.Message.getFieldWithDefault(msg, 6, 0),
    notifytime: jspb.Message.getFieldWithDefault(msg, 7, 0),
    ctime: jspb.Message.getFieldWithDefault(msg, 8, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.OrderRepayDetail}
 */
proto.xcommon.OrderRepayDetail.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.OrderRepayDetail;
  return proto.xcommon.OrderRepayDetail.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.OrderRepayDetail} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.OrderRepayDetail}
 */
proto.xcommon.OrderRepayDetail.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readInt64String());
      msg.setOrderid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTicketid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmployeeid(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRepayamount(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRepaytime(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNotifytime(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCtime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.OrderRepayDetail.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.OrderRepayDetail.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.OrderRepayDetail} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.OrderRepayDetail.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeInt64String(
      1,
      f
    );
  }
  f = message.getTicketid();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getEmployeeid();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getRepayamount();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getRepaytime();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getNotifytime();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getCtime();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
};


/**
 * optional int64 OrderId = 1;
 * @return {string}
 */
proto.xcommon.OrderRepayDetail.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/** @param {string} value */
proto.xcommon.OrderRepayDetail.prototype.setOrderid = function(value) {
  jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional int64 TicketId = 2;
 * @return {number}
 */
proto.xcommon.OrderRepayDetail.prototype.getTicketid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.OrderRepayDetail.prototype.setTicketid = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string Name = 3;
 * @return {string}
 */
proto.xcommon.OrderRepayDetail.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.xcommon.OrderRepayDetail.prototype.setName = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string EmployeeId = 4;
 * @return {string}
 */
proto.xcommon.OrderRepayDetail.prototype.getEmployeeid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.OrderRepayDetail.prototype.setEmployeeid = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int64 RepayAmount = 5;
 * @return {number}
 */
proto.xcommon.OrderRepayDetail.prototype.getRepayamount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.xcommon.OrderRepayDetail.prototype.setRepayamount = function(value) {
  jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 RepayTime = 6;
 * @return {number}
 */
proto.xcommon.OrderRepayDetail.prototype.getRepaytime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.xcommon.OrderRepayDetail.prototype.setRepaytime = function(value) {
  jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 NotifyTime = 7;
 * @return {number}
 */
proto.xcommon.OrderRepayDetail.prototype.getNotifytime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.xcommon.OrderRepayDetail.prototype.setNotifytime = function(value) {
  jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int64 Ctime = 8;
 * @return {number}
 */
proto.xcommon.OrderRepayDetail.prototype.getCtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/** @param {number} value */
proto.xcommon.OrderRepayDetail.prototype.setCtime = function(value) {
  jspb.Message.setProto3IntField(this, 8, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.SuggestInfo.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SuggestInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SuggestInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SuggestInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SuggestInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    suggestitemList: jspb.Message.toObjectList(msg.getSuggestitemList(),
    xcommon_common_pb.WebPageItem.toObject, includeInstance),
    appname: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SuggestInfo}
 */
proto.xcommon.SuggestInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SuggestInfo;
  return proto.xcommon.SuggestInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SuggestInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SuggestInfo}
 */
proto.xcommon.SuggestInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new xcommon_common_pb.WebPageItem;
      reader.readMessage(value,xcommon_common_pb.WebPageItem.deserializeBinaryFromReader);
      msg.addSuggestitem(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SuggestInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SuggestInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SuggestInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SuggestInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuggestitemList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      xcommon_common_pb.WebPageItem.serializeBinaryToWriter
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * repeated WebPageItem SuggestItem = 1;
 * @return {!Array<!proto.xcommon.WebPageItem>}
 */
proto.xcommon.SuggestInfo.prototype.getSuggestitemList = function() {
  return /** @type{!Array<!proto.xcommon.WebPageItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, xcommon_common_pb.WebPageItem, 1));
};


/** @param {!Array<!proto.xcommon.WebPageItem>} value */
proto.xcommon.SuggestInfo.prototype.setSuggestitemList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.xcommon.WebPageItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.WebPageItem}
 */
proto.xcommon.SuggestInfo.prototype.addSuggestitem = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.xcommon.WebPageItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.SuggestInfo.prototype.clearSuggestitemList = function() {
  this.setSuggestitemList([]);
};


/**
 * optional string AppName = 2;
 * @return {string}
 */
proto.xcommon.SuggestInfo.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.SuggestInfo.prototype.setAppname = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.CallLog.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.CallLog.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.CallLog} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CallLog.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    mobile: jspb.Message.getFieldWithDefault(msg, 2, ""),
    callcount: jspb.Message.getFieldWithDefault(msg, 3, 0),
    lastcalltime: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.CallLog}
 */
proto.xcommon.CallLog.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.CallLog;
  return proto.xcommon.CallLog.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.CallLog} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.CallLog}
 */
proto.xcommon.CallLog.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMobile(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCallcount(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLastcalltime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.CallLog.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.CallLog.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.CallLog} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.CallLog.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMobile();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCallcount();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getLastcalltime();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * optional string Name = 1;
 * @return {string}
 */
proto.xcommon.CallLog.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.xcommon.CallLog.prototype.setName = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Mobile = 2;
 * @return {string}
 */
proto.xcommon.CallLog.prototype.getMobile = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.xcommon.CallLog.prototype.setMobile = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 CallCount = 3;
 * @return {number}
 */
proto.xcommon.CallLog.prototype.getCallcount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.CallLog.prototype.setCallcount = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 LastCallTime = 4;
 * @return {number}
 */
proto.xcommon.CallLog.prototype.getLastcalltime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.xcommon.CallLog.prototype.setLastcalltime = function(value) {
  jspb.Message.setProto3IntField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.xcommon.SmsLog.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SmsLog.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SmsLog.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SmsLog} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SmsLog.toObject = function(includeInstance, msg) {
  var f, obj = {
    mobile: jspb.Message.getFieldWithDefault(msg, 1, ""),
    count: jspb.Message.getFieldWithDefault(msg, 2, 0),
    type: jspb.Message.getFieldWithDefault(msg, 3, 0),
    smsdataList: jspb.Message.toObjectList(msg.getSmsdataList(),
    proto.xcommon.SmsLogData.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SmsLog}
 */
proto.xcommon.SmsLog.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SmsLog;
  return proto.xcommon.SmsLog.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SmsLog} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SmsLog}
 */
proto.xcommon.SmsLog.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMobile(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCount(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setType(value);
      break;
    case 4:
      var value = new proto.xcommon.SmsLogData;
      reader.readMessage(value,proto.xcommon.SmsLogData.deserializeBinaryFromReader);
      msg.addSmsdata(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SmsLog.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SmsLog.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SmsLog} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SmsLog.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMobile();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCount();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getType();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getSmsdataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.xcommon.SmsLogData.serializeBinaryToWriter
    );
  }
};


/**
 * optional string Mobile = 1;
 * @return {string}
 */
proto.xcommon.SmsLog.prototype.getMobile = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.xcommon.SmsLog.prototype.setMobile = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 Count = 2;
 * @return {number}
 */
proto.xcommon.SmsLog.prototype.getCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.SmsLog.prototype.setCount = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 Type = 3;
 * @return {number}
 */
proto.xcommon.SmsLog.prototype.getType = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.SmsLog.prototype.setType = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * repeated SmsLogData SmsData = 4;
 * @return {!Array<!proto.xcommon.SmsLogData>}
 */
proto.xcommon.SmsLog.prototype.getSmsdataList = function() {
  return /** @type{!Array<!proto.xcommon.SmsLogData>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.xcommon.SmsLogData, 4));
};


/** @param {!Array<!proto.xcommon.SmsLogData>} value */
proto.xcommon.SmsLog.prototype.setSmsdataList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.xcommon.SmsLogData=} opt_value
 * @param {number=} opt_index
 * @return {!proto.xcommon.SmsLogData}
 */
proto.xcommon.SmsLog.prototype.addSmsdata = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.xcommon.SmsLogData, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 */
proto.xcommon.SmsLog.prototype.clearSmsdataList = function() {
  this.setSmsdataList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.xcommon.SmsLogData.prototype.toObject = function(opt_includeInstance) {
  return proto.xcommon.SmsLogData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.xcommon.SmsLogData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SmsLogData.toObject = function(includeInstance, msg) {
  var f, obj = {
    mobile: jspb.Message.getFieldWithDefault(msg, 1, ""),
    type: jspb.Message.getFieldWithDefault(msg, 2, 0),
    time: jspb.Message.getFieldWithDefault(msg, 3, 0),
    body: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.xcommon.SmsLogData}
 */
proto.xcommon.SmsLogData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.xcommon.SmsLogData;
  return proto.xcommon.SmsLogData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.xcommon.SmsLogData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.xcommon.SmsLogData}
 */
proto.xcommon.SmsLogData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMobile(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setType(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTime(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setBody(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.xcommon.SmsLogData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.xcommon.SmsLogData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.xcommon.SmsLogData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.xcommon.SmsLogData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMobile();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getType();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getTime();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getBody();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string Mobile = 1;
 * @return {string}
 */
proto.xcommon.SmsLogData.prototype.getMobile = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.xcommon.SmsLogData.prototype.setMobile = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 Type = 2;
 * @return {number}
 */
proto.xcommon.SmsLogData.prototype.getType = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.xcommon.SmsLogData.prototype.setType = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 Time = 3;
 * @return {number}
 */
proto.xcommon.SmsLogData.prototype.getTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.xcommon.SmsLogData.prototype.setTime = function(value) {
  jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string Body = 4;
 * @return {string}
 */
proto.xcommon.SmsLogData.prototype.getBody = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.xcommon.SmsLogData.prototype.setBody = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * @enum {number}
 */
proto.xcommon.RollStatus = {
  ROLL_STATUS_UNSPECIFIED: 0,
  NOT_APPLIED: 1,
  APPLYING: 2,
  INAPPLICABLE: 3
};

/**
 * @enum {number}
 */
proto.xcommon.BusinessTypeEnum = {
  BUSINESS_TYPE_UNSPECIFIED: 0,
  BUSINESS_TYPE_COMMON: 1,
  BUSINESS_TYPE_ROLL: 2,
  BUSINESS_TYPE_NEW_TO_PAY_OLD: 3,
  BUSINESS_TYPE_STAFF_LOAN: 4,
  BUSINESS_TYPE_AGRICULTURE_LOAN: 5,
  BUSINESS_TYPE_CORPORATE_LOAN: 6,
  BUSINESS_TYPE_EARLY_DELAY: 7
};

/**
 * @enum {number}
 */
proto.xcommon.CreditCardFeeReduceFlag = {
  CREDIT_CARD_FEE_REDUCE_FLAG_DISABLE: 0,
  CREDIT_CARD_FEE_REDUCE_FLAG_ENABLE: 1,
  CREDIT_CARD_FEE_REDUCE_FLAG_DONE: 2
};

/**
 * @enum {number}
 */
proto.xcommon.OrderFromPlatform = {
  OSTYPE_INVALID: 0,
  OSTYPE_ANDROID: 1,
  OSTYPE_IOS: 16
};

/**
 * @enum {number}
 */
proto.xcommon.ButtonShow = {
  BUTTONSHOWTYPE_UNDEFINED: 0,
  BUTTONSHOWTYPE_SHOW: 1,
  BUTTONSHOWTYPE_UNSHOW: 2
};

/**
 * @enum {number}
 */
proto.xcommon.URLLinkShowType = {
  URLLINKSHOWTYPE_IMAGE: 0,
  URLLINKSHOWTYPE_TEXT: 1
};

/**
 * @enum {number}
 */
proto.xcommon.OpenPayHandingFeeMethod = {
  _REVMETHOD: 0,
  RATE: 1,
  FIXEDVALUE: 2
};

/**
 * @enum {number}
 */
proto.xcommon.MarketPaymentType = {
  MARKETPAYMENTTYPE_UNSPECIFIED: 0,
  MARKETPAYMENTTYPE_FULL: 1,
  MARKETPAYMENTTYPE_PARTIAL: 2
};

/**
 * @enum {number}
 */
proto.xcommon.MarketPaymentChannel = {
  MARKETPAYMENTCHANNEL_UNSPECIFIED: 0,
  MARKETPAYMENTCHANNEL_OXXO: 1,
  MARKETPAYMENTCHANNEL_PAYNET: 2,
  MARKETPAYMENTCHANNEL_EFECTY: 7,
  MARKETPAYMENTCHANNEL_BALOTO: 8,
  MARKETPAYMENTCHANNEL_BANCOLOMBIA: 9
};

/**
 * @enum {number}
 */
proto.xcommon.MarketPaymentStatus = {
  MARKETPAYMENTSTATUS_UNSPECIFIED: 0,
  MARKETPAYMENTSTATUS_CREATED: 1,
  MARKETPAYMENTSTATUS_USED: 2,
  MARKETPAYMENTSTATUS_EXPIRED: 3
};

/**
 * @enum {number}
 */
proto.xcommon.CalcMarketPaymentFeeVersion = {
  CALCMARKETPAYMENTFEEVERSION_V0: 0,
  CALCMARKETPAYMENTFEEVERSION_V1: 1
};

/**
 * @enum {number}
 */
proto.xcommon.RepayTypeEnum = {
  RT_UNSPECIFIED: 0,
  RT_REPAY: 1,
  RT_ROLL: 2,
  RT_COUPON: 3,
  RT_REDUCE: 4,
  RT_REVOLVE: 5
};

/**
 * @enum {number}
 */
proto.xcommon.MPSystemType = {
  MPSYSTEMTYPECOLLECTION: 0,
  MPSYSTEMTYPEVERIFY: 1,
  MPSYSTEMTYPEPHONESALE: 2,
  MPSYSTEMTYPEALL: 100
};

/**
 * @enum {number}
 */
proto.xcommon.AutoCallSupplier = {
  AUTOCALLSUPPLIER_UNSPECIFIED: 0,
  AUTOCALLSUPPLIER_NXTELE: 1,
  AUTOCALLSUPPLIER_INFINITY: 2,
  AUTOCALLSUPPLIER_STI: 3
};

/**
 * @enum {number}
 */
proto.xcommon.ContactStatusEnum = {
  CONTACT_STATUS_UNSPECIFIED: 0,
  CONTACT_STATUS_PASS: 1,
  CONTACT_STATUS_REJECT: 2
};

module.exports = proto.xcommon;
